import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import {CommonModule}
    from '@angular/common';
// @ts-ignore
import {
    Component, ElementRef, EventEmitter,
    HostListener, Output, signal
}
    from '@angular/core';
// @ts-ignore
import {FormsModule}
    from '@angular/forms';
// @ts-ignore
import {LucideAngularModule, ZoomIn, ZoomOut}
    from 'lucide-angular';
// @ts-ignore
import {
    DemonstrativoAlteracaoClientePrefixoResponse,
    DemonstrativoAtualizacaoResponse,
    DemonstrativoCliente,
    DemonstrativoCotacao,
    DemonstrativoCotacoesResponse,
    DemonstrativoDados,
    DemonstrativoPrefixo,
    DemonstrativoPrefixosResponse,
    DemonstrativoAlteracaoFormaPagamentoResponse,
    DemonstrativoAjusteNativoItem,
    DemonstrativoFinalizacaoVendaResponse,
    DemonstrativoAjustesNativosResponse,
    DemonstrativoAjusteItemNativo,
    DemonstrativoCalculoAjusteNativoResponse,
    DemonstrativoSalvarAjustesNativosResponse,
    SankhyaEnvelope,
    SankhyaGatewayService
} from '../../services/sankhya-gateway.service';
import {firstValueFrom, forkJoin} from 'rxjs';
import {ajustarValorExato, ResultadoAjusteExato} from './ajuste-valor-exato';

declare const html2pdf: any;

type DemonstrativoResumoAlteracaoCliente = {
    nunota?: string | number;
    nunotaFormatado?: string;
    valorVenda?: string | number;
    status?: string;
    codparc?: string | number;
    nomeparc?: string;
    cnpj?: string;
    codaero?: string | number;
    prefixo?: string;
    enderecoEntrega?: string;
    sucesso?: boolean;
    erro?: string;
};

// @ts-ignore
@Component({
    selector: 'app-demonstrativo-vendas',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, FormsModule, LucideAngularModule],
    templateUrl: './demonstrativo-vendas.component.html',
    styleUrl: './demonstrativo-vendas.component.css'
})
export class DemonstrativoVendasComponent {
    readonly ZoomIn = ZoomIn;
    readonly ZoomOut = ZoomOut;

    @Output() activeViewChange = new EventEmitter<'gpl-venda-impressao'>();

    demonstrativoLoading
        = signal(false);
    demonstrativoStatus
        = signal('Informe um cliente para buscar o demonstrativo.');
    demonstrativoRawResponse
        = signal('');
    demonstrativoClientes
        = signal<DemonstrativoCliente[]>([]);
    demonstrativoDados
        = signal<DemonstrativoDados | null>(null);
    demonstrativoItens
        = signal<Array<Record<string, unknown>>>([]);
    demonstrativoBuscaSemDados
        = false;
    demonstrativoItensOriginais: Array<Record<string, unknown>>
        = [];
    demonstrativoContas: Array<Record<string, unknown>>
        = [];
    demonstrativoCodigosDisponiveis: string[]
        = [];
    demonstrativoPrefixosDisponiveis: string[]
        = [];
    demonstrativoEmpresasDisponiveis: string[]
        = [];
    demonstrativoStatusDisponiveis: string[]
        = [];
    demonstrativoCodigosSelecionados: string[]
        = [];
    demonstrativoPrefixosSelecionados: string[]
        = [];
    demonstrativoEmpresasSelecionadas: string[]
        = [];
    demonstrativoStatusSelecionados: string[]
        = [];
    demonstrativoCotacoes: DemonstrativoCotacao[]
        = [];
    demonstrativoCotacaoSelecionada: DemonstrativoCotacao | null
        = null;
    demonstrativoFiltroCotacao
        = '';
    demonstrativoModalCotacoes
        = false;
    demonstrativoPrefixosAlteracao: DemonstrativoPrefixo[]
        = [];
    demonstrativoPrefixoSelecionadoAlteracao: DemonstrativoPrefixo | null
        = null;
    demonstrativoFiltroPrefixoAlteracao
        = '';
    demonstrativoModalPrefixos
        = false;
    demonstrativoModalAlerta
        = false;
    demonstrativoModalAlertaTexto
        = '';
    demonstrativoModalAlertaBotao
        = 'OK';
    demonstrativoModalFinalizar
        = false;
    demonstrativoModalConfirmacao
        = false;
    demonstrativoConfirmacao
        = {
        mensagem: '',
        textoOk: 'Confirmar',
        textoCancelar: 'Cancelar',
        callbackOk: null as null | (() => void)
    };
    demonstrativoModalAjusteNotas = false;
    demonstrativoModalAjusteNotaIndividual = false;
    demonstrativoCalculandoAjusteNativo = false;
    demonstrativoAjuste = {
        tipo: 'DES' as 'DES' | 'ACR',
        percentual: '',
        valor: ''
    };
    demonstrativoItensAjuste: Array<Record<string, any>>
        = [];
    demonstrativoNotaAjuste: Record<string, any> | null
        = null;
    demonstrativoItensNotaAjuste: Array<Record<string, any>>
        = [];
    demonstrativoAjusteTotalNovoValor
        = '0,00';
    demonstrativoAjusteTotalIpi
        = '0,00';
    demonstrativoAjusteTotalSt
        = '0,00';
    demonstrativoAjusteTotalNota
        = '0,00';
    demonstrativoAjusteTotalFaturadoDesejado
        = '0,00';
    demonstrativoTotalNotaOriginal
        = '0,00';
    demonstrativoTotalNotaNovoValor
        = '0,00';
    demonstrativoLimiteDescontoVendedor
        = '0,00';
    demonstrativoModalConfirmacaoCotacao
        = false;
    demonstrativoConfirmacaoCotacao: {
        cotacao: number; notas: Array<Record<string, any>>
    } = {cotacao: 0, notas: []};
    demonstrativoModalLiberacaoLimite
        = false;
    demonstrativoLiberacaoLimite: Record<string, any>
        = {};
    demonstrativoItensPendentesLiberacao: Array<Record<string, unknown>>
        = [];
    demonstrativoCallbackLiberacaoSucesso: null | (()
        => void) = null;
    demonstrativoModalTipoNegociacaoResumo
        = false;
    demonstrativoModalTipoNegociacao
        = false;
    demonstrativoVendasTipoNegociacao:
        Array<Record<string, any>>
        = [];
    demonstrativoTiposVenda:
        Array<Record<string, any>>
        = [];
    demonstrativoTipoVendaSelecionado:
        Record<string, any> | null
        = null;
    demonstrativoFiltroTipoVenda
        = '';
    demonstrativoModalAlterarCliente
        = false;
    demonstrativoAlterarClienteNotas: DemonstrativoResumoAlteracaoCliente[]
        = [];
    demonstrativoAlterarClienteFiltro
        = '';
    demonstrativoAlterarClienteClientes: DemonstrativoCliente[]
        = [];
    demonstrativoAlterarClienteDropdownAberto
        = false;
    demonstrativoAlterarClienteClienteSelecionado: DemonstrativoCliente | null
        = null;
    demonstrativoAlterarClienteEnderecos: DemonstrativoCliente[]
        = [];
    demonstrativoAlterarClienteEnderecoSelecionado: DemonstrativoCliente | null
        = null;
    demonstrativoAlterarClienteEndereco: Record<string, unknown> | null
        = null;
    demonstrativoAlterarClientePrefixos: DemonstrativoPrefixo[]
        = [];
    demonstrativoAlterarClientePrefixoSelecionado: DemonstrativoPrefixo | null
        = null;
    demonstrativoAlterarClientePrefixosPorNota: Record<string, DemonstrativoPrefixo | null>
        = {};
    demonstrativoAlterarClienteFiltroPrefixo
        = '';
    demonstrativoAlterarClienteStatus
        = '';
    demonstrativoAlterarClientePasso: 1 | 2 | 3 = 1;
    demonstrativoFiltroCliente
        = '';
    demonstrativoCodparc
        = '';
    demonstrativoCodparcs: string[] = [];
    demonstrativoCodparcsComVendas: string[] = [];
    demonstrativoModalFiltroEndereco = false;
    demonstrativoEnderecosFiltro: DemonstrativoCliente[] = [];
    demonstrativoEnderecosFiltroAplicados: string[] = [];
    demonstrativoEnderecosFiltroPendentes: string[] = [];
    demonstrativoEnderecosFiltroCarregando = false;
    demonstrativoTipoBusca: 'CLIENTE' | 'VENDEDOR' | 'PREFIXO'
        = 'CLIENTE';
    demonstrativoPrefixoBuscaSelecionado
        = '';
    demonstrativoDropdownClientesAberto
        = false;
    demonstrativoDataInicial
        = this.toInputDate(
        new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1));
    demonstrativoDataFinal
        = this.toInputDate(
        new Date());
    demonstrativoTipoMoeda: 'DOLAR' | 'REAL'
        = 'REAL';
    mostrarRetornoDemonstrativo
        = false;
    demonstrativoAbrirMenu
        = false;
    demonstrativoAbrirPrefixos
        = false;
    demonstrativoAbrirEmpresas
        = false;
    demonstrativoAbrirCodigos
        = false;
    demonstrativoSelecionarTodos
        = false;
    demonstrativoZoomAtual
        = 1.1;
    demonstrativoWhatsappNumero
        = '';
    demonstrativoValorPixQrCode
        = '0,00';
    demonstrativoImprimirCotacao
        = true;
    demonstrativoModalImpressao
        = false;
    demonstrativoTipoImpressao: 'DEMONSTRATIVO' | 'AMBOS' | 'ORCAMENTO'
        = 'DEMONSTRATIVO';
    ordemOrdAsc
        = true;
    ordemEmpAsc
        = true;
    ordemPrefixoAsc
        = true;
    ordemEmissaoAsc
        = true;
    ordemStatusAsc
        = true;

    private demonstrativoBuscaClienteTimer:
        ReturnType<typeof setTimeout> | null = null;
    private demonstrativoAlterarClienteBuscaTimer:
        ReturnType<typeof setTimeout> | null = null;
    private qrCodePixRequestSeq
        = 0;
    private readonly estadoRetornoImpressaoKey
        = 'param_demonstrativo_vendas_estado_retorno';
    private readonly navegacaoVendaImpressaoKey
        = 'param_venda_impressao_navegacao';

    constructor(
        private readonly sankhyaGateway: SankhyaGatewayService,
        private readonly elementRef: ElementRef<HTMLElement>
    ) {
        this.restaurarEstadoRetornoImpressao();
    }

    @HostListener('document:keydown', ['$event'])
    onDocumentKeydown(event: KeyboardEvent): void {
        if (!this.algumModalDemonstrativoAberto()) {
            return;
        }

        if (event.key === 'Tab') {
            this.travarFocoNoModal(event);
            return;
        }

        if ((event.key === 'Enter' || event.key === ' ') &&
            this.focoForaDoModalAtivo()) {
            event.preventDefault();
            this.focarPrimeiroElementoDoModal();
        }
    }

    @HostListener('document:focusin', ['$event'])
    onDocumentFocusIn(event: FocusEvent): void {
        if (!this.algumModalDemonstrativoAberto()) {
            return;
        }

        const modal = this.modalDemonstrativoAtivo();
        const alvo = event.target as HTMLElement | null;

        if (modal && alvo && !modal.contains(alvo)) {
            this.focarPrimeiroElementoDoModal();
        }
    }

    private algumModalDemonstrativoAberto(): boolean {
        return this.demonstrativoModalCotacoes ||
            this.demonstrativoModalPrefixos ||
            this.demonstrativoModalAlerta ||
            this.demonstrativoModalFinalizar ||
            this.demonstrativoModalConfirmacao ||
            this.demonstrativoModalAjusteNotas ||
            this.demonstrativoModalAjusteNotaIndividual ||
            this.demonstrativoModalConfirmacaoCotacao ||
            this.demonstrativoModalLiberacaoLimite ||
            this.demonstrativoModalTipoNegociacaoResumo ||
            this.demonstrativoModalTipoNegociacao ||
            this.demonstrativoModalAlterarCliente ||
            this.demonstrativoModalImpressao;
    }

    private travarFocoNoModal(event: KeyboardEvent): void {
        const modal = this.modalDemonstrativoAtivo();

        if (!modal) {
            event.preventDefault();
            return;
        }

        const focaveis = this.elementosFocaveis(modal);

        if (!focaveis.length) {
            event.preventDefault();
            this.focarPrimeiroElementoDoModal();
            return;
        }

        const ativo = document.activeElement as HTMLElement | null;
        const primeiro = focaveis[0];
        const ultimo = focaveis[focaveis.length - 1];

        if (!ativo || !modal.contains(ativo)) {
            event.preventDefault();
            primeiro.focus();
            return;
        }

        if (event.shiftKey && ativo === primeiro) {
            event.preventDefault();
            ultimo.focus();
            return;
        }

        if (!event.shiftKey && ativo === ultimo) {
            event.preventDefault();
            primeiro.focus();
        }
    }

    private focoForaDoModalAtivo(): boolean {
        const modal = this.modalDemonstrativoAtivo();
        const ativo = document.activeElement as HTMLElement | null;

        return !!(modal && ativo && !modal.contains(ativo));
    }

    private focarPrimeiroElementoDoModal(): void {
        const modal = this.modalDemonstrativoAtivo();

        if (!modal) {
            return;
        }

        const primeiro = this.elementosFocaveis(modal)[0];

        if (primeiro) {
            primeiro.focus();
            return;
        }

        modal.tabIndex = -1;
        modal.focus();
    }

    private modalDemonstrativoAtivo(): HTMLElement | null {
        const modais = Array.from(
            this.elementRef.nativeElement.querySelectorAll<HTMLElement>(
                '.cotacao-overlay .cotacao-modal, .cotacao-overlay .alterar-cliente-modal, .snk-modal-overlay .snk-modal'
            )
        ).filter((modal) => this.elementoVisivel(modal));

        return modais.length ? modais[modais.length - 1] : null;
    }

    private elementosFocaveis(container: HTMLElement): HTMLElement[] {
        return Array.from(
            container.querySelectorAll<HTMLElement>(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )
        ).filter((elemento) =>
            this.elementoVisivel(elemento) &&
            !elemento.hasAttribute('disabled') &&
            elemento.getAttribute('aria-hidden') !== 'true'
        );
    }

    private elementoVisivel(elemento: HTMLElement): boolean {
        return !!(elemento.offsetWidth ||
            elemento.offsetHeight ||
            elemento.getClientRects().length);
    }

    agendarBuscaClientesDemonstrativo(): void {
        if (this.demonstrativoBuscaClienteTimer) {
            clearTimeout(this.demonstrativoBuscaClienteTimer);
        }

        this.demonstrativoCodparc = '';
        this.demonstrativoCodparcs = [];
        this.demonstrativoPrefixoBuscaSelecionado = '';

        if (this.demonstrativoFiltroCliente.trim().length < 2) {
            this.demonstrativoClientes.set([]);
            this.demonstrativoDropdownClientesAberto = false;
            this.demonstrativoStatus.set(`Digite ao menos 2 caracteres para buscar ${this.demonstrativoBuscaArtigo()}.`);
            return;
        }

        this.demonstrativoBuscaClienteTimer = setTimeout(() =>
            this.buscarClientesDemonstrativo(), 250);
    }

    buscarClientesDemonstrativo(): void {
        const filtro = this.demonstrativoFiltroCliente.trim();

        this.demonstrativoCodparc = '';
        this.demonstrativoCodparcs = [];
        this.demonstrativoPrefixoBuscaSelecionado = '';

        if (filtro.length < 2) {
            this.demonstrativoStatus.set(
                `Digite ao menos 2 caracteres para buscar ${this.demonstrativoBuscaArtigo()}.`
            );
            this.demonstrativoClientes.set([]);
            this.demonstrativoDropdownClientesAberto = false;
            return;
        }

        this.demonstrativoDropdownClientesAberto = true;

        this.demonstrativoStatus.set(
            this.demonstrativoTipoBusca === 'VENDEDOR'
                ? 'Buscando vendedores...'
                : this.demonstrativoTipoBusca === 'PREFIXO'
                    ? 'Buscando prefixos...'
                    : 'Buscando clientes...'
        );

        if (this.demonstrativoTipoBusca === 'PREFIXO') {
            this.sankhyaGateway
                .buscarPrefixosGlobalDemonstrativo(filtro)
                .subscribe({
                    next: (value: any) => {
                        const body = value?.responseBody || value;

                        const lista =
                            this.normalizarPrefixosBuscaDemonstrativo(
                                body?.prefixos || [],
                                filtro
                            );

                        this.demonstrativoRawResponse.set(
                            JSON.stringify(value, null, 2)
                        );

                        this.demonstrativoClientes.set(lista);

                        this.demonstrativoStatus.set(
                            lista.length
                                ? `${lista.length} prefixo(s) encontrado(s).`
                                : 'Nenhum prefixo encontrado.'
                        );
                    },
                    error: (error: any) => {
                        this.demonstrativoClientes.set([]);

                        this.demonstrativoRawResponse.set(
                            JSON.stringify(error, null, 2)
                        );

                        this.demonstrativoStatus.set(
                            this.erroMensagem(
                                error,
                                'Erro ao buscar prefixos no gateway.'
                            )
                        );
                    }
                });

            return;
        }

        /*
         * BUSCA POR VENDEDOR
         */
        if (this.demonstrativoTipoBusca === 'VENDEDOR') {
            this.sankhyaGateway
                .chamarServiceGpl(
                    'VendedorGlobalSP.doBuscarVendedores',
                    {}
                )
                .subscribe({
                    next: (value: any) => {
                        const body = value?.responseBody || value;

                        const lista =
                            this.normalizarVendedoresDemonstrativo(
                                body?.vendedores || [],
                                filtro
                            );

                        this.demonstrativoRawResponse.set(
                            JSON.stringify(value, null, 2)
                        );

                        this.demonstrativoClientes.set(lista);

                        this.demonstrativoStatus.set(
                            lista.length
                                ? `${lista.length} vendedor(es) encontrado(s).`
                                : 'Nenhum vendedor encontrado.'
                        );
                    },
                    error: (error: any) => {
                        this.demonstrativoClientes.set([]);

                        this.demonstrativoRawResponse.set(
                            JSON.stringify(error, null, 2)
                        );

                        this.demonstrativoStatus.set(
                            this.erroMensagem(
                                error,
                                'Erro ao buscar vendedores no gateway.'
                            )
                        );
                    }
                });

            return;
        }

        /*
         * BUSCA POR CLIENTE
         *
         * Pesquisa nativa do Sankhya:
         * PesquisaSP.getSuggestion.
         */
        this.sankhyaGateway
            .buscarClientesNativo(filtro)
            .subscribe({
                next: (value: any) => {
                    this.demonstrativoRawResponse.set(
                        JSON.stringify(value, null, 2)
                    );

                    if (!value) {
                        this.demonstrativoClientes.set([]);

                        this.demonstrativoStatus.set(
                            'Resposta vazia do gateway. Tente novamente.'
                        );

                        return;
                    }

                    if (value.status && value.status !== '1') {
                        this.demonstrativoClientes.set([]);

                        this.demonstrativoStatus.set(
                            value.statusMessage ||
                            'A pesquisa nativa de clientes não retornou sucesso.'
                        );

                        return;
                    }

                    const dadosNativos =
                        this.extrairDadosPesquisaNativaCliente(value);

                    const lista =
                        this.normalizarClientesDemonstrativo(dadosNativos);

                    this.demonstrativoClientes.set(lista);

                    this.demonstrativoStatus.set(
                        lista.length
                            ? `${lista.length} cliente(s) encontrado(s).`
                            : 'Nenhum cliente encontrado.'
                    );
                },
                error: (error: any) => {
                    this.demonstrativoClientes.set([]);

                    this.demonstrativoRawResponse.set(
                        JSON.stringify(error, null, 2)
                    );

                    this.demonstrativoStatus.set(
                        this.erroMensagem(
                            error,
                            'Erro ao buscar clientes no gateway.'
                        )
                    );
                }
            });
    }

    selecionarCliente(cliente: DemonstrativoCliente): void {
        this.limparFiltroEnderecoDemonstrativo();

        if (this.demonstrativoTipoBusca === 'PREFIXO') {
            this.demonstrativoCodparc = String(cliente.codaero || '');
            this.demonstrativoCodparcs = [];
            this.demonstrativoPrefixoBuscaSelecionado = String(cliente.prefixo || '');
        } else if (this.demonstrativoTipoBusca === 'VENDEDOR') {
            this.demonstrativoCodparc = String(cliente.codparc || '');
            this.demonstrativoCodparcs = [];
            this.demonstrativoPrefixoBuscaSelecionado = '';
        } else {
            const codparcs = Array.isArray(cliente.codparcs) && cliente.codparcs.length
                ? cliente.codparcs
                : [cliente.codparc];

            this.demonstrativoCodparcs = codparcs
                .map((codparc) => String(codparc || '').trim())
                .filter((codparc) => codparc !== '');

            /*
             * Mantido temporariamente para a busca atual, que ainda recebe
             * apenas um CODPARC. Na próxima etapa, buscarDadosDemonstrativo()
             * percorrerá demonstrativoCodparcs.
             */
            this.demonstrativoCodparc =
                this.demonstrativoCodparcs[0] || '';

            this.demonstrativoPrefixoBuscaSelecionado = '';
        }

        this.demonstrativoFiltroCliente =
            this.labelClienteDemonstrativo(cliente);

        this.demonstrativoClientes.set([]);
        this.demonstrativoDropdownClientesAberto = false;

        this.buscarDadosDemonstrativo();
    }

    mostrarFiltroEnderecoDemonstrativo(): boolean {
        return this.demonstrativoTipoBusca === 'CLIENTE' &&
            this.demonstrativoCodparcsComVendas.length > 1;
    }

    abrirFiltroEnderecoDemonstrativo(event?: Event): void {
        event?.stopPropagation();

        if (!this.mostrarFiltroEnderecoDemonstrativo()) {
            return;
        }

        this.demonstrativoEnderecosFiltroPendentes =
            [...this.demonstrativoEnderecosFiltroAplicados];
        this.demonstrativoModalFiltroEndereco = true;

        if (!this.demonstrativoEnderecosFiltro.length) {
            this.carregarEnderecosFiltroDemonstrativo();
        }
    }

    fecharFiltroEnderecoDemonstrativo(): void {
        this.demonstrativoModalFiltroEndereco = false;
        this.demonstrativoEnderecosFiltroPendentes =
            [...this.demonstrativoEnderecosFiltroAplicados];
    }

    selecionarEnderecoFiltroDemonstrativo(
        codparc: string | number | undefined
    ): void {
        if (codparc === undefined) {
            return;
        }

        const codigo = String(codparc);

        if (codigo === 'TODOS') {
            this.demonstrativoEnderecosFiltroPendentes = [];
            return;
        }

        this.demonstrativoEnderecosFiltroPendentes =
            this.demonstrativoEnderecosFiltroPendentes.includes(codigo)
                ? this.demonstrativoEnderecosFiltroPendentes.filter(
                    (selecionado) => selecionado !== codigo
                )
                : [...this.demonstrativoEnderecosFiltroPendentes, codigo];
    }

    aplicarFiltroEnderecoDemonstrativo(): void {
        this.demonstrativoEnderecosFiltroAplicados =
            [...this.demonstrativoEnderecosFiltroPendentes];
        this.demonstrativoModalFiltroEndereco = false;
        this.aplicarFiltrosDemonstrativo();
    }

    enderecoFiltroDemonstrativoTexto(cliente: DemonstrativoCliente): string {
        const logradouro = [cliente.endereco, cliente.numero]
            .filter(Boolean)
            .join(', ');
        const localidade = [cliente.bairro, cliente.cidade, cliente.uf]
            .filter(Boolean)
            .join(' - ');

        return [
            logradouro,
            cliente.complemento,
            localidade,
            cliente.cep ? `CEP ${cliente.cep}` : ''
        ]
            .filter(Boolean)
            .join(' | ') ||
            `Endereco nao cadastrado para o parceiro ${cliente.codparc}`;
    }

    private carregarEnderecosFiltroDemonstrativo(): void {
        const codparcs = [...this.demonstrativoCodparcsComVendas];

        if (!codparcs.length) {
            return;
        }

        this.demonstrativoEnderecosFiltroCarregando = true;

        const requisicoes = codparcs.map(
            (codparc) =>
                this.sankhyaGateway.buscarDadosParceiroNativo(codparc)
        );

        forkJoin(requisicoes).subscribe({
            next: (respostas: unknown[]) => {
                const dadosParceiros: Array<Record<string, unknown>> = [];

                for (const resposta of respostas) {
                    const value = resposta as any;

                    if (!value || (value.status && value.status !== '1')) {
                        continue;
                    }

                    const body = value.responseBody || value;

                    if (
                        body?.sucesso === false ||
                        !body?.dados ||
                        typeof body.dados !== 'object'
                    ) {
                        continue;
                    }

                    dadosParceiros.push(
                        body.dados as Record<string, unknown>
                    );
                }

                const clienteBase = {
                    codparc: codparcs[0],
                    nomeparc: this.demonstrativoFiltroCliente,
                    docparc: ''
                } as DemonstrativoCliente;

                const enderecos =
                    this.normalizarEnderecosNativosAlteracao(
                        dadosParceiros,
                        clienteBase
                    );

                this.demonstrativoEnderecosFiltro = codparcs.map(
                    (codparc) =>
                        enderecos.find(
                            (endereco) =>
                                String(endereco.codparc) === String(codparc)
                        ) || ({
                            codparc,
                            nomeparc: this.demonstrativoFiltroCliente,
                            docparc: ''
                        } as DemonstrativoCliente)
                );

                this.demonstrativoEnderecosFiltroCarregando = false;
            },
            error: () => {
                this.demonstrativoEnderecosFiltro = codparcs.map(
                    (codparc) => ({
                        codparc,
                        nomeparc: this.demonstrativoFiltroCliente,
                        docparc: ''
                    } as DemonstrativoCliente)
                );
                this.demonstrativoEnderecosFiltroCarregando = false;
            }
        });
    }

    private limparFiltroEnderecoDemonstrativo(): void {
        this.demonstrativoCodparcsComVendas = [];
        this.demonstrativoEnderecosFiltro = [];
        this.demonstrativoEnderecosFiltroAplicados = [];
        this.demonstrativoEnderecosFiltroPendentes = [];
        this.demonstrativoModalFiltroEndereco = false;
        this.demonstrativoEnderecosFiltroCarregando = false;
    }

    alterarTipoBuscaDemonstrativo(tipo: 'CLIENTE' | 'VENDEDOR' | 'PREFIXO'): void {
        if (this.demonstrativoTipoBusca === tipo) {
            return;
        }

        this.demonstrativoTipoBusca = tipo;
        this.demonstrativoFiltroCliente = '';
        this.demonstrativoCodparc = '';
        this.demonstrativoCodparcs = [];
        this.limparFiltroEnderecoDemonstrativo();
        this.demonstrativoPrefixoBuscaSelecionado = '';
        this.demonstrativoClientes.set([]);
        this.demonstrativoDropdownClientesAberto = false;
        this.limparDadosTrocaTipoBuscaDemonstrativo();
        this.demonstrativoStatus.set(
            tipo === 'VENDEDOR'
                ? 'Informe um vendedor para buscar o demonstrativo.'
                : tipo === 'PREFIXO'
                    ? 'Informe um prefixo para buscar o demonstrativo.'
                    : 'Informe um cliente para buscar o demonstrativo.'
        );
    }

    demonstrativoBuscaLabel(): string {
        return this.demonstrativoTipoBusca === 'VENDEDOR'
            ? 'Vendedor:'
            : this.demonstrativoTipoBusca === 'PREFIXO'
                ? 'Prefixo:'
                : 'Cliente:';
    }

    demonstrativoBuscaPlaceholder(): string {
        return this.demonstrativoTipoBusca === 'VENDEDOR'
            ? 'VENDEDOR / COD'
            : this.demonstrativoTipoBusca === 'PREFIXO'
                ? 'PREFIXO / CLIENTE'
                : 'CLIENTE / DOC / COD';
    }

    labelClienteDemonstrativo(cliente: DemonstrativoCliente): string {
        if (cliente.tipoBusca === 'PREFIXO') {
            const proprietario = cliente.nomeparc ? ` - ${cliente.nomeparc}` : '';
            return `${cliente.prefixo || 'Prefixo nao informado'}${proprietario}`;
        }

        if (cliente.tipoBusca === 'VENDEDOR') {
            return `${cliente.nomeparc || 'Vendedor nao informado'} - CODVEND: ${cliente.codparc}`;
        }

        const doc = String(cliente.docparc || '');
        const tipoDocumento = doc.replace(/\D/g, '').length === 11 ? 'F' : 'J';
        const documento = doc ? ` - CNPJ: ${this.formatarDocumento(doc, tipoDocumento)}` : '';

        return `${cliente.nomeparc || 'Cliente nao informado'}${documento}`;
    }

    documentoClienteDemonstrativo(cliente: DemonstrativoCliente): string {
        if (cliente.tipoBusca === 'PREFIXO') {
            return cliente.nomeparc || '';
        }

        if (cliente.tipoBusca === 'VENDEDOR') {
            return `CODVEND: ${cliente.codparc}`;
        }

        const doc = String(cliente.docparc || '');
        const tipoDocumento = doc.replace(/\D/g, '').length === 11 ? 'F' : 'J';

        return doc ? this.formatarDocumento(doc, tipoDocumento) : '';
    }

    private formatarCep(cep: string): string {
        const digitos = String(cep || '').replace(/\D/g, '');
        if (digitos.length !== 8) {
            return String(cep || '');
        }

        return `${digitos.slice(0, 5)}-${digitos.slice(5)}`;
    }

    cidadeUfClienteAlteracaoTexto(cliente: DemonstrativoCliente | null): string {
        if (!cliente) {
            return '';
        }

        return [cliente.cidade || '', cliente.uf || '']
            .filter(Boolean)
            .join(' - ');
    }

    logradouroClienteAlteracaoTexto(cliente: DemonstrativoCliente | null): string {
        if (!cliente) {
            return '';
        }

        const logradouro = [
            cliente.endereco || '',
            cliente.numero || ''
        ]
            .filter(Boolean)
            .join(', ');

        return [
            logradouro,
            cliente.complemento || '',
            cliente.bairro ? `Bairro: ${cliente.bairro}` : '',
            cliente.cep ? `CEP ${cliente.cep}` : ''
        ]
            .filter(Boolean)
            .join(' - ');
    }

    enderecoClienteAlteracaoTexto(cliente: DemonstrativoCliente | null): string {
        if (!cliente) {
            return '';
        }

        const endereco = [
            cliente.endereco || '',
            cliente.numero || '',
            cliente.complemento || ''
        ].filter(Boolean).join(', ');

        const cidadeUf = [
            cliente.cidade || '',
            cliente.uf || ''
        ].filter(Boolean).join('/');

        return [
            endereco,
            cliente.bairro ? `Bairro: ${cliente.bairro}` : '',
            cidadeUf,
            cliente.cep ? `CEP ${this.formatarCep(cliente.cep)}` : ''
        ].filter(Boolean).join(' - ');
    }

    private extrairDadosPesquisaNativaCliente(
        value: any
    ): Array<Record<string, unknown>> {
        const body = value?.responseBody || value;

        /*
         * O PesquisaSP.getSuggestion retorna:
         *
         * responseBody: {
         *     json: {
         *         "$": "{...JSON em formato texto...}"
         *     }
         * }
         */
        const jsonBruto =
            body?.json?.['$'] ??
            body?.json?.$ ??
            body?.json ??
            '';

        if (!jsonBruto) {
            return [];
        }

        try {
            const resultado =
                typeof jsonBruto === 'string'
                    ? JSON.parse(jsonBruto)
                    : jsonBruto;

            return Array.isArray(resultado?.data)
                ? resultado.data
                : [];
        } catch (error) {
            console.error(
                'Erro ao interpretar retorno do PesquisaSP.getSuggestion:',
                error,
                jsonBruto
            );

            return [];
        }
    }

    private normalizarClientesDemonstrativo(
        lista: unknown
    ): DemonstrativoCliente[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        const grupos = new Map<string, DemonstrativoCliente>();

        for (const item of lista) {
            const cliente = item as Record<string, unknown>;

            const codparc =
                this.valorBusca(cliente, 'CODPARC') ||
                this.valorBusca(cliente, 'codparc');

            const nomeparc =
                this.valorBusca(cliente, 'NOMEPARC') ||
                this.valorBusca(cliente, 'RAZAOSOCIAL') ||
                this.valorBusca(cliente, 'nomeparc') ||
                this.valorBusca(cliente, 'nomeParc');

            const docparc =
                this.valorBusca(cliente, 'CGC_CPF') ||
                this.valorBusca(cliente, 'CGC') ||
                this.valorBusca(cliente, 'CNPJ') ||
                this.valorBusca(cliente, 'DOCPARC') ||
                this.valorBusca(cliente, 'docparc');

            if (!codparc || !nomeparc) {
                continue;
            }

            const documento =
                String(docparc || '').replace(/\D/g, '');

            /*
             * Agrupa pelo CPF/CNPJ.
             *
             * Todos os CODPARC encontrados para o mesmo documento
             * são armazenados em codparcs.
             */
            const chave =
                documento ||
                `CODPARC:${codparc}`;

            const existente = grupos.get(chave);

            if (existente) {
                const codigos = existente.codparcs || [];

                const jaExiste = codigos.some(
                    (codigo) =>
                        String(codigo) === String(codparc)
                );

                if (!jaExiste) {
                    codigos.push(codparc);
                }

                existente.codparcs = codigos;
                continue;
            }

            grupos.set(chave, {
                codparc,
                codparcs: [codparc],
                nomeparc,
                docparc
            });
        }

        return Array.from(grupos.values());
    }

    private normalizarClientesAlteracao(lista: unknown): DemonstrativoCliente[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        return lista
            .map((item) => {
                const cliente = item as Record<string, unknown>;
                const codparc = this.valorBusca(cliente, 'codparc') || this.valorBusca(cliente, 'CODPARC');
                const nomeparc = this.valorBusca(cliente, 'nomeparc') ||
                    this.valorBusca(cliente, 'NOMEPARC') ||
                    this.valorBusca(cliente, 'nomeParc');
                const docparc = this.valorBusca(cliente, 'docparc') ||
                    this.valorBusca(cliente, 'DOCPARC') ||
                    this.valorBusca(cliente, 'CNPJ') ||
                    this.valorBusca(cliente, 'CGC_CPF');

                if (!codparc || !nomeparc) {
                    return null;
                }

                return {
                    codparc,
                    nomeparc,
                    docparc,
                    endereco: this.valorBusca(cliente, 'ENDERECO') ||
                        this.valorBusca(cliente, 'ENDERECO_COMPLETO') ||
                        this.valorBusca(cliente, 'ENDERECOENTREGA') ||
                        this.valorBusca(cliente, 'endereco') ||
                        this.valorBusca(cliente, 'enderecoCompleto'),
                    bairro: this.valorBusca(cliente, 'BAIRRO') ||
                        this.valorBusca(cliente, 'bairro'),
                    cidade: this.valorBusca(cliente, 'NOMECID') ||
                        this.valorBusca(cliente, 'CIDADE') ||
                        this.valorBusca(cliente, 'cidade'),
                    uf: this.valorBusca(cliente, 'UF') ||
                        this.valorBusca(cliente, 'uf'),
                    cep: this.valorBusca(cliente, 'CEP') ||
                        this.valorBusca(cliente, 'cep')
                } as DemonstrativoCliente;
            })
            .filter((cliente): cliente is DemonstrativoCliente => !!cliente);
    }

    formatarInscricaoEstadual(
        inscricaoEstadual: string | number | null | undefined,
        uf?: string | null
    ): string {
        const valorOriginal = String(inscricaoEstadual ?? '').trim();

        if (!valorOriginal) {
            return '';
        }

        if (valorOriginal.toUpperCase() === 'ISENTO') {
            return 'ISENTO';
        }

        const numeros = valorOriginal.replace(/\D/g, '');

        if (!numeros) {
            return valorOriginal;
        }

        const estado = String(uf ?? '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim()
            .toUpperCase();

        const aplicarMascara = (
            valor: string,
            tamanhos: number[],
            mascara: (numero: string) => string
        ): string | null => {
            if (!tamanhos.includes(valor.length)) {
                return null;
            }

            return mascara(valor);
        };

        let formatado: string | null = null;

        switch (estado) {
            case 'AC':
            case 'ACRE':
                formatado = aplicarMascara(numeros, [13], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{3})(\d{2})$/,
                        '$1.$2.$3/$4-$5'
                    )
                );
                break;

            case 'AL':
            case 'ALAGOAS':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'AP':
            case 'AMAPA':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'AM':
            case 'AMAZONAS':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'BA':
            case 'BAHIA':
                formatado = aplicarMascara(numeros, [8, 9], (numero) => {
                    if (numero.length === 8) {
                        return numero.replace(
                            /^(\d{6})(\d{2})$/,
                            '$1-$2'
                        );
                    }

                    return numero.replace(
                        /^(\d{7})(\d{2})$/,
                        '$1-$2'
                    );
                });
                break;

            case 'CE':
            case 'CEARA':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'DF':
            case 'DISTRITO FEDERAL':
                formatado = aplicarMascara(numeros, [11, 13], (numero) => {
                    if (numero.length === 11) {
                        return numero.replace(
                            /^(\d{8})(\d{2})$/,
                            '$1-$2'
                        );
                    }

                    return numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{3})(\d{2})$/,
                        '$1.$2.$3/$4-$5'
                    );
                });
                break;

            case 'ES':
            case 'ESPIRITO SANTO':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{3})(\d{3})(\d{2})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'GO':
            case 'GOIAS':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'MA':
            case 'MARANHAO':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{3})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'MT':
            case 'MATO GROSSO':
                formatado = aplicarMascara(numeros, [11], (numero) =>
                    numero.replace(
                        /^(\d{10})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'MS':
            case 'MATO GROSSO DO SUL':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'MG':
            case 'MINAS GERAIS':
                formatado = aplicarMascara(numeros, [13], (numero) =>
                    numero.replace(
                        /^(\d{3})(\d{3})(\d{3})(\d{4})$/,
                        '$1.$2.$3/$4'
                    )
                );
                break;

            case 'PA':
            case 'PARA':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{6})(\d{1})$/,
                        '$1-$2-$3'
                    )
                );
                break;

            case 'PB':
            case 'PARAIBA':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'PR':
            case 'PARANA':
                formatado = aplicarMascara(numeros, [10], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{2})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'PE':
            case 'PERNAMBUCO':
                formatado = aplicarMascara(numeros, [9, 14], (numero) => {
                    if (numero.length === 9) {
                        return numero.replace(
                            /^(\d{7})(\d{2})$/,
                            '$1-$2'
                        );
                    }

                    return numero.replace(
                        /^(\d{2})(\d{1})(\d{3})(\d{7})(\d{1})$/,
                        '$1.$2.$3.$4-$5'
                    );
                });
                break;

            case 'PI':
            case 'PIAUI':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'RJ':
            case 'RIO DE JANEIRO':
                formatado = aplicarMascara(numeros, [8], (numero) =>
                    numero.replace(
                        /^(\d{2})(\d{3})(\d{2})(\d{1})$/,
                        '$1.$2.$3-$4'
                    )
                );
                break;

            case 'RN':
            case 'RIO GRANDE DO NORTE':
                formatado = aplicarMascara(numeros, [9, 10], (numero) => {
                    if (numero.length === 9) {
                        return numero.replace(
                            /^(\d{2})(\d{3})(\d{3})(\d{1})$/,
                            '$1.$2.$3-$4'
                        );
                    }

                    return numero.replace(
                        /^(\d{2})(\d{1})(\d{3})(\d{3})(\d{1})$/,
                        '$1.$2.$3.$4-$5'
                    );
                });
                break;

            case 'RS':
            case 'RIO GRANDE DO SUL':
                formatado = aplicarMascara(numeros, [10], (numero) =>
                    numero.replace(
                        /^(\d{3})(\d{7})$/,
                        '$1/$2'
                    )
                );
                break;

            case 'RO':
            case 'RONDONIA':
                formatado = aplicarMascara(numeros, [14], (numero) =>
                    numero.replace(
                        /^(\d{13})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'RR':
            case 'RORAIMA':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'SC':
            case 'SANTA CATARINA':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{3})(\d{3})(\d{3})$/,
                        '$1.$2.$3'
                    )
                );
                break;

            case 'SP':
            case 'SAO PAULO':
                formatado = aplicarMascara(numeros, [12], (numero) =>
                    numero.replace(
                        /^(\d{3})(\d{3})(\d{3})(\d{3})$/,
                        '$1.$2.$3.$4'
                    )
                );
                break;

            case 'SE':
            case 'SERGIPE':
                formatado = aplicarMascara(numeros, [9], (numero) =>
                    numero.replace(
                        /^(\d{8})(\d{1})$/,
                        '$1-$2'
                    )
                );
                break;

            case 'TO':
            case 'TOCANTINS':
                formatado = aplicarMascara(numeros, [9, 11], (numero) => {
                    if (numero.length === 9) {
                        return numero.replace(
                            /^(\d{8})(\d{1})$/,
                            '$1-$2'
                        );
                    }

                    return numero.replace(
                        /^(\d{2})(\d{2})(\d{6})(\d{1})$/,
                        '$1.$2.$3-$4'
                    );
                });
                break;
        }

        if (formatado) {
            return formatado;
        }
        return this.formatarInscricaoEstadualPadraoGoias(numeros);
    }

    private formatarInscricaoEstadualPadraoGoias(numeros: string): string {
        const valor = String(numeros || '').replace(/\D/g, '');

        if (!valor) {
            return '';
        }

        const valorNormalizado = valor.length < 9
            ? valor.padStart(9, '0')
            : valor;

        const digito = valorNormalizado.slice(-1);
        const blocoFinal = valorNormalizado.slice(-4, -1);
        const blocoMeio = valorNormalizado.slice(-7, -4);
        const blocoInicial = valorNormalizado.slice(0, -7);

        return `${blocoInicial}.${blocoMeio}.${blocoFinal}-${digito}`;
    }

    private normalizarEnderecosAlteracao(lista: unknown, clienteBase: DemonstrativoCliente): DemonstrativoCliente[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        return lista
            .map((item) => {
                const endereco = item as Record<string, unknown>;
                const codparc = this.valorBusca(endereco, 'codparc') ||
                    this.valorBusca(endereco, 'CODPARC') ||
                    clienteBase.codparc;
                const nomeparc = this.valorBusca(endereco, 'nomeparc') ||
                    this.valorBusca(endereco, 'NOMEPARC') ||
                    this.valorBusca(endereco, 'nomeParc') ||
                    clienteBase.nomeparc;
                const docparc = this.valorBusca(endereco, 'docparc') ||
                    this.valorBusca(endereco, 'DOCPARC') ||
                    this.valorBusca(endereco, 'CNPJ') ||
                    this.valorBusca(endereco, 'CGC_CPF') ||
                    clienteBase.docparc;
                const inscEstadual =
                    this.valorBusca(endereco, 'inscEstadual') ||
                    this.valorBusca(endereco, 'INSCESTADNAUF') ||
                    clienteBase.inscEstadual ||
                    '';

                const uf =
                    this.valorBusca(endereco, 'UF') ||
                    this.valorBusca(endereco, 'uf') ||
                    clienteBase.uf ||
                    '';

                if (!codparc || !nomeparc) {
                    return null;
                }

                return {
                    codparc,
                    nomeparc,
                    docparc,
                    inscEstadual,
                    uf,
                    endereco: this.valorBusca(endereco, 'ENDERECO') ||
                        this.valorBusca(endereco, 'NOMEEND') ||
                        this.valorBusca(endereco, 'LOGRADOURO') ||
                        this.valorBusca(endereco, 'ENDERECO_COMPLETO') ||
                        this.valorBusca(endereco, 'ENDERECOENTREGA') ||
                        this.valorBusca(endereco, 'endereco') ||
                        this.valorBusca(endereco, 'enderecoCompleto'),
                    numero: this.valorBusca(endereco, 'NUMEND') ||
                        this.valorBusca(endereco, 'NUMERO') ||
                        this.valorBusca(endereco, 'numero'),
                    complemento: this.valorBusca(endereco, 'COMPLEMENTO') ||
                        this.valorBusca(endereco, 'complemento'),
                    bairro: this.valorBusca(endereco, 'BAIRRO') ||
                        this.valorBusca(endereco, 'bairro'),
                    cidade: this.valorBusca(endereco, 'NOMECID') ||
                        this.valorBusca(endereco, 'CIDADE') ||
                        this.valorBusca(endereco, 'cidade'),
                    cep: this.valorBusca(endereco, 'CEP') ||
                        this.valorBusca(endereco, 'cep')
                } as DemonstrativoCliente;
            })
            .filter((cliente): cliente is DemonstrativoCliente => !!cliente);
    }

    private normalizarEnderecosNativosAlteracao(
        lista: unknown,
        clienteBase: DemonstrativoCliente
    ): DemonstrativoCliente[] {

        if (!Array.isArray(lista)) {
            return [];
        }

        const resultado: DemonstrativoCliente[] = [];
        const codparcsAdicionados = new Set<string>();

        for (const item of lista) {
            if (
                !item ||
                typeof item !== 'object'
            ) {
                continue;
            }

            const parceiro =
                item as Record<string, unknown>;

            const codparc =
                this.valorBusca(
                    parceiro,
                    'CODPARC'
                ) ||
                String(clienteBase.codparc || '');

            if (!codparc) {
                continue;
            }

            /*
             * Uma consulta por CODPARC deve produzir um único
             * endereço. Evita duplicidade caso a resposta seja
             * adicionada duas vezes.
             */
            const chaveCodparc =
                String(codparc);

            if (
                codparcsAdicionados.has(
                    chaveCodparc
                )
            ) {
                continue;
            }

            codparcsAdicionados.add(
                chaveCodparc
            );

            const nomeparc =
                this.valorBusca(
                    parceiro,
                    'NOMEPARC'
                ) ||
                this.valorBusca(
                    parceiro,
                    'RAZAOSOCIAL'
                ) ||
                clienteBase.nomeparc ||
                '';

            const docparc =
                this.valorBusca(
                    parceiro,
                    'CGC_CPF'
                ) ||
                clienteBase.docparc ||
                '';

            const inscEstadual =
                this.valorBusca(
                    parceiro,
                    'INSCESTADNAUF'
                );

            const endereco =
                this.valorBusca(
                    parceiro,
                    'Endereco.NOMEEND'
                ) ||
                this.valorBusca(
                    parceiro,
                    'NOMEEND'
                );

            const numero =
                this.valorBusca(
                    parceiro,
                    'NUMEND'
                );

            const complemento =
                this.valorBusca(
                    parceiro,
                    'COMPLEMENTO'
                );

            const bairro =
                this.valorBusca(
                    parceiro,
                    'Bairro.NOMEBAI'
                ) ||
                this.valorBusca(
                    parceiro,
                    'NOMEBAI'
                );

            const cep =
                this.valorBusca(
                    parceiro,
                    'CEP'
                );

            /*
             * Se o payload nativo trouxer NOMECID e UF separados,
             * usa diretamente.
             */
            let cidade =
                this.valorBusca(
                    parceiro,
                    'Cidade.NOMECID'
                ) ||
                this.valorBusca(
                    parceiro,
                    'NOMECID'
                );

            let uf =
                this.valorBusca(
                    parceiro,
                    'Cidade.UnidadeFederativa.UF'
                ) ||
                this.valorBusca(
                    parceiro,
                    'UF'
                );

            /*
             * O retorno capturado também possui Cidade.AD_UF,
             * por exemplo:
             *
             * CUIABA - MT
             *
             * Usa como fallback quando cidade/UF separados não
             * estiverem preenchidos.
             */
            const cidadeUf =
                this.valorBusca(
                    parceiro,
                    'Cidade.AD_UF'
                );

            if (
                cidadeUf &&
                (!cidade || !uf)
            ) {
                const partes =
                    cidadeUf
                        .split(' - ')
                        .map((parte) =>
                            parte.trim()
                        )
                        .filter(Boolean);

                if (
                    !cidade &&
                    partes.length
                ) {
                    cidade =
                        partes[0];
                }

                if (
                    !uf &&
                    partes.length > 1
                ) {
                    uf =
                        partes[
                        partes.length - 1
                            ];
                }
            }

            resultado.push({
                codparc,
                nomeparc,
                docparc,
                inscEstadual,
                endereco,
                numero,
                complemento,
                bairro,
                cidade,
                uf,
                cep
            });
        }

        return resultado;
    }

    private normalizarVendedoresDemonstrativo(lista: unknown, filtro: string): DemonstrativoCliente[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        const termo = filtro.trim().toUpperCase();

        return lista
            .map((item) => {
                const vendedor = item as Record<string, unknown>;
                const codVend = this.valorBusca(vendedor, 'codVend') || this.valorBusca(vendedor, 'CODVEND');
                const apelido = this.valorBusca(vendedor, 'apelido') || this.valorBusca(vendedor, 'APELIDO');
                return {codparc: codVend, nomeparc: apelido, docparc: '', tipoBusca: 'VENDEDOR' as const};
            })
            .filter((vendedor) => {
                const codigo = String(vendedor.codparc || '').toUpperCase();
                const nome = String(vendedor.nomeparc || '').toUpperCase();
                return vendedor.codparc && vendedor.nomeparc && (codigo.includes(termo) || nome.includes(termo));
            })
            .slice(0, 10);
    }

    private normalizarPrefixosBuscaDemonstrativo(lista: unknown, filtro: string): DemonstrativoCliente[] {
        if (!Array.isArray(lista)) {
            return [];
        }

        const termo = filtro.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

        return lista
            .map((item) => {
                const prefixo = item as Record<string, unknown>;
                const codaero = this.valorBusca(prefixo, 'codaero') || this.valorBusca(prefixo, 'CODAERO');
                const descricao = this.valorBusca(prefixo, 'prefixo') || this.valorBusca(prefixo, 'PREFIXO');
                const codparc = this.valorBusca(prefixo, 'codparc') || this.valorBusca(prefixo, 'CODPARC');
                const nomeparc = this.valorBusca(prefixo, 'nomeparc') ||
                    this.valorBusca(prefixo, 'NOMEPARC') ||
                    this.valorBusca(prefixo, 'nomeProprietario');

                return {
                    codparc,
                    nomeparc,
                    codaero,
                    prefixo: descricao,
                    tipoBusca: 'PREFIXO' as const
                };
            })
            .filter((item) => {
                const prefixo = String(item.prefixo || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
                const cliente = String(item.nomeparc || '').toUpperCase();
                return item.codaero && item.prefixo && (prefixo.includes(termo) || cliente.includes(filtro.trim().toUpperCase()));
            })
            .slice(0, 10);
    }

    private demonstrativoBuscaArtigo(): string {
        return this.demonstrativoTipoBusca === 'VENDEDOR'
            ? 'o vendedor'
            : this.demonstrativoTipoBusca === 'PREFIXO'
                ? 'o prefixo'
                : 'o cliente';
    }

    private valorBusca(objeto: Record<string, unknown>, key: string): string {
        const value = objeto[key];
        return value === null || value === undefined ? '' : String(value);
    }

    buscarDadosDemonstrativo(): void {
        if (
            this.demonstrativoTipoBusca === 'CLIENTE' &&
            !this.demonstrativoCodparcs.length &&
            !this.demonstrativoCodparc.trim()
        ) {
            this.demonstrativoStatus.set(
                'Selecione um cliente.'
            );
            return;
        }

        if (
            this.demonstrativoTipoBusca !== 'CLIENTE' &&
            !this.demonstrativoCodparc.trim()
        ) {
            this.demonstrativoStatus.set(
                this.demonstrativoTipoBusca === 'VENDEDOR'
                    ? 'Selecione um vendedor ou informe o CODVEND.'
                    : 'Selecione um prefixo.'
            );
            return;
        }

        this.demonstrativoBuscaSemDados = false;
        this.demonstrativoLoading.set(true);

        /*
         * CLIENTE
         *
         * Executa uma busca para cada CODPARC pertencente
         * ao mesmo CPF/CNPJ.
         */
        if (this.demonstrativoTipoBusca === 'CLIENTE') {
            const codparcs =
                this.demonstrativoCodparcs.length
                    ? this.demonstrativoCodparcs
                    : [this.demonstrativoCodparc];

            const codparcsValidos = Array.from(
                new Set(
                    codparcs
                        .map((codparc) =>
                            String(codparc || '').trim()
                        )
                        .filter((codparc) => codparc !== '')
                )
            );

            if (!codparcsValidos.length) {
                this.demonstrativoStatus.set(
                    'Nenhum CODPARC localizado para o cliente.'
                );
                this.demonstrativoLoading.set(false);
                return;
            }

            this.demonstrativoStatus.set(
                codparcsValidos.length > 1
                    ? `Buscando vendas em ${codparcsValidos.length} cadastros do cliente...`
                    : 'Buscando vendas do cliente...'
            );

            const respostas: Array<
                SankhyaEnvelope<DemonstrativoDados>
            > = [];

            const buscarProximoCadastro = (indice: number): void => {
                if (indice >= codparcsValidos.length) {
                    this.aplicarDadosMultiplosDemonstrativo(
                        respostas
                    );
                    return;
                }

                this.demonstrativoStatus.set(
                    `Buscando cadastro ${indice + 1} de ${codparcsValidos.length}...`
                );

                this.sankhyaGateway
                    .buscarDadosNativosDemonstrativo({
                        CODPARC: codparcsValidos[indice],
                        TIPO_BUSCA: 'CLIENTE',
                        DTINICIAL: this.demonstrativoDataInicial,
                        DTFINAL: this.demonstrativoDataFinal
                    })
                    .subscribe({
                        next: (
                            resposta: SankhyaEnvelope<DemonstrativoDados>
                        ) => {
                            respostas.push(resposta);
                            buscarProximoCadastro(indice + 1);
                        },
                        error: (error: any) => {
                            this.demonstrativoRawResponse.set(
                                JSON.stringify(error, null, 2)
                            );
                            buscarProximoCadastro(indice + 1);
                        }
                    });
            };

            buscarProximoCadastro(0);

            return;
        }

        /*
         * PREFIXO
         */
        if (this.demonstrativoTipoBusca === 'PREFIXO') {
            this.sankhyaGateway
                .buscarVendasPorCodaeroDemonstrativo({
                    PREFIXO:
                    this.demonstrativoPrefixoBuscaSelecionado,
                    TIPO_BUSCA: 'PREFIXO',
                    DTINICIAL: this.demonstrativoDataInicial,
                    DTFINAL: this.demonstrativoDataFinal
                })
                .subscribe({
                    next: (
                        value: SankhyaEnvelope<DemonstrativoDados>
                    ) => this.aplicarDadosDemonstrativo(value),

                    error: (error: any) => {
                        this.demonstrativoRawResponse.set(
                            JSON.stringify(error, null, 2)
                        );

                        this.demonstrativoStatus.set(
                            'Erro ao buscar demonstrativo no gateway.'
                        );

                        this.demonstrativoLoading.set(false);
                    }
                });

            return;
        }

        /*
         * VENDEDOR
         */
        this.sankhyaGateway
            .buscarDadosDemonstrativo({
                CODVEND: this.demonstrativoCodparc,
                TIPO_BUSCA: 'VENDEDOR',
                DTINICIAL: this.demonstrativoDataInicial,
                DTFINAL: this.demonstrativoDataFinal
            })
            .subscribe({
                next: (
                    value: SankhyaEnvelope<DemonstrativoDados>
                ) => this.aplicarDadosDemonstrativo(value),

                error: (error: any) => {
                    this.demonstrativoRawResponse.set(
                        JSON.stringify(error, null, 2)
                    );

                    this.demonstrativoStatus.set(
                        'Erro ao buscar demonstrativo no gateway.'
                    );

                    this.demonstrativoLoading.set(false);
                }
            });
    }

    getCell(item: Record<string, unknown>, key: string): string {
        const value = item[key];
        return value === null || value === undefined ? '' : String(value);
    }

    iconeBanco(conta: Record<string, unknown>): string | null {
        const descricao = String(conta?.['deposito'] || conta?.['DEPOSITO'] || '').toUpperCase();
        const banco = ['bradesco', 'sicoob', 'santander']
            .find(nome => new RegExp(`\\b${nome}\\b`, 'i').test(descricao));
        return banco ? `assets/bancos/${banco}.svg` : null;
    }

    demonstrativoTemDados(): boolean {
        return !!this.demonstrativoDados();
    }

    mensagemSemDadosDemonstrativo(): string {
        const alvo = this.demonstrativoTipoBusca === 'VENDEDOR'
            ? 'vendedor'
            : this.demonstrativoTipoBusca === 'PREFIXO'
                ? 'prefixo'
                : 'cliente';
        return `Nenhum dado encontrado para o ${alvo}, no periodo ${this.formatarDataInputCurta(this.demonstrativoDataInicial)} a ${this.formatarDataInputCurta(this.demonstrativoDataFinal)}.`;
    }

    demonstrativoDataAtual(): string {
        return new Date().toLocaleDateString('pt-BR');
    }

    demonstrativoHoraAtual(): string {
        return new Date().toLocaleTimeString('pt-BR');
    }

    demonstrativoDocTipo(): string {
        const tipo = this.demonstrativoDados()?.parceiro?.tipPessoa;
        return tipo === 'F' ? 'CPF:' : 'CNPJ:';
    }

    demonstrativoDocumento(): string {
        const parceiro = this.demonstrativoDados()?.parceiro;
        if (!parceiro?.docNumero) {
            return '-';
        }
        return this.formatarDocumento(parceiro.docNumero, parceiro.tipPessoa || 'J');
    }

    demonstrativoTotalFaturado(): string {
        const total = this.demonstrativoItens().reduce((acc: number, item: Record<string, unknown>) => {
            return acc + this.toNumber(this.getCell(item, 'valorFinal') || this.getCell(item, 'faturado'));
        }, 0);

        return total.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    demonstrativoMoeda(): string {
        return this.demonstrativoTipoMoeda === 'REAL' ? 'R$' : 'U$';
    }

    alternarMoeda(tipo: 'DOLAR' | 'REAL'): void {
        this.demonstrativoTipoMoeda = tipo;
        this.aplicarFiltrosDemonstrativo();
    }

    imprimirDemonstrativo(): void {
        this.demonstrativoImprimirCotacao = true;
        this.demonstrativoTipoImpressao = 'DEMONSTRATIVO';
        this.demonstrativoModalImpressao = true;
    }

    fecharModalImpressao(): void {
        this.demonstrativoModalImpressao = false;
    }

    temSelecionadosImpressao(): boolean {
        return this.itensSelecionados().length > 0;
    }

    confirmarImpressaoDemonstrativo(tipo: 'SELECIONADOS' | 'TODOS'): void {
        const itens = this.itensParaImpressao(tipo);

        if (!itens.length) {
            this.abrirModalAlerta('Nao ha vendas para imprimir.', 'OK');
            return;
        }

        this.demonstrativoModalImpressao = false;

        if (this.demonstrativoTipoImpressao === 'ORCAMENTO') {
            this.abrirFilaOrcamentos(itens);
            return;
        }

        this.imprimirAreaDemonstrativo(tipo, () => {
            if (this.demonstrativoTipoImpressao === 'AMBOS') {
                this.abrirFilaOrcamentos(itens);
            }
        });
    }

    abrirVendaImpressao(item: Record<string, unknown>, event?: Event): void {
        event?.stopPropagation();
        const nunota = this.getCell(item, 'codigo');

        if (!nunota) {
            this.abrirModalAlerta('Codigo da venda nao localizado para impressao.', 'OK');
            return;
        }

        const storage = this.getSessionStorage();
        this.salvarEstadoRetornoImpressao();
        this.salvarNavegacaoVendaImpressao(storage);
        storage?.setItem('param_venda_impressao_nunota', nunota);
        storage?.setItem('param_venda_impressao_retorno', 'demonstrativo-vendas');
        storage?.removeItem('param_venda_impressao_fila');
        storage?.removeItem('param_venda_impressao_auto_print');
        this.activeViewChange.emit('gpl-venda-impressao');
    }

    toggleRetornoDemonstrativo(): void {
        this.mostrarRetornoDemonstrativo = !this.mostrarRetornoDemonstrativo;
    }

    toggleMenuDemonstrativo(event?: Event): void {
        event?.stopPropagation();
        this.demonstrativoAbrirMenu = !this.demonstrativoAbrirMenu;
    }

    fecharMenusDemonstrativo(): void {
        this.demonstrativoAbrirMenu = false;
        this.demonstrativoAbrirPrefixos = false;
        this.demonstrativoAbrirEmpresas = false;
        this.demonstrativoAbrirCodigos = false;
        this.demonstrativoDropdownClientesAberto = false;
    }

    toggleDropdownDemonstrativo(
        tipo: 'prefixos' | 'empresas' | 'codigos',
        event?: Event
    ): void {

        event?.stopPropagation();

        if (tipo === 'prefixos') {
            this.demonstrativoAbrirPrefixos = !this.demonstrativoAbrirPrefixos;
            this.demonstrativoAbrirEmpresas = false;
            this.demonstrativoAbrirCodigos = false;
            return;
        }

        if (tipo === 'empresas') {
            this.demonstrativoAbrirEmpresas = !this.demonstrativoAbrirEmpresas;
            this.demonstrativoAbrirPrefixos = false;
            this.demonstrativoAbrirCodigos = false;
            return;
        }

        this.demonstrativoAbrirCodigos = !this.demonstrativoAbrirCodigos;
        this.demonstrativoAbrirPrefixos = false;
        this.demonstrativoAbrirEmpresas = false;
    }

    filtrarCodigo(codigo: string): void {
        this.demonstrativoCodigosSelecionados = this.toggleFiltro(codigo, this.demonstrativoCodigosSelecionados);
        this.aplicarFiltrosDemonstrativo();
    }

    filtrarPrefixo(prefixo: string): void {
        this.demonstrativoPrefixosSelecionados = this.toggleFiltro(prefixo, this.demonstrativoPrefixosSelecionados);
        this.aplicarFiltrosDemonstrativo();
    }

    filtrarEmpresa(empresa: string): void {
        this.demonstrativoEmpresasSelecionadas = this.toggleFiltro(empresa, this.demonstrativoEmpresasSelecionadas);
        this.aplicarFiltrosDemonstrativo();
    }

    filtrarStatus(status: string): void {
        this.demonstrativoStatusSelecionados = this.toggleFiltro(status, this.demonstrativoStatusSelecionados);
        this.aplicarFiltrosDemonstrativo();
    }

    marcarTodosDemonstrativo(): void {
        this.demonstrativoSelecionarTodos = !this.demonstrativoSelecionarTodos;
        const itens = this.demonstrativoItens().map((item: any) => ({
            ...item,
            selecionado: this.demonstrativoSelecionarTodos
        }));
        this.demonstrativoItens.set(itens);
    }

    validarSelecionadosDemonstrativo(): void {
        const itens = this.demonstrativoItens();
        this.demonstrativoSelecionarTodos = itens.length > 0 && itens.every((item: {
            [x: string]: any;
        }) => item['selecionado']);
    }

    ordenarDemonstrativo(campo: 'ord' | 'emp' | 'prefixo' | 'emissao' | 'status'): void {
        const asc = this.toggleOrdenacao(campo);
        const itens = [...this.demonstrativoItens()].sort((a, b) => {
            if (campo === 'ord' || campo === 'emp') {
                const valorA = Number(this.getCell(a, campo)) || 0;
                const valorB = Number(this.getCell(b, campo)) || 0;
                return asc ? valorA - valorB : valorB - valorA;
            }

            const valorA = campo === 'emissao'
                ? this.normalizarDataOrdenacao(this.getCell(a, campo))
                : this.getCell(a, campo).toUpperCase();
            const valorB = campo === 'emissao'
                ? this.normalizarDataOrdenacao(this.getCell(b, campo))
                : this.getCell(b, campo).toUpperCase();
            return asc ? valorA.localeCompare(valorB) : valorB.localeCompare(valorA);
        });
        this.demonstrativoItens.set(itens);
    }

    zoomDemonstrativo(tipo: '+' | '-'): void {
        if (tipo === '+' && this.demonstrativoZoomAtual < 1.4) {
            this.demonstrativoZoomAtual += 0.1;
        }
        if (tipo === '-' && this.demonstrativoZoomAtual > 1.1) {
            this.demonstrativoZoomAtual -= 0.1;
        }
        this.demonstrativoZoomAtual = Number(this.demonstrativoZoomAtual.toFixed(1));
    }

    alternarZoomDemonstrativo(): void {
        this.demonstrativoZoomAtual = this.demonstrativoZoomAtual >= 1.4 ? 1.1 : 1.4;
    }

    pageA4Style(): Record<string, string> {
        return {
            transform: `scale(${this.demonstrativoZoomAtual})`,
            transformOrigin: 'top center'
        };
    }

    formatarWhatsappDemonstrativo(valor: string): void {
        const numeros = String(valor || '')
            .replace(/\D/g, '')
            .slice(0, 11);

        if (numeros.length <= 2) {
            this.demonstrativoWhatsappNumero = numeros;
            return;
        }

        if (numeros.length <= 7) {
            this.demonstrativoWhatsappNumero =
                `${numeros.slice(0, 2)} ${numeros.slice(2)}`;
            return;
        }

        this.demonstrativoWhatsappNumero =
            `${numeros.slice(0, 2)} ${numeros.slice(2, 7)}-${numeros.slice(7)}`;
    }

    whatsappDemonstrativoValido(): boolean {
        return /^\d{2} \d{5}-\d{4}$/.test(
            this.demonstrativoWhatsappNumero
        );
    }

    enviarWhatsappDemonstrativo(): void {
        if (!this.whatsappDemonstrativoValido()) {
            this.abrirModalAlerta('Informe um telefone válido', 'OK');
            return;
        }

        let numero = this.demonstrativoWhatsappNumero.replace(/\D/g, '');

        if (!numero.startsWith('55')) {
            numero = '55' + numero;
        }

        const parceiro = this.demonstrativoDados()?.parceiro?.nomeParc || this.demonstrativoFiltroCliente || 'cliente';
        const mensagem = encodeURIComponent('Ola! O demonstrativo de vendas da ' + parceiro + ' foi gerado.');
        window.open('https://wa.me/' + numero + '?text=' + mensagem, '_blank');
    }

    async salvarPdfDemonstrativo(): Promise<void> {
        const elemento = document.querySelector('.page-a4') as HTMLElement | null;

        if (!elemento) {
            this.abrirModalAlerta('Area de impressao nao encontrada.', 'OK');
            return;
        }

        if (typeof html2pdf === 'undefined') {
            this.abrirModalAlerta('Biblioteca de PDF nao carregada.', 'OK');
            return;
        }

        const transformOriginal = elemento.style.transform;
        const transformOriginOriginal = elemento.style.transformOrigin;
        const zoomOriginal = (elemento.style as any).zoom;

        this.demonstrativoLoading.set(true);
        document.body.classList.add('demonstrativo-pdf-exporting');
        elemento.style.transform = '';
        elemento.style.transformOrigin = '';
        (elemento.style as any).zoom = '';

        try {
            await new Promise((resolve) => setTimeout(resolve, 180));

            await html2pdf()
                .set({
                    margin: 0,
                    filename: this.nomeArquivoPdfDemonstrativo(),
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        useCORS: true,
                        logging: false,
                        letterRendering: true,
                        backgroundColor: '#ffffff',
                        scrollX: 0,
                        scrollY: 0
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: 'a4',
                        orientation: 'landscape'
                    },
                    pagebreak: {
                        mode: ['avoid-all']
                    }
                })
                .from(elemento)
                .save();
        } catch (e) {
            console.error('Erro ao gerar PDF:', e);
            this.abrirModalAlerta('Erro ao gerar PDF', 'OK');
        } finally {
            elemento.style.transform = transformOriginal;
            elemento.style.transformOrigin = transformOriginOriginal;
            (elemento.style as any).zoom = zoomOriginal;
            document.body.classList.remove('demonstrativo-pdf-exporting');
            this.demonstrativoLoading.set(false);
        }
    }

    abrirCotacoes(): void {
        this.demonstrativoAbrirMenu = false;

        try {
            this.validarStatusLegado(
                this.demonstrativoItens(),
                'Um ou mais registros nao puderam ser alterados!\nRegistro feito no AeroSys.'
            );
        } catch {
            return;
        }

        const selecionados = this.itensSelecionados();
        if (!selecionados.length) {
            this.abrirModalAlerta('Selecione ao menos uma nota para alterar a cotacao', 'OK');
            return;
        }

        this.buscarCotacoes();
    }

    fecharCotacoes(): void {
        this.demonstrativoModalCotacoes = false;
    }

    abrirAlterarPrefixo(): void {
        this.demonstrativoAbrirMenu = false;

        try {
            this.validarStatusLegado(
                this.demonstrativoItens(),
                'Um ou mais registros nao puderam ser alterados!\nRegistro feito no AeroSys.'
            );
        } catch {
            return;
        }

        const selecionados =
            this.itensSelecionados();

        if (!selecionados.length) {
            this.abrirModalAlerta(
                'Selecione ao menos uma nota para alterar o prefixo',
                'OK'
            );

            return;
        }

        const codparcs = Array.from(
            new Set(
                selecionados
                    .map((item) =>
                        this.toNumber(
                            this.getCell(
                                item,
                                'codParc'
                            )
                        )
                    )
                    .filter((codparc) =>
                        codparc > 0
                    )
            )
        );

        if (!codparcs.length) {
            this.abrirModalAlerta(
                'CODPARC da venda não localizado.',
                'OK'
            );

            return;
        }

        /*
         * O PesquisaSP.getSuggestion nativo filtra as aeronaves
         * pelo CODPARC da venda.
         *
         * Portanto, uma alteração em lote precisa trabalhar
         * com vendas pertencentes ao mesmo CODPARC.
         */
        if (codparcs.length > 1) {
            this.abrirModalAlerta(
                'As vendas selecionadas pertencem a cadastros de clientes diferentes. Selecione vendas do mesmo CODPARC para alterar o prefixo.',
                'OK'
            );

            return;
        }

        this.buscarPrefixos(
            codparcs[0]
        );
    }

    fecharAlterarPrefixo(): void {
        this.demonstrativoModalPrefixos = false;
    }

    prefixosAlteracaoFiltrados(): DemonstrativoPrefixo[] {
        const filtro = this.demonstrativoFiltroPrefixoAlteracao.trim().toLowerCase();
        if (!filtro) {
            return this.demonstrativoPrefixosAlteracao;
        }

        return this.demonstrativoPrefixosAlteracao.filter((prefixo) =>
            String(prefixo.prefixo ?? '').toLowerCase().includes(filtro)
        );
    }

    atualizarPrefixo(): void {
        if (!this.demonstrativoPrefixoSelecionadoAlteracao) {
            this.abrirModalAlerta('Selecione um prefixo para alterar', 'OK');
            return;
        }

        const notas = this.itensSelecionados()
            .map((item) => this.toNumber(this.getCell(item, 'codigo')))
            .filter((codigo) => codigo > 0);

        if (!notas.length) {
            this.abrirModalAlerta('Selecione ao menos uma nota para alterar o prefixo', 'OK');
            return;
        }

        const codaero = this.toNumber(String(this.demonstrativoPrefixoSelecionadoAlteracao.codaero));
        if (!codaero) {
            this.abrirModalAlerta('Prefixo selecionado invalido.', 'OK');
            return;
        }

        this.fecharAlterarPrefixo();
        this.demonstrativoLoading.set(true);
        this.sankhyaGateway.atualizarPrefixoDemonstrativo({
            CODAERO: codaero,
            notas
        }).subscribe({
            next: (value) => {
                const body = this.unwrapResponse<DemonstrativoAtualizacaoResponse>(value);
                if (body?.sucesso && !this.respostaPossuiFalhas(body)) {
                    this.abrirModalAlerta('Prefixos atualizados com sucesso!', 'OK');
                    this.buscarDadosDemonstrativo();
                    return;
                }

                this.demonstrativoLoading.set(false);
                // @ts-ignore
                this.abrirModalAlerta(body?.erro || value.statusMessage || 'Erro ao atualizar prefixos.', 'OK');
            },
            error: (error: unknown) => {
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao atualizar prefixos.'), 'OK');
            }
        });
    }

    cotacoesFiltradas(): DemonstrativoCotacao[] {
        const filtro = this.demonstrativoFiltroCotacao
            .trim()
            .toLocaleLowerCase('pt-BR');

        if (!filtro) {
            return this.demonstrativoCotacoes;
        }

        return this.demonstrativoCotacoes.filter(
            (cotacao) => {
                const valor = Number(cotacao.valor || 0)
                    .toLocaleString(
                        'pt-BR',
                        {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 4
                        }
                    )
                    .toLocaleLowerCase('pt-BR');

                const data = String(cotacao.data || '')
                    .toLocaleLowerCase('pt-BR');

                const moeda = String(cotacao.moeda || '')
                    .toLocaleLowerCase('pt-BR');

                return valor.includes(filtro)
                    || data.includes(filtro)
                    || moeda.includes(filtro);
            }
        );
    }

    cotacaoData(
        cotacao: DemonstrativoCotacao
    ): string {
        return String(
            cotacao.data || '-'
        );
    }

    alterarCotacoes(): void {
        if (!this.demonstrativoCotacaoSelecionada) {
            this.abrirModalAlerta('Selecione a cotacao para alterar', 'OK');
            return;
        }

        const selecionados = this.itensSelecionados();
        const notas = selecionados
            .map((item) => this.toNumber(this.getCell(item, 'codigo')))
            .filter((codigo) => codigo > 0);

        if (!notas.length) {
            this.abrirModalAlerta('Selecione ao menos uma nota para alterar a cotacao', 'OK');
            return;
        }

        const valorCotacao = this.toNumber(String(this.demonstrativoCotacaoSelecionada.valor));
        if (!valorCotacao) {
            this.abrirModalAlerta('Cotacao selecionada invalida.', 'OK');
            return;
        }

        const notasResumo = selecionados.map((item) => {
            const cotacaoAtual = this.toNumber(this.getCell(item, 'dolar'));
            return {
                codigo: this.getCell(item, 'codigo'),
                titulo: this.getCell(item, 'codigo'),
                emissao: this.getCell(item, 'emissao'),
                status: this.getCell(item, 'status'),
                cotacaoAtual,
                novaCotacao: valorCotacao,
                acao: valorCotacao < cotacaoAtual ? 'Solicitar liberacao' : (valorCotacao > cotacaoAtual ? 'Atualizar cotacao' : 'Manter cotacao')
            };
        });

        this.abrirConfirmacaoCotacao(valorCotacao, notasResumo);
    }

    confirmarAlteracaoCotacao(): void {
        const cotacao = this.demonstrativoConfirmacaoCotacao.cotacao;
        const notasAtualizar = this.demonstrativoConfirmacaoCotacao.notas
            .filter((nota) => nota['acao'] !== 'Solicitar liberacao')
            .map((nota) => this.toNumber(String(nota['codigo'] || '')))
            .filter((codigo) => codigo > 0);
        const notasLiberacao = this.demonstrativoConfirmacaoCotacao.notas
            .filter((nota) => nota['acao'] === 'Solicitar liberacao')
            .map((nota) => this.toNumber(String(nota['codigo'] || '')))
            .filter((codigo) => codigo > 0);

        this.cancelarConfirmacaoCotacao();

        if (notasAtualizar.length) {
            this.executarAlteracaoCotacao(cotacao, notasAtualizar, notasLiberacao);
            return;
        }

        this.processarCotacaoMenor(cotacao, notasLiberacao, false);
    }

    cancelarConfirmacaoCotacao(): void {
        this.demonstrativoModalConfirmacaoCotacao = false;
        this.demonstrativoConfirmacaoCotacao = {cotacao: 0, notas: []};
    }

    private abrirConfirmacaoCotacao(cotacao: number, notas: Array<Record<string, any>>): void {
        this.fecharCotacoes();
        this.demonstrativoConfirmacaoCotacao = {cotacao, notas};
        this.demonstrativoModalConfirmacaoCotacao = true;
    }

    private executarAlteracaoCotacao(valorCotacao: number, notas: number[], notasLiberacao: number[] = []): void {
        this.fecharCotacoes();
        this.demonstrativoLoading.set(true);
        this.sankhyaGateway.atualizarCotacaoVenda({
            cotacao: valorCotacao,
            notas
        }).subscribe({
            next: (value: SankhyaEnvelope<DemonstrativoAtualizacaoResponse> | (DemonstrativoAtualizacaoResponse & Record<string, unknown>) | null | undefined) => {
                const body = this.unwrapResponse<DemonstrativoAtualizacaoResponse>(value);
                if (body?.sucesso) {
                    if (body.excedeLimite || body.cotacaoAtualizada === false) {
                        this.abrirModalAlerta(
                            body.mensagem ||
                            body.mensagemSolicitacao ||
                            'Reducao de cotacao exige liberacao. Solicitacao gravada.',
                            'OK'
                        );
                        this.demonstrativoLoading.set(false);

                        if (body.cotacaoAtualizada || Number(body.notasAtualizadas || 0) > 0) {
                            this.buscarDadosDemonstrativo();
                        }

                        return;
                    }

                    if (notasLiberacao.length) {
                        this.processarCotacaoMenor(valorCotacao, notasLiberacao, true);
                        return;
                    }

                    this.abrirModalAlerta('Cotacoes atualizadas com sucesso!', 'OK');
                    this.buscarDadosDemonstrativo();
                    return;
                }

                this.demonstrativoLoading.set(false);
                // @ts-ignore
                this.abrirModalAlerta(body?.erro || value.statusMessage || 'Erro ao atualizar cotacoes.', 'OK');
            },
            error: (error: unknown) => {
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao atualizar cotacoes.'), 'OK');
            }
        });
    }

    private processarCotacaoMenor(
        cotacao: number,
        notas: number[],
        atualizarDepois = false
    ): void {
        if (!notas.length) {
            if (atualizarDepois) {
                this.abrirModalAlerta('Cotacoes atualizadas com sucesso!', 'OK');
                this.buscarDadosDemonstrativo();
            }
            return;
        }

        this.demonstrativoLoading.set(true);
        this.sankhyaGateway
            .atualizarCotacaoVendaNativa({cotacao, notas})
            .subscribe({
                next: (value) => {
                    const body = this.unwrapResponse<DemonstrativoAtualizacaoResponse>(value);

                    if (body?.sucesso && body.autorizado === false) {
                        this.solicitarLiberacaoCotacao(
                            cotacao,
                            notas,
                            atualizarDepois
                        );
                        return;
                    }

                    if (body?.sucesso && body.cotacaoAtualizada) {
                        this.abrirModalAlerta(
                            atualizarDepois
                                ? 'Cotacoes atualizadas com sucesso!'
                                : 'Cotacao atualizada com sucesso!',
                            'OK'
                        );
                        this.buscarDadosDemonstrativo();
                        return;
                    }

                    this.demonstrativoLoading.set(false);
                    this.abrirModalAlerta(
                        body?.erro || body?.mensagem || 'Erro ao atualizar cotacao.',
                        'OK'
                    );
                },
                error: (error) => {
                    this.demonstrativoLoading.set(false);
                    this.abrirModalAlerta(
                        this.erroMensagem(error, 'Erro ao atualizar cotacao.'),
                        'OK'
                    );
                }
            });
    }

    private solicitarLiberacaoCotacao(cotacao: number, notas: number[], atualizarDepois = false): void {
        if (!notas.length) {
            if (atualizarDepois) {
                this.abrirModalAlerta('Cotacoes atualizadas com sucesso!', 'OK');
                this.buscarDadosDemonstrativo();
            }
            return;
        }

        this.demonstrativoLoading.set(true);
        this.sankhyaGateway.solicitarLiberacaoCotacao({cotacao, notas}).subscribe({
            next: (value) => {
                const body = this.unwrapResponse<any>(value as any);
                if (body?.sucesso) {
                    const mensagem = body.mensagemSolicitacao || 'Solicitacao de liberacao de cotacao registrada.';
                    this.abrirModalAlerta(
                        atualizarDepois ? 'Cotacoes atualizadas e ' + mensagem : mensagem,
                        'OK'
                    );
                    this.demonstrativoLoading.set(false);
                    this.buscarDadosDemonstrativo();
                    return;
                }

                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(body?.mensagem || body?.erro || 'Erro ao salvar solicitacao de liberacao de cotacao.', 'OK');
            },
            error: (error) => {
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao salvar solicitacao de liberacao de cotacao.'), 'OK');
            }
        });
    }

    abrirModalAlerta(texto: string, botao = 'OK'): void {
        this.demonstrativoModalAlertaTexto = texto;
        this.demonstrativoModalAlertaBotao = botao;
        this.demonstrativoModalAlerta = true;
    }

    fecharModalAlerta(): void {
        this.demonstrativoModalAlerta = false;
    }

    abrirFuncaoPendenteDemonstrativo(nome: string): void {
        this.demonstrativoAbrirMenu = false;
        this.demonstrativoStatus.set(`${nome} mantido no menu. Integracao sera conectada depois.`);
    }

    abrirAlterarClienteVendas(): void {
        this.demonstrativoAbrirMenu = false;

        try {
            this.validarStatusLegado(
                this.demonstrativoItens(),
                'Um ou mais registros nao puderam ser alterados!\nRegistro feito no AeroSys.'
            );
        } catch {
            return;
        }

        const notas = this.notasSelecionadasNumericas();
        if (!notas.length) {
            this.abrirModalAlerta('Selecione ao menos uma venda para alterar o cliente', 'OK');
            return;
        }

        this.limparAlterarCliente(false);
        this.demonstrativoLoading.set(true);
        this.sankhyaGateway.chamarServiceGpl('CabecalhoDaNotaGlobalSP.doBuscarResumoAlteracaoCliente', {notas}).subscribe({
            next: (value) => {
                const body = this.unwrapResponse<any>(value as any);
                this.demonstrativoLoading.set(false);

                if (body?.sucesso) {
                    this.demonstrativoAlterarClienteNotas = Array.isArray(body.notas) ? body.notas : [];
                    this.demonstrativoModalAlterarCliente = true;
                    return;
                }

                this.abrirModalAlerta(body?.erro || body?.mensagem || 'Erro ao buscar dados atuais das vendas.', 'OK');
            },
            error: (error) => {
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao buscar dados atuais das vendas.'), 'OK');
            }
        });
    }

    fecharAlterarClienteVendas(): void {
        this.demonstrativoModalAlterarCliente = false;
        this.limparAlterarCliente(true);
    }

    agendarBuscaClienteAlteracao(): void {
        if (this.demonstrativoAlterarClienteBuscaTimer) {
            clearTimeout(this.demonstrativoAlterarClienteBuscaTimer);
        }

        this.demonstrativoAlterarClienteClienteSelecionado = null;
        this.demonstrativoAlterarClienteEnderecos = [];
        this.demonstrativoAlterarClienteEnderecoSelecionado = null;
        this.demonstrativoAlterarClienteEndereco = null;
        this.demonstrativoAlterarClientePrefixos = [];
        this.demonstrativoAlterarClientePrefixoSelecionado = null;
        this.demonstrativoAlterarClientePrefixosPorNota = {};
        this.demonstrativoAlterarClientePasso = 1;

        if (this.demonstrativoAlterarClienteFiltro.trim().length < 2) {
            this.demonstrativoAlterarClienteClientes = [];
            this.demonstrativoAlterarClienteDropdownAberto = false;
            this.demonstrativoAlterarClienteStatus = 'Digite ao menos 2 caracteres para buscar o cliente.';
            return;
        }

        this.demonstrativoAlterarClienteBuscaTimer = setTimeout(() => this.buscarClientesAlteracao(), 250);
    }

    buscarClientesAlteracao(): void {
        const filtro =
            this.demonstrativoAlterarClienteFiltro.trim();

        if (filtro.length < 2) {
            this.demonstrativoAlterarClienteStatus =
                'Digite ao menos 2 caracteres para buscar o cliente.';

            this.demonstrativoAlterarClienteClientes = [];
            this.demonstrativoAlterarClienteDropdownAberto = false;

            return;
        }

        this.demonstrativoAlterarClienteDropdownAberto = true;
        this.demonstrativoAlterarClienteStatus =
            'Buscando clientes...';

        this.sankhyaGateway
            .buscarClientesNativo(filtro)
            .subscribe({
                next: (value: any) => {
                    if (!value) {
                        this.demonstrativoAlterarClienteClientes = [];

                        this.demonstrativoAlterarClienteStatus =
                            'Resposta vazia do gateway.';

                        return;
                    }

                    if (
                        value.status &&
                        value.status !== '1'
                    ) {
                        this.demonstrativoAlterarClienteClientes = [];

                        this.demonstrativoAlterarClienteStatus =
                            value.statusMessage ||
                            'A pesquisa nativa de clientes não retornou sucesso.';

                        return;
                    }

                    /*
                     * PesquisaSP.getSuggestion retorna os dados dentro de:
                     *
                     * responseBody.json.$
                     *
                     * Reutilizamos o mesmo normalizador já utilizado
                     * na busca principal do demonstrativo.
                     */
                    const dadosNativos =
                        this.extrairDadosPesquisaNativaCliente(
                            value
                        );

                    const lista =
                        this.normalizarClientesDemonstrativo(
                            dadosNativos
                        );

                    this.demonstrativoAlterarClienteClientes =
                        lista;

                    this.demonstrativoAlterarClienteStatus =
                        lista.length
                            ? `${lista.length} cliente(s) encontrado(s).`
                            : 'Nenhum cliente encontrado.';
                },

                error: (error: unknown) => {
                    this.demonstrativoAlterarClienteClientes = [];

                    this.demonstrativoAlterarClienteStatus =
                        this.erroMensagem(
                            error,
                            'Erro ao buscar clientes.'
                        );
                }
            });
    }

    selecionarClienteAlteracao(cliente: DemonstrativoCliente): void {
        this.demonstrativoAlterarClienteClienteSelecionado = cliente;
        this.demonstrativoAlterarClienteFiltro = this.labelClienteDemonstrativo(cliente);
        this.demonstrativoAlterarClienteClientes = [];
        this.demonstrativoAlterarClienteDropdownAberto = false;
        this.demonstrativoAlterarClienteEnderecos = [];
        this.demonstrativoAlterarClienteEnderecoSelecionado = null;
        this.demonstrativoAlterarClienteEndereco = null;
        this.demonstrativoAlterarClientePrefixos = [];
        this.demonstrativoAlterarClientePrefixoSelecionado = null;
        this.demonstrativoAlterarClientePrefixosPorNota = {};
        this.carregarEnderecosClienteAlteracao(cliente);
    }

    selecionarEnderecoAlteracao(cliente: DemonstrativoCliente): void {
        this.demonstrativoAlterarClienteEnderecoSelecionado = cliente;
        this.demonstrativoAlterarClienteEndereco = null;
        this.demonstrativoAlterarClientePrefixos = [];
        this.demonstrativoAlterarClientePrefixoSelecionado = null;
        this.demonstrativoAlterarClientePrefixosPorNota = {};
    }

    avancarAlterarCliente(): void {
        if (!this.demonstrativoAlterarClienteClienteSelecionado) {
            this.abrirModalAlerta('Selecione o novo cliente.', 'OK');
            return;
        }

        if (!this.demonstrativoAlterarClienteEnderecoSelecionado) {
            this.abrirModalAlerta('Selecione o endereco do novo cliente.', 'OK');
            return;
        }

        this.demonstrativoAlterarClientePasso = 2;
        this.carregarPrefixosClienteAlteracao(this.demonstrativoAlterarClienteEnderecoSelecionado);
    }

    voltarPassoAlterarCliente(): void {
        if (this.demonstrativoAlterarClientePasso === 3) {
            this.demonstrativoAlterarClientePasso = 2;
            return;
        }

        this.demonstrativoAlterarClientePasso = 1;
    }

    avancarPrefixosAlterarCliente(): void {
        if (!this.demonstrativoAlterarClientePrefixos.length) {
            this.abrirModalAlerta('Nenhum prefixo encontrado para o novo cliente.', 'OK');
            return;
        }

        this.inicializarPrefixosAlterarClientePorNota();
        this.demonstrativoAlterarClientePasso = 3;
    }

    prefixosAlterarClienteFiltrados(): DemonstrativoPrefixo[] {
        const filtro = this.demonstrativoAlterarClienteFiltroPrefixo.trim().toLowerCase();
        if (!filtro) {
            return this.demonstrativoAlterarClientePrefixos;
        }

        return this.demonstrativoAlterarClientePrefixos.filter((prefixo) =>
            String(prefixo.prefixo ?? '').toLowerCase().includes(filtro)
        );
    }

    enderecoAlterarClienteTexto(): string {
        const enderecoSelecionado = this.enderecoClienteAlteracaoTexto(this.demonstrativoAlterarClienteEnderecoSelecionado);
        if (enderecoSelecionado) {
            return enderecoSelecionado;
        }

        return this.formatarEnderecoAlteracao(this.demonstrativoAlterarClienteEndereco);
    }

    chaveNotaAlterarCliente(nota: DemonstrativoResumoAlteracaoCliente): string {
        return String(nota.nunota || '').trim();
    }

    nunotaFormatadoAlterarCliente(nota: DemonstrativoResumoAlteracaoCliente): string {
        const nunota = String(nota.nunotaFormatado || nota.nunota || '').replace(/\D/g, '');
        return nunota ? nunota.padStart(7, '0') : '-';
    }

    valorVendaFormatadoAlterarCliente(nota: DemonstrativoResumoAlteracaoCliente): string {
        return `R$ ${this.formatarMoeda(this.toNumber(String(nota.valorVenda || '0')))}`;
    }

    prefixoSelecionadoAlterarClienteNota(nota: DemonstrativoResumoAlteracaoCliente): DemonstrativoPrefixo | null {
        return this.demonstrativoAlterarClientePrefixosPorNota[this.chaveNotaAlterarCliente(nota)] || null;
    }

    selecionarPrefixoAlterarClienteNota(nota: DemonstrativoResumoAlteracaoCliente, valor: string): void {
        const chave = this.chaveNotaAlterarCliente(nota);
        this.demonstrativoAlterarClientePrefixosPorNota[chave] =
            this.demonstrativoAlterarClientePrefixos.find((prefixo) => String(prefixo.codaero) === valor) || null;
    }

    aplicarPrefixoAlterarClienteTodos(valor: string): void {
        const prefixo = this.demonstrativoAlterarClientePrefixos.find((item) => String(item.codaero) === valor) || null;

        this.demonstrativoAlterarClienteNotas.forEach((nota) => {
            const chave = this.chaveNotaAlterarCliente(nota);
            if (chave) {
                this.demonstrativoAlterarClientePrefixosPorNota[chave] = prefixo;
            }
        });
    }

    todasNotasAlterarClienteComPrefixo(): boolean {
        return this.demonstrativoAlterarClienteNotas.every((nota) =>
            Boolean(this.prefixoSelecionadoAlterarClienteNota(nota)?.codaero)
        );
    }

    salvarAlterarClienteVendas(): void {
        const notas = this.notasSelecionadasNumericas();
        const cliente = this.demonstrativoAlterarClienteEnderecoSelecionado || this.demonstrativoAlterarClienteClienteSelecionado;

        if (!notas.length) {
            this.abrirModalAlerta('Selecione ao menos uma venda para alterar o cliente', 'OK');
            return;
        }

        if (!cliente?.codparc) {
            this.abrirModalAlerta('Selecione o novo cliente.', 'OK');
            return;
        }

        const codparc = this.toNumber(String(cliente.codparc));
        if (!codparc) {
            this.abrirModalAlerta('Cliente selecionado invalido.', 'OK');
            return;
        }

        if (!this.todasNotasAlterarClienteComPrefixo()) {
            this.abrirModalAlerta('Selecione o prefixo de todas as vendas.', 'OK');
            return;
        }

        this.abrirConfirmacao({
            mensagem: 'Alterar cliente e prefixo para venda(s) selecionada(s)?',
            textoOk: 'Confirmar',
            textoCancelar: 'Cancelar',
            callbackOk: () => this.confirmarAlterarClienteVendas(notas, codparc)
        });
    }

    private confirmarAlterarClienteVendas(
        notas: number[],
        codparc: number
    ): void {

        const cliente =
            this.demonstrativoAlterarClienteEnderecoSelecionado ||
            this.demonstrativoAlterarClienteClienteSelecionado;

        if (!cliente) {
            this.abrirModalAlerta(
                'Cliente selecionado não localizado.',
                'OK'
            );

            return;
        }

        const nomeparc =
            String(
                cliente.nomeparc ||
                this.demonstrativoAlterarClienteClienteSelecionado?.nomeparc ||
                ''
            ).trim();

        if (!nomeparc) {
            this.abrirModalAlerta(
                'Nome do novo cliente não localizado.',
                'OK'
            );

            return;
        }

        const notasSelecionadas =
            new Set(
                notas
            );

        const alteracoes =
            this.demonstrativoAlterarClienteNotas
                .filter(
                    (nota) => {

                        const nunota =
                            this.toNumber(
                                this.chaveNotaAlterarCliente(
                                    nota
                                )
                            );

                        return notasSelecionadas.has(
                            nunota
                        );
                    }
                )
                .map(
                    (nota) => {

                        const nunota =
                            this.toNumber(
                                this.chaveNotaAlterarCliente(
                                    nota
                                )
                            );

                        const prefixo =
                            this.prefixoSelecionadoAlterarClienteNota(
                                nota
                            );

                        const codaero =
                            this.toNumber(
                                String(
                                    prefixo?.codaero ||
                                    ''
                                )
                            );

                        const descricaoPrefixo =
                            String(
                                prefixo?.prefixo ||
                                ''
                            ).trim();

                        if (
                            !nunota ||
                            !codaero ||
                            !descricaoPrefixo
                        ) {
                            return null;
                        }

                        return {
                            NUNOTA:
                            nunota,

                            CODPARC:
                            codparc,

                            NOMEPARC:
                            nomeparc,

                            CODAERO:
                            codaero,

                            PREFIXO:
                            descricaoPrefixo
                        };
                    }
                )
                .filter(
                    (
                        item
                    ): item is {
                        NUNOTA: number;
                        CODPARC: number;
                        NOMEPARC: string;
                        CODAERO: number;
                        PREFIXO: string;
                    } =>
                        item !== null
                );

        if (
            alteracoes.length !==
            notas.length
        ) {
            this.abrirModalAlerta(
                'Não foi possível montar cliente e prefixo para todas as vendas selecionadas.',
                'OK'
            );

            return;
        }

        this.demonstrativoModalAlterarCliente =
            false;

        this.demonstrativoLoading.set(
            true
        );

        this.sankhyaGateway
            .alterarClientePrefixoVendaNativo({
                alteracoes
            })
            .subscribe({
                next: (
                    value:
                    SankhyaEnvelope<
                        DemonstrativoAlteracaoClientePrefixoResponse
                    >
                ) => {

                    const body =
                        this.unwrapResponse<
                            DemonstrativoAlteracaoClientePrefixoResponse
                        >(
                            value
                        );

                    if (
                        body?.sucesso
                    ) {
                        this.abrirModalAlerta(
                            'Cliente e prefixos alterados com sucesso!',
                            'OK'
                        );

                        this.limparAlterarCliente(
                            true
                        );

                        this.buscarDadosDemonstrativo();

                        return;
                    }

                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.montarMensagemFalhas(
                            body,
                            'Erro ao alterar cliente e prefixo das vendas.'
                        ),
                        'OK'
                    );
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao alterar cliente e prefixo das vendas.'
                        ),
                        'OK'
                    );
                }
            });
    }

    abrirFinalizarVendas(): void {
        this.demonstrativoAbrirMenu = false;
        const selecionados = this.itensSelecionados();
        if (!selecionados.length) {
            this.abrirModalAlerta('Selecione ao menos uma venda para finalizar', 'OK');
            return;
        }
        this.demonstrativoModalFinalizar = true;
    }

    fecharModalFinalizar(): void {
        this.demonstrativoModalFinalizar = false;
    }

    confirmarFinalizar(): void {

        const notas =
            this.itensSelecionados()
                .map(
                    (item) =>
                        this.toNumber(
                            this.getCell(
                                item,
                                'codigo'
                            )
                        )
                )
                .filter(
                    (codigo) =>
                        codigo > 0
                );

        if (!notas.length) {
            this.abrirModalAlerta(
                'Selecione ao menos uma venda para finalizar',
                'OK'
            );

            return;
        }

        this.demonstrativoModalFinalizar =
            false;

        this.demonstrativoLoading.set(
            true
        );

        this.sankhyaGateway
            .finalizarVendasNativo({
                notas
            })
            .subscribe({
                next: (
                    response:
                    DemonstrativoFinalizacaoVendaResponse
                ) => {

                    this.demonstrativoLoading.set(
                        false
                    );

                    const resultado =
                        Array.isArray(
                            response?.resultado
                        )
                            ? response.resultado
                            : [];

                    if (!resultado.length) {

                        this.abrirModalAlerta(
                            response?.erro ||
                            'O Sankhya não retornou resultado da finalização.',
                            'OK'
                        );

                        return;
                    }

                    const mensagens =
                        resultado.map(
                            (item) => {

                                if (
                                    item.sucesso
                                ) {
                                    return `Venda ${item.nunota}: finalizada com sucesso.`;
                                }

                                let mensagem =
                                    `Venda ${item.nunota}: ${item.erro || 'não foi possível finalizar.'}`;

                                if (
                                    item.codigoErro
                                ) {
                                    mensagem +=
                                        `\nCódigo: ${item.codigoErro}`;
                                }

                                return mensagem;
                            }
                        );

                    this.abrirModalAlerta(
                        mensagens.join(
                            '\n\n'
                        ),
                        'OK'
                    );

                    /*
                     * Se alguma venda foi confirmada,
                     * atualizamos o demonstrativo.
                     *
                     * O modal continua mostrando também
                     * eventuais erros das demais.
                     */
                    const possuiSucesso =
                        resultado.some(
                            (item) =>
                                item.sucesso
                        );

                    if (
                        possuiSucesso
                    ) {
                        this.buscarDadosDemonstrativo();
                    }
                },

                error: (
                    error: unknown
                ) => {

                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao finalizar as vendas no Sankhya.'
                        ),
                        'OK'
                    );
                }
            });
    }

    abrirAjusteNotas(): void {
        this.demonstrativoAbrirMenu = false;

        try {
            this.validarStatusLegado(
                this.demonstrativoItens(),
                'Um ou mais registros nao puderam ser alterados!\nRegistro feito no AeroSys.'
            );
        } catch {
            return;
        }

        /*
         * DA TELA DO DEMONSTRATIVO PEGAMOS SOMENTE A NUNOTA.
         *
         * Nenhum valor financeiro, data, status, desconto,
         * cotacao ou total exibido na grade principal sera
         * reaproveitado para montar o modal.
         */
        const notas = this.notasSelecionadasNumericas();

        if (!notas.length) {
            this.abrirModalAlerta(
                'Selecione ao menos um registro!',
                'OK'
            );
            return;
        }

        /*
         * Limpa qualquer informação de uma abertura anterior
         * antes de consultar novamente o Sankhya.
         */
        this.demonstrativoAjuste = {
            tipo: 'DES',
            percentual: '',
            valor: ''
        };

        this.demonstrativoItensAjuste = [];
        this.demonstrativoNotaAjuste = null;
        this.demonstrativoItensNotaAjuste = [];

        this.demonstrativoAjusteTotalNovoValor = '0,00';
        this.demonstrativoAjusteTotalIpi = '0,00';
        this.demonstrativoAjusteTotalSt = '0,00';
        this.demonstrativoAjusteTotalNota = '0,00';
        this.demonstrativoAjusteTotalFaturadoDesejado = '0,00';
        this.demonstrativoTotalNotaOriginal = '0,00';
        this.demonstrativoTotalNotaNovoValor = '0,00';

        this.demonstrativoLoading.set(true);

        /*
         * Esta chamada recebe SOMENTE:
         *
         * {
         *     notas: [1981, 2137, ...]
         * }
         *
         * O backend deve recarregar tudo diretamente no Sankhya.
         */
        this.sankhyaGateway
            .buscarAjustesVendaNativo({
                notas
            })
            .subscribe({
                next: (
                    response: DemonstrativoAjustesNativosResponse
                ) => {
                    this.demonstrativoLoading.set(false);

                    const notasRetorno =
                        Array.isArray(response?.notas)
                            ? response.notas
                            : [];

                    /*
                     * Não usamos fallback para a grade do demonstrativo.
                     *
                     * Se o servidor não trouxer uma nota corretamente,
                     * ela é considerada falha.
                     */
                    const falhas =
                        notasRetorno.filter(
                            (nota) =>
                                !nota.sucesso
                        );

                    if (falhas.length) {
                        this.abrirModalAlerta(
                            falhas
                                .map(
                                    (nota) =>
                                        `Nota ${nota.nunota}: ${nota.erro || 'erro ao carregar'}`
                                )
                                .join('\n'),
                            'OK'
                        );
                        return;
                    }

                    if (!notasRetorno.length) {
                        this.abrirModalAlerta(
                            'Nenhuma venda foi carregada pelo servidor.',
                            'OK'
                        );
                        return;
                    }

                    /*
                     * Confirma que todas as NUNOTAs selecionadas
                     * voltaram do servidor.
                     */
                    const notasRecebidas =
                        new Set(
                            notasRetorno.map(
                                (nota) =>
                                    Number(nota.nunota)
                            )
                        );

                    const notasNaoRetornadas =
                        notas.filter(
                            (nunota) =>
                                !notasRecebidas.has(nunota)
                        );

                    if (notasNaoRetornadas.length) {
                        this.abrirModalAlerta(
                            `O servidor nao retornou os dados das vendas: ${notasNaoRetornadas.join(', ')}.`,
                            'OK'
                        );
                        return;
                    }

                    /*
                     * A partir daqui TODOS os campos da grade
                     * são montados usando EXCLUSIVAMENTE o retorno
                     * do servidor.
                     */
                    this.demonstrativoItensAjuste =
                        notasRetorno.map(
                            (nota) => {

                                const cotacao =
                                    Number(
                                        nota.cotacao || 0
                                    );

                                /*
                                 * IMPORTANTE:
                                 *
                                 * O resumo de desconto/acréscimo é calculado
                                 * SEMPRE pelos itens que acabaram de ser
                                 * carregados do Sankhya.
                                 *
                                 * Não usamos valor/desconto já exibido
                                 * no demonstrativo.
                                 *
                                 * Não usamos desconto de cabeçalho.
                                 */
                                const itensNativos =
                                    Array.isArray(nota.itens)
                                        ? nota.itens
                                        : [];

                                /*
                                 * TOTAL BRUTO DOS ITENS
                                 *
                                 * REAL:
                                 * SOMA TGFITE.VLRTOT
                                 *
                                 * MOEDA:
                                 * SOMA do equivalente em moeda retornado
                                 * pelo serviço nativo.
                                 */
                                const totalBrutoItens =
                                    itensNativos.reduce(
                                        (
                                            total,
                                            item
                                        ) => {

                                            const valor =
                                                this.demonstrativoTipoMoeda === 'DOLAR'
                                                    ? Number(
                                                        item.vlrTotalMoeda || 0
                                                    )
                                                    : Number(
                                                        item.vlrTotalReal || 0
                                                    );

                                            return total + valor;
                                        },
                                        0
                                    );

                                /*
                                 * DESCONTO TOTAL
                                 *
                                 * É EXCLUSIVAMENTE A SOMA DOS
                                 * DESCONTOS DOS ITENS.
                                 *
                                 * REAL:
                                 * SOMA TGFITE.VLRDESC
                                 *
                                 * MOEDA:
                                 * SOMA VLRDESCMOE retornado
                                 * pelo serviço nativo.
                                 */
                                const descontoItens =
                                    itensNativos.reduce(
                                        (
                                            total,
                                            item
                                        ) => {

                                            const valor =
                                                this.demonstrativoTipoMoeda === 'DOLAR'
                                                    ? Number(
                                                        item.vlrDescMoeda || 0
                                                    )
                                                    : Number(
                                                        item.vlrDescReal || 0
                                                    );

                                            return total + valor;
                                        },
                                        0
                                    );

                                /*
                                 * TOTAL LÍQUIDO DOS ITENS
                                 *
                                 * Não calculamos usando dados da tela.
                                 * Utilizamos o valor líquido retornado
                                 * para cada item pelo Sankhya.
                                 */
                                const totalLiquidoItens =
                                    itensNativos.reduce(
                                        (
                                            total,
                                            item
                                        ) => {

                                            const valor =
                                                this.demonstrativoTipoMoeda === 'DOLAR'
                                                    ? Number(
                                                        item.vlrTotalLiqMoeda || 0
                                                    )
                                                    : Number(
                                                        item.vlrTotalLiqReal || 0
                                                    );

                                            return total + valor;
                                        },
                                        0
                                    );

                                /*
                                 * PERCENTUAL VISUAL DA NOTA
                                 *
                                 * Não fazemos média dos percentuais
                                 * individuais dos itens.
                                 *
                                 * Exemplo:
                                 *
                                 * item 1 = 359,46 / 10%
                                 * item 2 = 332,72 / 8%
                                 * item 3 = 292,01 / 8%
                                 * item 4 = 57,19  / 8%
                                 *
                                 * percentual =
                                 *
                                 * desconto total
                                 * --------------
                                 * bruto total
                                 *
                                 * x 100
                                 */
                                const percentual =
                                    totalBrutoItens > 0
                                        ? (
                                        descontoItens /
                                        totalBrutoItens
                                    ) * 100
                                        : 0;

                                const totalIpi =
                                    this.valorMoedaAjuste(
                                        Number(nota.totalIpiReal || 0),
                                        cotacao
                                    );

                                const totalSt =
                                    this.valorMoedaAjuste(
                                        Number(nota.totalStReal || 0),
                                        cotacao
                                    );

                                const totalNota =
                                    this.valorMoedaAjuste(
                                        Number(nota.valorNotaReal || 0),
                                        cotacao
                                    );

                                return {
                                    codigo:
                                    nota.nunota,

                                    num_titulo:
                                    nota.nunota,

                                    emissao:
                                        nota.emissao || '',

                                    percentual:
                                        this.formatarMoeda(
                                            percentual
                                        ),

                                    valor:
                                        this.formatarMoeda(
                                            descontoItens
                                        ),

                                    novoValor:
                                        this.formatarMoeda(
                                            totalLiquidoItens
                                        ),

                                    ipi:
                                        this.formatarMoeda(totalIpi),

                                    st:
                                        this.formatarMoeda(totalSt),

                                    totalFaturado:
                                        this.formatarMoeda(totalNota),

                                    totalFaturadoDesejado:
                                        this.formatarMoeda(totalNota),

                                    /*
                                     * Valores internos utilizados
                                     * pelos cálculos da tela.
                                     */
                                    _valorOriginal:
                                    totalBrutoItens,

                                    _valorAnterior:
                                        this.formatarMoeda(
                                            descontoItens
                                        ),

                                    _percentualAnterior:
                                        this.formatarMoeda(
                                            percentual
                                        ),

                                    _novoValorAnterior:
                                        this.formatarMoeda(
                                            totalLiquidoItens
                                        ),

                                    _cotacao:
                                    cotacao,

                                    /*
                                     * Apenas informativo.
                                     *
                                     * Mantemos o valor da TGFCAB
                                     * disponível caso seja necessário
                                     * em outro ponto, mas ele NÃO é
                                     * usado para calcular o resumo
                                     * de desconto.
                                     */
                                    _valorNotaReal:
                                        Number(
                                            nota.valorNotaReal || 0
                                        ),

                                    _totalItensInicial:
                                        totalLiquidoItens,

                                    /*
                                     * Mantemos exatamente os itens
                                     * carregados pelo servidor.
                                     *
                                     * Ao clicar no lápis não existe
                                     * nova origem de dados diferente.
                                     */
                                    _itensNativos:
                                    itensNativos
                                };
                            }
                        );

                    this.recalcularTotaisAjuste();

                    this.recalcularCamposGeraisAjuste();

                    this.buscarLimiteDescontoVendedorAtual();

                    /*
                     * O modal só abre DEPOIS de a nova consulta
                     * ao servidor terminar.
                     */
                    this.demonstrativoModalAjusteNotas =
                        true;
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoLoading.set(false);

                    this.demonstrativoItensAjuste = [];

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao carregar desconto/acrescimo das vendas diretamente do Sankhya.'
                        ),
                        'OK'
                    );
                }
            });
    }

    fecharAjusteNotas(): void {
        this.demonstrativoModalAjusteNotas = false;
    }

    aplicarAjusteValorGeral(): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        const totalFaturado = this.totalOriginalAjuste(this.demonstrativoItensAjuste);
        const valorAjuste = this.toNumber(this.demonstrativoAjuste.valor);
        const totalNovo = this.demonstrativoAjuste.tipo === 'DES'
            ? totalFaturado - valorAjuste
            : totalFaturado + valorAjuste;
        this.aplicarAjustePorTotal(this.demonstrativoItensAjuste, totalNovo);
        this.demonstrativoItensAjuste.forEach((item) => item['_ajusteOrigem'] = 'VALOR');
    }

    async aplicarAjusteTodos(): Promise<void> {

        if (this.demonstrativoCalculandoAjusteNativo) {
            return;
        }

        if (this.demonstrativoAjuste.tipo !== 'DES') {
            this.abrirModalAlerta(
                'O cálculo nativo de acréscimo ainda precisa ser capturado no Sankhya.',
                'OK'
            );

            return;
        }

        const percentual =
            this.toNumber(
                this.demonstrativoAjuste.percentual
            );

        if (
            percentual < 0 ||
            percentual > 100
        ) {
            this.abrirModalAlerta(
                'Percentual de desconto inválido.',
                'OK'
            );

            return;
        }

        /*
         * A primeira tela é apenas visual.
         *
         * O desconto é realmente calculado nos itens
         * através do CACSP.calculaValoresItemNota.
         */
        this.demonstrativoCalculandoAjusteNativo =
            true;

        this.demonstrativoLoading.set(
            true
        );

        try {

            /*
             * Percorre nota por nota.
             */
            for (
                const nota of
                this.demonstrativoItensAjuste
                ) {

                const nunota =
                    this.toNumber(
                        String(
                            nota['codigo'] ||
                            ''
                        )
                    );

                if (!nunota) {
                    throw new Error(
                        'NUNOTA não localizada para cálculo do desconto.'
                    );
                }

                const cotacao =
                    Number(
                        nota['_cotacao'] ||
                        0
                    );

                const itensNativos =
                    Array.isArray(
                        nota['_itensNativos']
                    )
                        ? nota['_itensNativos'] as DemonstrativoAjusteItemNativo[]
                        : [];

                if (!itensNativos.length) {
                    throw new Error(
                        `Nenhum item localizado para a nota ${nunota}.`
                    );
                }

                /*
                 * IMPORTANTE:
                 *
                 * Processamento sequencial.
                 *
                 * Não usamos Promise.all porque cada item deve
                 * concluir seu recálculo nativo antes de seguir.
                 */
                for (
                    const itemNativo of
                    itensNativos
                    ) {

                    const sequencia =
                        Number(
                            itemNativo.sequencia ||
                            0
                        );

                    if (!sequencia) {
                        throw new Error(
                            `Sequência de item não localizada na nota ${nunota}.`
                        );
                    }

                    if (!itemNativo.itemNativo) {
                        throw new Error(
                            `Dados nativos do item ${sequencia} da nota ${nunota} não foram carregados.`
                        );
                    }

                    /*
                     * Percentual atualmente confirmado
                     * pelo Sankhya.
                     */
                    const percentualAnterior =
                        Number(
                            itemNativo.percDesc ||
                            0
                        );

                    const response =
                        await firstValueFrom(
                            this.sankhyaGateway
                                .calcularPercentualAjusteVendaNativo({
                                    NUNOTA:
                                    nunota,

                                    SEQUENCIA:
                                    sequencia,

                                    PERCDESC:
                                    percentual,

                                    VLRANTERIORCAMPO:
                                    percentualAnterior,

                                    VLRMOEDA:
                                    cotacao,

                                    itemNativo: {
                                        ...itemNativo.itemNativo
                                    }
                                })
                        );

                    if (!response?.sucesso) {
                        throw new Error(
                            `O Sankhya não conseguiu calcular o item ${sequencia} da nota ${nunota}.`
                        );
                    }

                    /*
                     * Atualiza o próprio item interno da nota
                     * com o retorno NATIVO do Sankhya.
                     */
                    itemNativo.percDesc =
                        Number(
                            response.percDesc ||
                            0
                        );

                    itemNativo.vlrDescReal =
                        Number(
                            response.vlrDescReal ||
                            0
                        );

                    itemNativo.vlrDescMoeda =
                        Number(
                            response.vlrDescMoeda ||
                            0
                        );

                    itemNativo.vlrTotalLiqReal =
                        Number(
                            response.vlrTotalLiqReal ||
                            0
                        );

                    itemNativo.vlrTotalLiqMoeda =
                        Number(
                            response.vlrTotalLiqMoeda ||
                            0
                        );

                    itemNativo.vlrUnitLiqReal =
                        Number(
                            response.vlrUnitLiqReal ||
                            0
                        );

                    itemNativo.vlrUnitLiqMoeda =
                        Number(
                            response.vlrUnitLiqMoeda ||
                            0
                        );

                    /*
                     * Este é o ITEM que posteriormente será
                     * enviado para incluirAlterarItemNota.
                     */
                    itemNativo.itemNativo = {
                        ...(response.itemNativo || {})
                    };
                }

                /*
                 * Terminou todos os itens desta nota.
                 *
                 * Agora atualiza somente o RESUMO VISUAL
                 * da primeira tela.
                 */
                this.atualizarResumoAjusteNotaPorItensNativos(
                    nota
                );
            }

            /*
             * Somente depois de terminar TODAS as notas
             * recalculamos os totais gerais da primeira tela.
             */
            this.recalcularTotaisAjuste();

            this.recalcularCamposGeraisAjuste();

        } catch (
            error: unknown
            ) {

            this.abrirModalAlerta(
                error instanceof Error
                    ? error.message
                    : 'Erro ao recalcular os descontos dos itens no Sankhya.',
                'OK'
            );

        } finally {

            /*
             * Só libera nova edição depois de todo o FOR
             * terminar, inclusive em caso de erro.
             */
            this.demonstrativoCalculandoAjusteNativo =
                false;

            this.demonstrativoLoading.set(
                false
            );
        }
    }

    private atualizarResumoAjusteNotaPorItensNativos(
        nota: Record<string, any>
    ): void {

        const itens =
            Array.isArray(
                nota['_itensNativos']
            )
                ? nota['_itensNativos'] as DemonstrativoAjusteItemNativo[]
                : [];

        const totalBruto =
            itens.reduce(
                (
                    total,
                    item
                ) => {

                    return total +
                        (
                            this.demonstrativoTipoMoeda === 'DOLAR'
                                ? Number(
                                    item.vlrTotalMoeda ||
                                    0
                                )
                                : Number(
                                    item.vlrTotalReal ||
                                    0
                                )
                        );
                },
                0
            );

        const totalDesconto =
            itens.reduce(
                (
                    total,
                    item
                ) => {

                    return total +
                        (
                            this.demonstrativoTipoMoeda === 'DOLAR'
                                ? Number(
                                    item.vlrDescMoeda ||
                                    0
                                )
                                : Number(
                                    item.vlrDescReal ||
                                    0
                                )
                        );
                },
                0
            );

        const totalLiquido =
            itens.reduce(
                (
                    total,
                    item
                ) => {

                    return total +
                        (
                            this.demonstrativoTipoMoeda === 'DOLAR'
                                ? Number(
                                    item.vlrTotalLiqMoeda ||
                                    0
                                )
                                : Number(
                                    item.vlrTotalLiqReal ||
                                    0
                                )
                        );
                },
                0
            );

        const percentual =
            totalBruto > 0
                ? (
                totalDesconto /
                totalBruto
            ) * 100
                : 0;

        /*
         * Somente apresentação.
         */
        nota['faturado'] =
            this.formatarMoeda(
                totalBruto
            );

        nota['percentual'] =
            this.formatarMoeda(
                percentual
            );

        nota['valor'] =
            this.formatarMoeda(
                totalDesconto
            );

        nota['novoValor'] =
            this.formatarMoeda(
                totalLiquido
            );

        this.atualizarTotalFaturadoNota(
            nota,
            totalLiquido
        );

        nota['_valorOriginal'] =
            totalBruto;

        nota['_valorAnterior'] =
            this.formatarMoeda(
                totalDesconto
            );

        nota['_percentualAnterior'] =
            this.formatarMoeda(
                percentual
            );

        nota['_novoValorAnterior'] =
            this.formatarMoeda(
                totalLiquido
            );
    }

    aplicarAjusteItem(item: Record<string, any>): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        item['_ajusteOrigem'] = 'PERCENTUAL';
        const original = this.valorOriginalItem(item);
        const valor = original * (this.toNumber(String(item['percentual'] || '')) / 100);
        const novoValor = this.demonstrativoAjuste.tipo === 'DES' ? original - valor : original + valor;
        this.aplicarNovoValorCalculadoItem(item, novoValor);
        this.recalcularTotaisAjuste();
    }

    aplicarAjusteValorItem(item: Record<string, any>): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        item['_ajusteOrigem'] = 'VALOR';
        const original = this.valorOriginalItem(item);
        const valor = this.toNumber(String(item['valor'] || ''));
        const novoValor = this.demonstrativoAjuste.tipo === 'DES' ? original - valor : original + valor;
        this.aplicarNovoValorCalculadoItem(item, novoValor);
        this.recalcularTotaisAjuste();
    }

    aplicarNovoValorItem(item: Record<string, any>): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        item['_ajusteOrigem'] = 'NOVO_VALOR';
        const alvoFaturado = this.toNumberValorMonetario(String(item['totalFaturadoDesejado'] || ''));
        const faturadoAtual = this.toNumber(String(item['totalFaturado'] || ''));
        const totalItensAtual = this.totalLiquidoAjusteNota(item);
        const alvo = this.round2(totalItensAtual + (alvoFaturado - faturadoAtual));
        const bruto = this.valorOriginalItem(item);

        const alvoFaturadoInvalido = this.demonstrativoAjuste.tipo === 'DES'
            ? alvoFaturado < 0
            : false;
        const alvoItensInvalido = this.demonstrativoAjuste.tipo === 'DES'
            ? alvo < 0 || alvo > bruto
            : alvo < bruto;

        if (alvoFaturadoInvalido || alvoItensInvalido) {
            this.abrirModalAlerta('Valor final invalido para desconto/acrescimo.', 'OK');
            item['totalFaturadoDesejado'] = this.formatarMoeda(faturadoAtual);
            return;
        }

        this.aplicarNovoValorCalculadoItem(item, alvo);
        this.recalcularTotaisAjuste();
        if (this.demonstrativoAjuste.tipo === 'DES') {
            void this.calcularNotaPorValorExato(item, alvo);
        }
    }

    private totalLiquidoAjusteNota(nota: Record<string, any>): number {
        const itens = Array.isArray(nota['_itensNativos'])
            ? nota['_itensNativos'] as DemonstrativoAjusteItemNativo[]
            : [];
        return itens.reduce((total, item) => total + Number(
            this.demonstrativoTipoMoeda === 'DOLAR' ? item.vlrTotalLiqMoeda : item.vlrTotalLiqReal
        ), 0);
    }

    private totalBrutoAjusteNota(nota: Record<string, any>): number {
        const itens = Array.isArray(nota['_itensNativos'])
            ? nota['_itensNativos'] as DemonstrativoAjusteItemNativo[]
            : [];
        return this.round2(itens.reduce((total, item) => total + Number(
            this.demonstrativoTipoMoeda === 'DOLAR' ? item.vlrTotalMoeda : item.vlrTotalReal
        ), 0));
    }

    private toNumberValorMonetario(value: string): number {
        const texto = String(value || '').trim().replace(/[^\d,.-]/g, '');
        if (!texto) return 0;

        if (texto.includes(',')) {
            return Number(texto.replace(/\./g, '').replace(',', '.')) || 0;
        }

        const sinal = texto.startsWith('-') ? '-' : '';
        const semSinal = texto.replace(/^[+-]/, '');
        if (/^\d{1,3}(?:\.\d{3})+$/.test(semSinal)) {
            return Number(`${sinal}${semSinal.replace(/\./g, '')}`) || 0;
        }

        return Number(texto) || 0;
    }

    private async calcularNotaPorValorExato(nota: Record<string, any>, alvo: number): Promise<void> {
        this.demonstrativoCalculandoAjusteNativo = true;
        this.demonstrativoLoading.set(true);
        try {
            const resultado = await this.calcularItensNotaPorValorExato(nota, alvo);
            nota['_itensNativos'] = resultado.retorno;
            this.atualizarResumoAjusteNotaPorItensNativos(nota);
            this.recalcularTotaisAjuste();
            this.recalcularCamposGeraisAjuste();
            if (!resultado.atingiu) this.informarDiferencaAjuste(alvo, resultado.valor);
        } catch (erro) {
            this.atualizarResumoAjusteNotaPorItensNativos(nota);
            this.recalcularTotaisAjuste();
            this.abrirModalAlerta(this.erroMensagem(erro, 'Erro ao calcular o valor desejado no Sankhya.'), 'OK');
        } finally {
            this.demonstrativoCalculandoAjusteNativo = false;
            this.demonstrativoLoading.set(false);
        }
    }

    private async calcularItensNotaPorValorExato(
        nota: Record<string, any>,
        alvo: number
    ): Promise<ResultadoAjusteExato<DemonstrativoAjusteItemNativo[]>> {
        let itens: DemonstrativoAjusteItemNativo[] = (nota['_itensNativos'] || []).map(
            (item: DemonstrativoAjusteItemNativo) => ({...item, itemNativo: {...item.itemNativo}})
        );
        if (!itens.length) throw new Error('Itens nativos da venda nao foram carregados.');
        const dolar = this.demonstrativoTipoMoeda === 'DOLAR';
        const bruto = this.totalBrutoAjusteNota(nota);
        return ajustarValorExato(alvo, bruto, (bruto - alvo) * 100 / bruto,
            async percentual => {
                const novos: DemonstrativoAjusteItemNativo[] = [];
                for (const item of itens) {
                    const retorno = await firstValueFrom(this.sankhyaGateway.calcularPercentualAjusteVendaNativo({
                        NUNOTA: Number(nota['codigo']), SEQUENCIA: item.sequencia,
                        PERCDESC: percentual, VLRANTERIORCAMPO: item.percDesc,
                        VLRMOEDA: Number(nota['_cotacao'] || 0), itemNativo: {...item.itemNativo}
                    }));
                    if (!retorno?.sucesso || !retorno.itemNativo) throw new Error('Falha no recalculo nativo da venda.');
                    novos.push({...item, ...retorno, itemNativo: {...retorno.itemNativo}});
                }
                itens = novos;
                return novos;
            }, retorno => retorno.reduce((total, item) => total + Number(
                dolar ? item.vlrTotalLiqMoeda : item.vlrTotalLiqReal
            ), 0));
    }

    private informarDiferencaAjuste(alvo: number, obtido: number): void {
        this.abrirModalAlerta(`Apos 3 tentativas, o Sankhya nao atingiu o valor solicitado de ${this.formatarMoeda(alvo)}. ` +
            `Valor calculado: ${this.formatarMoeda(obtido)}. Diferenca: ${this.formatarMoeda(obtido - alvo)}. Confira antes de salvar.`, 'OK');
    }

    async aplicarNovoValorTotal(): Promise<void> {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        if (this.demonstrativoAjuste.tipo !== 'DES') {
            this.demonstrativoAjusteTotalFaturadoDesejado = this.demonstrativoAjusteTotalNota;
            this.abrirModalAlerta(
                'O calculo nativo de acrescimo ainda precisa ser capturado no Sankhya.',
                'OK'
            );
            return;
        }

        const notas = this.demonstrativoItensAjuste;
        if (!notas.length) return;

        const totalFaturadoAlvo = this.toNumberValorMonetario(this.demonstrativoAjusteTotalFaturadoDesejado);
        const totalFaturadoAtual = notas.reduce(
            (total, nota) => total + this.toNumber(String(nota['totalFaturado'] || '')),
            0
        );

        for (const nota of notas) {
            const itemJaFaturado = ((nota['_itensNativos'] || []) as DemonstrativoAjusteItemNativo[])
                .find(item => this.toNumber(String(item.itemNativo?.['QTDENTREGUE'] || '0')) > 0);
            if (!itemJaFaturado) continue;

            this.demonstrativoAjusteTotalFaturadoDesejado = this.formatarMoeda(totalFaturadoAtual);
            const codigoProduto = itemJaFaturado.codProd || itemJaFaturado.itemNativo?.['CODPROD'] || 'desconhecido';
            const quantidadeEntregue = itemJaFaturado.itemNativo?.['QTDENTREGUE'] || '0';
            this.abrirModalAlerta(
                `O Sankhya não permite alterar o produto ${codigoProduto} da venda ${nota['codigo']} porque ele já foi faturado (quantidade entregue: ${quantidadeEntregue}). Remova essa venda da seleção para recalcular o total.`,
                'OK'
            );
            return;
        }

        const totaisItensAtuais = notas.map(nota => this.round2(this.totalLiquidoAjusteNota(nota)));
        const totaisItensBrutos = notas.map(nota => this.totalBrutoAjusteNota(nota));
        const totalItensAlvo = this.round2(
            totaisItensAtuais.reduce((total, valor) => total + valor, 0) +
            (totalFaturadoAlvo - totalFaturadoAtual)
        );
        const totalItensBrutos = totaisItensBrutos.reduce((total, valor) => total + valor, 0);

        if (totalFaturadoAlvo < 0 || totalItensAlvo < 0 || totalItensAlvo > totalItensBrutos) {
            this.demonstrativoAjusteTotalFaturadoDesejado = this.formatarMoeda(totalFaturadoAtual);
            this.abrirModalAlerta('Valor final faturado invalido para o desconto selecionado.', 'OK');
            return;
        }

        this.demonstrativoCalculandoAjusteNativo = true;
        this.demonstrativoLoading.set(true);
        try {
            if (notas.some(nota => !Array.isArray(nota['_itensNativos']) || !nota['_itensNativos'].length)) {
                throw new Error('Itens nativos de uma ou mais vendas nao foram carregados.');
            }

            let itensPorNota = notas.map(nota => ({
                nota,
                itens: ((nota['_itensNativos'] || []) as DemonstrativoAjusteItemNativo[])
                    .map(item => ({...item, itemNativo: {...item.itemNativo}}))
            }));
            const percentualInicial = (totalItensBrutos - totalItensAlvo) * 100 / totalItensBrutos;
            const resultado = await ajustarValorExato(
                totalFaturadoAlvo,
                totalItensBrutos,
                percentualInicial,
                async percentual => {
                    const novosPorNota: typeof itensPorNota = [];

                    // Um único percentual é recalculado item a item, em todas as vendas.
                    for (const {nota, itens} of itensPorNota) {
                        const nunota = Number(nota['codigo']);
                        const cotacao = Number(nota['_cotacao'] || 0);
                        const novosItens: DemonstrativoAjusteItemNativo[] = [];

                        for (const item of itens) {
                            const retorno = await firstValueFrom(
                                this.sankhyaGateway.calcularPercentualAjusteVendaNativo({
                                    NUNOTA: nunota,
                                    SEQUENCIA: item.sequencia,
                                    PERCDESC: percentual,
                                    VLRANTERIORCAMPO: Number(item.percDesc || 0),
                                    VLRMOEDA: cotacao,
                                    itemNativo: {...item.itemNativo}
                                })
                            );

                            if (!retorno?.sucesso || !retorno.itemNativo) {
                                throw new Error(`Falha no recalculo nativo do item ${item.sequencia} da venda ${nunota}.`);
                            }

                            novosItens.push({...item, ...retorno, itemNativo: {...retorno.itemNativo}});
                        }

                        novosPorNota.push({nota, itens: novosItens});
                    }

                    itensPorNota = novosPorNota;
                    return novosPorNota;
                },
                retorno => retorno.reduce((total, {nota, itens}) => {
                    const totalLiquido = itens.reduce((soma, item) => soma + Number(
                        this.demonstrativoTipoMoeda === 'DOLAR' ? item.vlrTotalLiqMoeda : item.vlrTotalLiqReal
                    ), 0);
                    const totalInicial = Number(nota['_totalItensInicial'] ?? totalLiquido);
                    const totalNotaOriginal = this.valorMoedaAjuste(
                        Number(nota['_valorNotaReal'] || 0),
                        Number(nota['_cotacao'] || 0)
                    );
                    return total + this.round2(totalNotaOriginal + (totalLiquido - totalInicial));
                }, 0),
                Math.max(totalItensBrutos, totalFaturadoAlvo)
            );

            for (const {nota, itens} of resultado.retorno) {
                nota['_itensNativos'] = itens;
                nota['_ajusteOrigem'] = 'NOVO_VALOR';
                this.atualizarResumoAjusteNotaPorItensNativos(nota);
            }

            this.recalcularTotaisAjuste();
            this.recalcularCamposGeraisAjuste();

            const totalFaturadoObtido = this.toNumber(this.demonstrativoAjusteTotalNota);
            if (!resultado.atingiu || Math.round(totalFaturadoObtido * 100) !== Math.round(totalFaturadoAlvo * 100)) {
                this.informarDiferencaAjuste(totalFaturadoAlvo, totalFaturadoObtido);
            }
        } catch (erro) {
            this.demonstrativoAjusteTotalFaturadoDesejado = this.formatarMoeda(totalFaturadoAtual);
            this.abrirModalAlerta(
                this.erroMensagem(erro, 'Erro ao recalcular os descontos nativos das vendas selecionadas.'),
                'OK'
            );
        } finally {
            this.demonstrativoCalculandoAjusteNativo = false;
            this.demonstrativoLoading.set(false);
        }
    }

    abrirAjusteNotaIndividual(
        item: Record<string, any>
    ): void {

        if (
            this.isNotaFinalizada(
                item
            )
        ) {
            this.abrirModalAlerta(
                'Desconto / acrescimo so pode ser aplicado em notas nao finalizadas.',
                'OK'
            );

            return;
        }

        const itensNativos =
            Array.isArray(
                item['_itensNativos']
            )
                ? item['_itensNativos'] as DemonstrativoAjusteItemNativo[]
                : [];

        if (!itensNativos.length) {
            this.abrirModalAlerta(
                'Nenhum item localizado para esta venda.',
                'OK'
            );

            return;
        }

        this.demonstrativoNotaAjuste =
            item;

        this.demonstrativoItensNotaAjuste =
            itensNativos.map(
                (
                    itemNativo:
                    DemonstrativoAjusteItemNativo
                ) => {

                    const vlrUnit =
                        this.demonstrativoTipoMoeda === 'DOLAR'
                            ? Number(
                                itemNativo.vlrUnitMoeda || 0
                            )
                            : Number(
                                itemNativo.vlrUnitReal || 0
                            );

                    const vlrTotal =
                        this.demonstrativoTipoMoeda === 'DOLAR'
                            ? Number(
                                itemNativo.vlrTotalMoeda || 0
                            )
                            : Number(
                                itemNativo.vlrTotalReal || 0
                            );

                    const valorDesconto =
                        this.demonstrativoTipoMoeda === 'DOLAR'
                            ? Number(
                                itemNativo.vlrDescMoeda || 0
                            )
                            : Number(
                                itemNativo.vlrDescReal || 0
                            );

                    const novoValor =
                        this.demonstrativoTipoMoeda === 'DOLAR'
                            ? Number(
                                itemNativo.vlrTotalLiqMoeda || 0
                            )
                            : Number(
                                itemNativo.vlrTotalLiqReal || 0
                            );

                    const percentual =
                        Number(
                            itemNativo.percDesc || 0
                        );

                    return {
                        codigo:
                        itemNativo.nunota,

                        sequencia:
                        itemNativo.sequencia,

                        codProd:
                        itemNativo.codProd,

                        codVol:
                        itemNativo.codVol,

                        qtd:
                        itemNativo.qtd,

                        partnumber:
                        itemNativo.partnumber,

                        produto:
                        itemNativo.produto,

                        vlrUnit:
                            this.formatarMoeda(
                                vlrUnit
                            ),

                        vlrTotal:
                            this.formatarMoeda(
                                novoValor
                            ),

                        percentual:
                            this.formatarMoeda(
                                percentual
                            ),

                        valor:
                            this.formatarMoeda(
                                valorDesconto
                            ),

                        novoValor:
                            this.formatarMoeda(
                                novoValor
                            ),

                        /*
                         * Valores reais originais.
                         */
                        _vlrUnitReal:
                            Number(
                                itemNativo.vlrUnitReal || 0
                            ),

                        _vlrUnitMoeda:
                            Number(
                                itemNativo.vlrUnitMoeda || 0
                            ),

                        _vlrTotalReal:
                            Number(
                                itemNativo.vlrTotalReal || 0
                            ),

                        _vlrTotalMoeda:
                            Number(
                                itemNativo.vlrTotalMoeda || 0
                            ),

                        _vlrDescReal:
                            Number(
                                itemNativo.vlrDescReal || 0
                            ),

                        _vlrDescMoeda:
                            Number(
                                itemNativo.vlrDescMoeda || 0
                            ),

                        _vlrTotalLiqReal:
                            Number(
                                itemNativo.vlrTotalLiqReal || 0
                            ),

                        _vlrTotalLiqMoeda:
                            Number(
                                itemNativo.vlrTotalLiqMoeda || 0
                            ),

                        /*
                         * É FUNDAMENTAL preservar o item completo
                         * carregado pelo DatasetSP.
                         *
                         * Ele será reutilizado por:
                         *
                         * CACSP.calculaValoresItemNota
                         * CACSP.incluirAlterarItemNota
                         */
                        _itemNativo: {
                            ...itemNativo.itemNativo
                        },

                        _percDescNativo:
                        percentual,

                        _alterado:
                            false,

                        _valorOriginal:
                        vlrTotal,

                        _valorInicial:
                            this.formatarMoeda(
                                valorDesconto
                            ),

                        _percentualInicial:
                            this.formatarMoeda(
                                percentual
                            ),

                        _novoValorInicial:
                            this.formatarMoeda(
                                novoValor
                            )
                    };
                }
            );

        this.recalcularTotaisAjusteNotaIndividual();

        this.demonstrativoModalAjusteNotas =
            false;

        this.demonstrativoModalAjusteNotaIndividual =
            true;
    }

    private calcularPercentualItemNativo(
        item: Record<string, any>,
        percentual: number,
        valorAlvo?: number
    ): void {

        if (this.demonstrativoCalculandoAjusteNativo) {
            return;
        }

        if (!item['_itemNativo']) {
            this.abrirModalAlerta(
                'Dados nativos do item não foram carregados.',
                'OK'
            );

            return;
        }

        /*
         * O payload capturado do Sankhya que já validamos
         * trabalha com PERCDESC.
         *
         * Para acréscimo ainda não temos um payload nativo
         * capturado que possa ser reproduzido com segurança.
         */
        if (this.demonstrativoAjuste.tipo !== 'DES') {
            this.abrirModalAlerta(
                'O cálculo nativo de acréscimo ainda precisa ser capturado no Sankhya antes de ser habilitado.',
                'OK'
            );

            return;
        }

        const nunota =
            this.toNumber(
                String(
                    item['codigo'] ||
                    this.demonstrativoNotaAjuste?.['codigo'] ||
                    ''
                )
            );

        const sequencia =
            this.toNumber(
                String(
                    item['sequencia'] ||
                    ''
                )
            );

        if (
            !nunota ||
            !sequencia
        ) {
            this.abrirModalAlerta(
                'NUNOTA ou sequência do item não localizada.',
                'OK'
            );

            return;
        }

        const cotacao =
            Number(
                this.demonstrativoNotaAjuste?.['_cotacao'] ||
                0
            );

        if (valorAlvo !== undefined) {
            void this.calcularProdutoPorValorExato(item, percentual, valorAlvo, nunota, sequencia, cotacao);
            return;
        }

        /*
         * VLRANTERIORCAMPO corresponde ao valor anterior
         * de PERCDESC antes da alteração.
         */
        const percentualAnterior =
            Number(
                item['_percDescNativo'] ||
                0
            );

        this.demonstrativoCalculandoAjusteNativo =
            true;

        this.demonstrativoLoading.set(
            true
        );

        this.sankhyaGateway
            .calcularPercentualAjusteVendaNativo({
                NUNOTA:
                nunota,

                SEQUENCIA:
                sequencia,

                PERCDESC:
                percentual,

                VLRANTERIORCAMPO:
                percentualAnterior,

                /*
                 * A captura real do Sankhya mostrou VLRMOEDA
                 * recebendo a cotação da nota.
                 */
                VLRMOEDA:
                cotacao,

                itemNativo: {
                    ...item['_itemNativo']
                }
            })
            .subscribe({
                next: (
                    response:
                    DemonstrativoCalculoAjusteNativoResponse
                ) => {

                    if (
                        !response?.sucesso
                    ) {
                        this.demonstrativoCalculandoAjusteNativo =
                            false;

                        this.demonstrativoLoading.set(
                            false
                        );

                        this.abrirModalAlerta(
                            'O Sankhya não conseguiu calcular o desconto do item.',
                            'OK'
                        );

                        return;
                    }

                    this.aplicarRetornoCalculoNativoItem(
                        item,
                        response
                    );

                    this.recalcularTotaisAjusteNotaIndividual();

                    this.atualizarNotaAjustePelosItens();

                    this.recalcularTotaisAjuste();

                    this.demonstrativoCalculandoAjusteNativo =
                        false;

                    this.demonstrativoLoading.set(
                        false
                    );
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoCalculandoAjusteNativo =
                        false;

                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao calcular o desconto do item no Sankhya.'
                        ),
                        'OK'
                    );
                }
            });
    }

    private async calcularProdutoPorValorExato(item: Record<string, any>, percentual: number,
                                               alvo: number, nunota: number, sequencia: number, cotacao: number): Promise<void> {
        this.demonstrativoCalculandoAjusteNativo = true;
        this.demonstrativoLoading.set(true);
        try {
            let nativo = {...item['_itemNativo']};
            let anterior = Number(item['_percDescNativo'] || 0);
            const dolar = this.demonstrativoTipoMoeda === 'DOLAR';
            const resultado = await ajustarValorExato(alvo, this.valorOriginalItem(item), percentual,
                async valorPercentual => {
                    const retorno = await firstValueFrom(this.sankhyaGateway.calcularPercentualAjusteVendaNativo({
                        NUNOTA: nunota, SEQUENCIA: sequencia, PERCDESC: valorPercentual,
                        VLRANTERIORCAMPO: anterior, VLRMOEDA: cotacao, itemNativo: nativo
                    }));
                    if (!retorno?.sucesso || !retorno.itemNativo) throw new Error('Falha no recalculo nativo do item.');
                    nativo = {...retorno.itemNativo};
                    anterior = retorno.percDesc;
                    return retorno;
                }, retorno => Number(dolar ? retorno.vlrTotalLiqMoeda : retorno.vlrTotalLiqReal));
            this.aplicarRetornoCalculoNativoItem(item, resultado.retorno);
            this.recalcularTotaisAjusteNotaIndividual();
            this.atualizarNotaAjustePelosItens();
            this.recalcularTotaisAjuste();
            if (!resultado.atingiu) this.informarDiferencaAjuste(alvo, resultado.valor);
        } catch (erro) {
            item['novoValor'] = this.formatarMoeda(Number(this.demonstrativoTipoMoeda === 'DOLAR'
                ? item['_vlrTotalLiqMoeda'] : item['_vlrTotalLiqReal']));
            this.abrirModalAlerta(this.erroMensagem(erro, 'Erro ao calcular o valor desejado no Sankhya.'), 'OK');
        } finally {
            this.demonstrativoCalculandoAjusteNativo = false;
            this.demonstrativoLoading.set(false);
        }
    }

    private aplicarRetornoCalculoNativoItem(
        item: Record<string, any>,
        response: DemonstrativoCalculoAjusteNativoResponse
    ): void {

        const percentual =
            Number(
                response.percDesc ||
                0
            );

        const vlrDescReal =
            Number(
                response.vlrDescReal ||
                0
            );

        const vlrDescMoeda =
            Number(
                response.vlrDescMoeda ||
                0
            );

        const vlrTotalLiqReal =
            Number(
                response.vlrTotalLiqReal ||
                0
            );

        const vlrTotalLiqMoeda =
            Number(
                response.vlrTotalLiqMoeda ||
                0
            );

        const vlrUnitLiqReal =
            Number(
                response.vlrUnitLiqReal ||
                0
            );

        const vlrUnitLiqMoeda =
            Number(
                response.vlrUnitLiqMoeda ||
                0
            );

        item['_percDescNativo'] =
            percentual;

        item['_vlrDescReal'] =
            vlrDescReal;

        item['_vlrDescMoeda'] =
            vlrDescMoeda;

        item['_vlrTotalLiqReal'] =
            vlrTotalLiqReal;

        item['_vlrTotalLiqMoeda'] =
            vlrTotalLiqMoeda;

        item['_vlrUnitLiqReal'] =
            vlrUnitLiqReal;

        item['_vlrUnitLiqMoeda'] =
            vlrUnitLiqMoeda;

        /*
         * O backend deve devolver o ITEM já atualizado
         * com os valores retornados por
         * CACSP.calculaValoresItemNota.
         */
        item['_itemNativo'] = {
            ...response.itemNativo
        };

        item['_alterado'] =
            true;

        item['percentual'] =
            this.formatarMoeda(
                percentual
            );

        if (
            this.demonstrativoTipoMoeda === 'DOLAR'
        ) {
            item['valor'] =
                this.formatarMoeda(
                    vlrDescMoeda
                );

            item['novoValor'] =
                this.formatarMoeda(
                    vlrTotalLiqMoeda
                );

        } else {
            item['valor'] =
                this.formatarMoeda(
                    vlrDescReal
                );

            item['novoValor'] =
                this.formatarMoeda(
                    vlrTotalLiqReal
                );
        }
    }

    fecharAjusteNotaIndividual(): void {
        if (this.existeAlteracaoAjusteNotaIndividual()) {
            this.exibirConfirmacao(
                'Deseja descartar as alteracoes dos itens?',
                'Descartar',
                'Cancelar',
                () => this.fecharAjusteNotaIndividualConfirmado()
            );
            return;
        }

        this.fecharAjusteNotaIndividualConfirmado();
    }

    private fecharAjusteNotaIndividualConfirmado(): void {
        this.demonstrativoModalAjusteNotaIndividual = false;
    }

    voltarParaAjusteNotas(): void {
        if (this.existeAlteracaoAjusteNotaIndividual()) {
            this.exibirConfirmacao(
                'Deseja descartar as alteracoes dos itens?',
                'Descartar',
                'Cancelar',
                () => this.voltarParaAjusteNotasConfirmado(false)
            );
            return;
        }

        this.voltarParaAjusteNotasConfirmado(true);
    }

    private voltarParaAjusteNotasConfirmado(aplicarItensNoResumo: boolean): void {
        if (aplicarItensNoResumo) {
            this.atualizarNotaAjustePelosItens();
        }

        this.demonstrativoModalAjusteNotaIndividual = false;
        this.demonstrativoModalAjusteNotas = true;
        this.recalcularTotaisAjuste();
        this.recalcularCamposGeraisAjuste();
    }

    aplicarAjusteItemNotaPercentual(
        item: Record<string, any>
    ): void {

        if (this.demonstrativoCalculandoAjusteNativo) {
            return;
        }

        item['_ajusteOrigem'] =
            'PERCENTUAL';

        const percentual =
            this.toNumber(
                String(
                    item['percentual'] ||
                    ''
                )
            );

        if (
            percentual < 0 ||
            percentual > 100
        ) {
            this.abrirModalAlerta(
                'Percentual de desconto inválido.',
                'OK'
            );

            item['percentual'] =
                item['_percentualInicial'] ||
                '0,00';

            return;
        }

        this.calcularPercentualItemNativo(
            item,
            percentual
        );
    }

    aplicarAjusteItemNotaValor(
        item: Record<string, any>
    ): void {

        if (this.demonstrativoCalculandoAjusteNativo) {
            return;
        }

        item['_ajusteOrigem'] =
            'VALOR';

        if (
            this.demonstrativoAjuste.tipo !== 'DES'
        ) {
            this.abrirModalAlerta(
                'O cálculo nativo de acréscimo ainda precisa ser capturado no Sankhya.',
                'OK'
            );

            return;
        }

        const valorOriginal =
            this.valorOriginalItem(
                item
            );

        const valorDesconto =
            this.toNumber(
                String(
                    item['valor'] ||
                    ''
                )
            );

        if (
            valorDesconto < 0 ||
            valorDesconto > valorOriginal
        ) {
            this.abrirModalAlerta(
                'Valor de desconto inválido.',
                'OK'
            );

            return;
        }

        const percentual =
            valorOriginal > 0
                ? (
                valorDesconto /
                valorOriginal
            ) * 100
                : 0;

        this.calcularPercentualItemNativo(
            item,
            percentual
        );
    }

    aplicarNovoValorItemNota(
        item: Record<string, any>
    ): void {

        if (this.demonstrativoCalculandoAjusteNativo) {
            return;
        }

        item['_ajusteOrigem'] =
            'NOVO_VALOR';

        if (
            this.demonstrativoAjuste.tipo !== 'DES'
        ) {
            this.abrirModalAlerta(
                'O cálculo nativo de acréscimo ainda precisa ser capturado no Sankhya.',
                'OK'
            );

            return;
        }

        const valorOriginal =
            this.valorOriginalItem(
                item
            );

        const novoValor =
            this.toNumber(
                String(
                    item['novoValor'] ||
                    ''
                )
            );

        if (
            novoValor < 0 ||
            novoValor > valorOriginal
        ) {
            this.abrirModalAlerta(
                'Novo valor inválido para desconto.',
                'OK'
            );

            return;
        }

        const valorDesconto =
            valorOriginal -
            novoValor;

        const percentual =
            valorOriginal > 0
                ? (
                valorDesconto /
                valorOriginal
            ) * 100
                : 0;

        this.calcularPercentualItemNativo(
            item,
            percentual,
            novoValor
        );
    }

    salvarAjusteNotas(): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        this.demonstrativoModalAjusteNotas = false;
        this.exibirConfirmacao(
            'Deseja realmente salvar o desconto / acrescimo nas notas selecionadas?',
            'Salvar',
            'Cancelar',
            () => this.confirmarSalvarAjusteNotas()
        );
    }

    confirmarSalvarAjusteNotas(): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;

        const itensSalvar:
            Array<{
                NUNOTA: number;
                SEQUENCIA: number;
                itemNativo: Record<string, string>;
            }> = [];

        for (
            const nota of
            this.demonstrativoItensAjuste
            ) {

            const itens =
                Array.isArray(
                    nota['_itensNativos']
                )
                    ? nota['_itensNativos'] as DemonstrativoAjusteItemNativo[]
                    : [];

            for (
                const item of
                itens
                ) {

                /*
                 * Neste momento só enviamos itens cujo
                 * itemNativo tenha sido recalculado.
                 *
                 * O backend não deve receber cabeçalho
                 * de desconto.
                 */
                if (
                    !item.itemNativo
                ) {
                    continue;
                }

                itensSalvar.push({
                    NUNOTA:
                        Number(
                            item.nunota ||
                            0
                        ),

                    SEQUENCIA:
                        Number(
                            item.sequencia ||
                            0
                        ),

                    itemNativo: {
                        ...item.itemNativo
                    }
                });
            }
        }

        const itensValidos =
            itensSalvar.filter(
                (
                    item
                ) =>
                    item.NUNOTA > 0 &&
                    item.SEQUENCIA > 0
            );

        if (!itensValidos.length) {
            this.demonstrativoLoading.set(
                false
            );

            this.abrirModalAlerta(
                'Nenhum item preparado para gravação.',
                'OK'
            );

            return;
        }

        this.demonstrativoLoading.set(
            true
        );

        this.sankhyaGateway
            .salvarAjustesVendaNativo({
                itens:
                itensValidos
            })
            .subscribe({
                next: (
                    response:
                    DemonstrativoSalvarAjustesNativosResponse
                ) => {

                    this.demonstrativoLoading.set(
                        false
                    );

                    const falhas =
                        Array.isArray(
                            response?.resultado
                        )
                            ? response.resultado.filter(
                                (
                                    resultado
                                ) =>
                                    !resultado.sucesso
                            )
                            : [];

                    if (
                        !response?.sucesso ||
                        falhas.length
                    ) {
                        this.abrirModalAlerta(
                            falhas.length
                                ? falhas
                                    .map(
                                        (
                                            falha
                                        ) =>
                                            `Nota ${falha.nunota}, item ${falha.sequencia}: ${falha.erro || 'erro ao salvar'}`
                                    )
                                    .join('\n')
                                : 'Erro ao salvar os descontos.',
                            'OK'
                        );

                        return;
                    }

                    this.demonstrativoModalAjusteNotas =
                        false;

                    this.demonstrativoModalAjusteNotaIndividual =
                        false;

                    this.abrirModalAlerta(
                        'Desconto salvo com sucesso!',
                        'OK'
                    );

                    this.buscarDadosDemonstrativo();
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao salvar os descontos.'
                        ),
                        'OK'
                    );
                }
            });
    }

    salvarAjusteNotaIndividual(): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;
        this.demonstrativoModalAjusteNotaIndividual = false;
        this.exibirConfirmacao(
            'Deseja realmente salvar o desconto / acrescimo nos itens da nota?',
            'Salvar',
            'Cancelar',
            () => this.confirmarSalvarAjusteNotaIndividual()
        );
    }

    confirmarSalvarAjusteNotaIndividual(): void {
        if (this.demonstrativoCalculandoAjusteNativo) return;

        const itensAlterados =
            this.demonstrativoItensNotaAjuste
                .filter(
                    (
                        item
                    ) =>
                        this.itemNotaPossuiAjuste(
                            item
                        )
                );

        if (!itensAlterados.length) {
            this.abrirModalAlerta(
                'Nenhum item foi alterado.',
                'OK'
            );

            return;
        }

        const itensSalvar =
            itensAlterados
                .map(
                    (
                        item
                    ) => {

                        const nunota =
                            this.toNumber(
                                String(
                                    item['codigo'] ||
                                    ''
                                )
                            );

                        const sequencia =
                            this.toNumber(
                                String(
                                    item['sequencia'] ||
                                    ''
                                )
                            );

                        if (
                            !nunota ||
                            !sequencia ||
                            !item['_itemNativo']
                        ) {
                            return null;
                        }

                        return {
                            NUNOTA:
                            nunota,

                            SEQUENCIA:
                            sequencia,

                            itemNativo: {
                                ...item['_itemNativo']
                            }
                        };
                    }
                )
                .filter(
                    (
                        item
                    ): item is {
                        NUNOTA: number;
                        SEQUENCIA: number;
                        itemNativo: Record<string, string>;
                    } =>
                        item !== null
                );

        if (
            itensSalvar.length !==
            itensAlterados.length
        ) {
            this.abrirModalAlerta(
                'Não foi possível montar todos os itens para gravação.',
                'OK'
            );

            return;
        }

        this.demonstrativoLoading.set(
            true
        );

        this.sankhyaGateway
            .salvarAjustesVendaNativo({
                itens:
                itensSalvar
            })
            .subscribe({
                next: (
                    response:
                    DemonstrativoSalvarAjustesNativosResponse
                ) => {

                    this.demonstrativoLoading.set(
                        false
                    );

                    const falhas =
                        Array.isArray(
                            response?.resultado
                        )
                            ? response.resultado
                                .filter(
                                    (
                                        resultado
                                    ) =>
                                        !resultado.sucesso
                                )
                            : [];

                    if (
                        !response?.sucesso ||
                        falhas.length
                    ) {
                        this.abrirModalAlerta(
                            falhas.length
                                ? falhas
                                    .map(
                                        (
                                            falha
                                        ) =>
                                            `Nota ${falha.nunota}, item ${falha.sequencia}: ${falha.erro || 'erro ao salvar'}`
                                    )
                                    .join('\n')
                                : 'Erro ao salvar os itens no Sankhya.',
                            'OK'
                        );

                        return;
                    }

                    this.demonstrativoModalAjusteNotaIndividual =
                        false;

                    this.demonstrativoModalAjusteNotas =
                        false;

                    this.abrirModalAlerta(
                        'Desconto dos itens salvo com sucesso!',
                        'OK'
                    );

                    /*
                     * Não confiamos nos valores que estavam na tela.
                     * Recarregamos tudo após a alteração.
                     */
                    this.buscarDadosDemonstrativo();
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao salvar os itens no Sankhya.'
                        ),
                        'OK'
                    );
                }
            });
    }

    abrirModalTipoNegociacao(): void {
        this.demonstrativoAbrirMenu = false;
        try {
            this.validarStatusLegado(
                this.demonstrativoItens(),
                'Um ou mais registros nao puderam ser alterados!\nRegistro feito no AeroSys.'
            );
        } catch {
            return;
        }

        const selecionados = this.itensSelecionados();
        if (!selecionados.length) {
            this.abrirModalAlerta('Selecione ao menos uma venda para alterar a forma de pagamento.', 'OK');
            return;
        }

        if (selecionados.some((item) => this.isNotaFinalizada(item))) {
            this.abrirModalAlerta('Forma de pagamento so pode ser alterada em vendas nao autorizadas.', 'OK');
            return;
        }

        this.demonstrativoVendasTipoNegociacao = selecionados.map((item) => ({
            codigo: this.getCell(item, 'codigo'),
            numTitulo: this.getCell(item, 'codigo'),
            emissao: this.getCell(item, 'emissao'),
            status: this.getCell(item, 'status'),
            valorFinal: this.getCell(item, 'valorFinal') || this.getCell(item, 'faturado'),
            codTipVendaAtual: this.getCell(item, 'codTipVenda'),
            tipoNegociacaoAtual: this.getCell(item, 'tipoNegociacao') || 'Nao informado'
        }));
        this.demonstrativoModalTipoNegociacaoResumo = true;
    }

    proximoTipoNegociacao(): void {
        this.demonstrativoTipoVendaSelecionado = null;
        this.demonstrativoFiltroTipoVenda = '';
        this.demonstrativoTiposVenda = [];

        this.demonstrativoLoading.set(true);

        this.sankhyaGateway
            .chamarServiceGpl(
                'TipoNegociacaoComponentSP.doBuscarTiposVenda',
                {}
            )
            .subscribe({
                next: (value: any) => {
                    this.demonstrativoLoading.set(false);

                    const body =
                        value?.responseBody ||
                        value;

                    if (!body?.sucesso) {
                        this.abrirModalAlerta(
                            body?.erro ||
                            'Erro ao buscar formas de pagamento.',
                            'OK'
                        );
                        return;
                    }

                    this.demonstrativoTiposVenda =
                        Array.isArray(body.tiposVenda)
                            ? body.tiposVenda
                            : [];

                    if (!this.demonstrativoTiposVenda.length) {
                        this.abrirModalAlerta(
                            'Nenhuma forma de pagamento encontrada.',
                            'OK'
                        );
                        return;
                    }

                    this.demonstrativoModalTipoNegociacaoResumo =
                        false;

                    this.demonstrativoModalTipoNegociacao =
                        true;
                },

                error: (error: unknown) => {
                    this.demonstrativoLoading.set(false);
                    this.demonstrativoTiposVenda = [];

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao buscar formas de pagamento.'
                        ),
                        'OK'
                    );
                }
            });
    }

    fecharModalTipoNegociacaoResumo(): void {
        this.demonstrativoModalTipoNegociacaoResumo = false;
        this.demonstrativoVendasTipoNegociacao = [];
    }

    fecharModalTipoNegociacao(): void {
        this.demonstrativoModalTipoNegociacao = false;
        this.demonstrativoTipoVendaSelecionado = null;
        this.demonstrativoFiltroTipoVenda = '';
    }

    tiposVendaFiltrados(): Array<Record<string, any>> {
        const filtro =
            this.demonstrativoFiltroTipoVenda
                .trim()
                .toLocaleLowerCase('pt-BR');

        const lista =
            [...this.demonstrativoTiposVenda]
                .filter(
                    (tipo: Record<string, any>) =>
                        Number(
                            tipo['codTipVenda'] || 0
                        ) > 0 &&
                        String(
                            tipo['descricao'] || ''
                        ).trim() !== ''
                )
                .sort(
                    (
                        a: Record<string, any>,
                        b: Record<string, any>
                    ) =>
                        String(
                            a['descricao'] || ''
                        ).localeCompare(
                            String(
                                b['descricao'] || ''
                            ),
                            'pt-BR',
                            {
                                sensitivity: 'base'
                            }
                        )
                );

        if (!filtro) {
            return lista;
        }

        return lista.filter(
            (tipo: Record<string, any>) =>
                String(
                    tipo['descricao'] || ''
                )
                    .toLocaleLowerCase('pt-BR')
                    .includes(filtro)
        );
    }

    alterarTipoNegociacao(): void {
        if (!this.demonstrativoTipoVendaSelecionado) {
            this.abrirModalAlerta('Selecione um tipo de negociacao!', 'OK');
            return;
        }

        this.exibirConfirmacao(
            'Deseja realmente alterar a forma de pagamento das vendas selecionadas?',
            'Alterar',
            'Cancelar',
            () => this.confirmarAlterarTipoNegociacao()
        );
    }

    confirmarAlterarTipoNegociacao(): void {

        const codTipVenda =
            this.toNumber(
                String(
                    this.demonstrativoTipoVendaSelecionado?.['codTipVenda'] ??
                    ''
                )
            );

        const descricao =
            String(
                this.demonstrativoTipoVendaSelecionado?.['descricao'] ??
                ''
            ).trim();

        if (
            !codTipVenda ||
            !descricao
        ) {
            this.abrirModalAlerta(
                'Forma de pagamento selecionada inválida.',
                'OK'
            );

            return;
        }

        const alteracoes =
            this.demonstrativoVendasTipoNegociacao
                .map(
                    (item) =>
                        this.toNumber(
                            String(
                                item['codigo'] ??
                                ''
                            )
                        )
                )
                .filter(
                    (nunota) =>
                        nunota > 0
                )
                .map(
                    (nunota) => ({
                        NUNOTA:
                        nunota,

                        CODTIPVENDA:
                        codTipVenda,

                        DESCRTIPVENDA:
                        descricao
                    })
                );

        if (!alteracoes.length) {
            this.abrirModalAlerta(
                'Nenhuma venda selecionada para alterar.',
                'OK'
            );

            return;
        }

        this.demonstrativoModalTipoNegociacao =
            false;

        this.demonstrativoLoading.set(
            true
        );

        this.sankhyaGateway
            .alterarFormaPagamentoVendaNativo({
                alteracoes
            })
            .subscribe({
                next: (
                    body:
                    DemonstrativoAlteracaoFormaPagamentoResponse
                ) => {

                    if (
                        body?.sucesso
                    ) {
                        this.abrirModalAlerta(
                            'Forma de pagamento alterada com sucesso!',
                            'OK'
                        );

                        this.demonstrativoVendasTipoNegociacao =
                            [];

                        this.demonstrativoTipoVendaSelecionado =
                            null;

                        this.demonstrativoFiltroTipoVenda =
                            '';

                        this.buscarDadosDemonstrativo();

                        return;
                    }

                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.montarMensagemFalhas(
                            body,
                            'Erro ao alterar forma de pagamento!'
                        ),
                        'OK'
                    );
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoLoading.set(
                        false
                    );

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao alterar forma de pagamento!'
                        ),
                        'OK'
                    );
                }
            });
    }

    abrirConfirmacao(config: {
        mensagem: string;
        textoOk?: string;
        textoCancelar?: string;
        callbackOk?: () => void
    }): void {
        this.demonstrativoConfirmacao = {
            mensagem: config.mensagem,
            textoOk: config.textoOk || 'Confirmar',
            textoCancelar: config.textoCancelar || 'Cancelar',
            callbackOk: config.callbackOk || null
        };
        this.demonstrativoModalConfirmacao = true;
    }

    confirmarModal(): void {
        const callback = this.demonstrativoConfirmacao.callbackOk;
        this.demonstrativoModalConfirmacao = false;
        callback?.();
    }

    cancelarModal(): void {
        this.demonstrativoModalConfirmacao = false;
    }

    exibirConfirmacao(mensagem: string, textoOk: string, textoCancelar: string, callbackOk: () => void): void {
        this.abrirConfirmacao({mensagem, textoOk, textoCancelar, callbackOk});
    }

    private buscarCotacoes(): void {
        this.demonstrativoLoading.set(true);

        this.sankhyaGateway
            .buscarCotacoesDemonstrativo()
            .subscribe({
                next: (
                    value:
                        SankhyaEnvelope<DemonstrativoCotacoesResponse>
                        | null
                        | undefined
                ) => {
                    this.demonstrativoLoading.set(false);

                    if (!value) {
                        this.demonstrativoCotacoes = [];

                        this.abrirModalAlerta(
                            'Resposta vazia ao buscar as cotações.',
                            'OK'
                        );

                        return;
                    }

                    if (value.status !== '1') {
                        this.demonstrativoCotacoes = [];

                        this.abrirModalAlerta(
                            value.statusMessage
                            || 'O serviço nativo não retornou sucesso.',
                            'OK'
                        );

                        return;
                    }

                    const body =
                        value.responseBody;

                    if (!body?.sucesso) {
                        this.demonstrativoCotacoes = [];

                        this.abrirModalAlerta(
                            body?.erro
                            || 'Erro ao buscar as cotações do dólar.',
                            'OK'
                        );

                        return;
                    }

                    const cotacoes =
                        Array.isArray(body.cotacoes)
                            ? body.cotacoes
                            : [];

                    this.demonstrativoCotacoes =
                        cotacoes
                            .map((cotacao) => ({
                                codigoMoeda:
                                    Number(
                                        cotacao.codigoMoeda || 4
                                    ),

                                moeda:
                                    String(
                                        cotacao.moeda || 'Dólar'
                                    ),

                                data:
                                    String(
                                        cotacao.data || ''
                                    ),

                                valor:
                                    Number(
                                        cotacao.valor || 0
                                    )
                            }))
                            .filter(
                                (cotacao) =>
                                    cotacao.codigoMoeda === 4
                                    && cotacao.data !== ''
                                    && Number.isFinite(
                                        cotacao.valor
                                    )
                                    && cotacao.valor > 0
                            );

                    if (!this.demonstrativoCotacoes.length) {
                        this.abrirModalAlerta(
                            'Nenhuma cotação do dólar foi localizada.',
                            'OK'
                        );

                        return;
                    }

                    this.demonstrativoCotacaoSelecionada =
                        null;

                    this.demonstrativoFiltroCotacao =
                        '';

                    this.demonstrativoModalCotacoes =
                        true;
                },

                error: (error: unknown) => {
                    this.demonstrativoLoading.set(false);
                    this.demonstrativoCotacoes = [];

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao buscar as cotações do dólar.'
                        ),
                        'OK'
                    );
                }
            });
    }

    private buscarPrefixos(
        codparc: number
    ): void {
        this.demonstrativoLoading.set(true);

        this.sankhyaGateway
            .buscarPrefixosNativosDemonstrativo(
                codparc
            )
            .subscribe({
                next: (
                    value: SankhyaEnvelope<DemonstrativoPrefixosResponse>
                ) => {
                    const body =
                        this.unwrapResponse<DemonstrativoPrefixosResponse>(
                            value
                        );

                    this.demonstrativoLoading.set(false);

                    if (!body?.sucesso) {
                        this.abrirModalAlerta(
                            body?.erro ||
                            value.statusMessage ||
                            'Erro ao buscar prefixos.',
                            'OK'
                        );

                        return;
                    }

                    const prefixos =
                        Array.isArray(body.prefixos)
                            ? body.prefixos
                            : [];

                    if (!prefixos.length) {
                        this.abrirModalAlerta(
                            'Sem prefixos localizados para este cliente.',
                            'OK'
                        );

                        return;
                    }

                    this.demonstrativoPrefixosAlteracao =
                        prefixos;

                    this.demonstrativoPrefixoSelecionadoAlteracao =
                        null;

                    this.demonstrativoFiltroPrefixoAlteracao =
                        '';

                    this.demonstrativoModalPrefixos =
                        true;
                },

                error: (error: unknown) => {
                    this.demonstrativoLoading.set(false);

                    this.abrirModalAlerta(
                        this.erroMensagem(
                            error,
                            'Erro ao buscar prefixos.'
                        ),
                        'OK'
                    );
                }
            });
    }

    private carregarEnderecosClienteAlteracao(
        cliente: DemonstrativoCliente
    ): void {

        const codparcsOrigem =
            Array.isArray(cliente.codparcs) &&
            cliente.codparcs.length
                ? cliente.codparcs
                : [cliente.codparc];

        const codparcs = Array.from(
            new Set(
                codparcsOrigem
                    .map((codparc) =>
                        String(codparc ?? '').trim()
                    )
                    .filter((codparc) =>
                        codparc !== ''
                    )
            )
        );

        if (!codparcs.length) {
            this.demonstrativoAlterarClienteEnderecos = [];
            this.demonstrativoAlterarClienteEnderecoSelecionado = null;

            this.demonstrativoAlterarClienteStatus =
                'Cliente selecionado sem CODPARC para localizar enderecos.';

            return;
        }

        this.demonstrativoAlterarClienteStatus =
            codparcs.length > 1
                ? `Buscando ${codparcs.length} enderecos relacionados ao cliente...`
                : 'Buscando endereco do cliente...';

        const requisicoes =
            codparcs.map(
                (codparc) =>
                    this.sankhyaGateway
                        .buscarDadosParceiroNativo(
                            codparc
                        )
            );

        forkJoin(requisicoes)
            .subscribe({
                next: (respostas: unknown[]) => {

                    const dadosParceiros:
                        Array<Record<string, unknown>> = [];

                    for (const resposta of respostas) {
                        const value =
                            resposta as any;

                        if (!value) {
                            continue;
                        }

                        if (
                            value.status &&
                            value.status !== '1'
                        ) {
                            continue;
                        }

                        const body =
                            value.responseBody ||
                            value;

                        if (
                            body?.sucesso === false ||
                            !body?.dados ||
                            typeof body.dados !== 'object'
                        ) {
                            continue;
                        }

                        dadosParceiros.push(
                            body.dados as Record<string, unknown>
                        );
                    }

                    const enderecos =
                        this.normalizarEnderecosNativosAlteracao(
                            dadosParceiros,
                            cliente
                        );

                    this.demonstrativoAlterarClienteEnderecos =
                        enderecos;

                    /*
                     * Mantém o comportamento atual:
                     * havendo somente um endereço, ele já fica selecionado.
                     */
                    this.demonstrativoAlterarClienteEnderecoSelecionado =
                        enderecos.length === 1
                            ? enderecos[0]
                            : null;

                    this.demonstrativoAlterarClienteEndereco =
                        null;

                    this.demonstrativoAlterarClienteStatus =
                        enderecos.length
                            ? enderecos.length === 1
                                ? '1 endereco localizado.'
                                : `${enderecos.length} enderecos localizados. Selecione o endereco que sera usado na venda.`
                            : 'Nenhum endereco encontrado para este cliente.';
                },

                error: (error: unknown) => {
                    this.demonstrativoAlterarClienteEnderecos =
                        [];

                    this.demonstrativoAlterarClienteEnderecoSelecionado =
                        null;

                    this.demonstrativoAlterarClienteEndereco =
                        null;

                    this.demonstrativoAlterarClienteStatus =
                        this.erroMensagem(
                            error,
                            'Erro ao buscar os enderecos do cliente.'
                        );
                }
            });
    }

    private carregarPrefixosClienteAlteracao(
        cliente: DemonstrativoCliente
    ): void {

        const codparc =
            this.toNumber(
                String(
                    cliente.codparc || ''
                )
            );

        if (!codparc) {
            this.demonstrativoAlterarClientePrefixos = [];
            this.demonstrativoAlterarClientePrefixoSelecionado = null;
            this.demonstrativoAlterarClientePrefixosPorNota = {};

            this.demonstrativoAlterarClienteStatus =
                'CODPARC do cliente não localizado para buscar os prefixos.';

            return;
        }

        this.demonstrativoAlterarClientePrefixos = [];
        this.demonstrativoAlterarClientePrefixoSelecionado = null;
        this.demonstrativoAlterarClientePrefixosPorNota = {};
        this.demonstrativoAlterarClienteFiltroPrefixo = '';

        this.demonstrativoAlterarClienteStatus =
            'Buscando prefixos do cliente...';

        this.sankhyaGateway
            .buscarPrefixosNativosDemonstrativo(
                codparc
            )
            .subscribe({
                next: (
                    value:
                    SankhyaEnvelope<
                        DemonstrativoPrefixosResponse
                    >
                ) => {

                    const body =
                        this.unwrapResponse<
                            DemonstrativoPrefixosResponse
                        >(
                            value
                        );

                    if (!body?.sucesso) {
                        this.demonstrativoAlterarClientePrefixos =
                            [];

                        this.demonstrativoAlterarClienteStatus =
                            body?.erro ||
                            value.statusMessage ||
                            'Erro ao buscar prefixos do cliente.';

                        return;
                    }

                    const prefixos =
                        Array.isArray(
                            body.prefixos
                        )
                            ? body.prefixos
                            : [];

                    this.demonstrativoAlterarClientePrefixos =
                        prefixos;

                    this.demonstrativoAlterarClientePrefixoSelecionado =
                        null;

                    this.demonstrativoAlterarClientePrefixosPorNota =
                        {};

                    this.demonstrativoAlterarClienteFiltroPrefixo =
                        '';

                    this.demonstrativoAlterarClienteStatus =
                        prefixos.length
                            ? `${prefixos.length} prefixo(s) encontrado(s).`
                            : 'Nenhum prefixo encontrado para este cliente.';
                },

                error: (
                    error: unknown
                ) => {
                    this.demonstrativoAlterarClientePrefixos =
                        [];

                    this.demonstrativoAlterarClientePrefixoSelecionado =
                        null;

                    this.demonstrativoAlterarClientePrefixosPorNota =
                        {};

                    this.demonstrativoAlterarClienteStatus =
                        this.erroMensagem(
                            error,
                            'Erro ao buscar prefixos do cliente.'
                        );
                }
            });
    }

    private limparAlterarCliente(fecharTudo: boolean): void {
        if (fecharTudo) {
            this.demonstrativoAlterarClienteNotas = [];
        }

        this.demonstrativoAlterarClienteFiltro = '';
        this.demonstrativoAlterarClienteClientes = [];
        this.demonstrativoAlterarClienteDropdownAberto = false;
        this.demonstrativoAlterarClienteClienteSelecionado = null;
        this.demonstrativoAlterarClienteEnderecos = [];
        this.demonstrativoAlterarClienteEnderecoSelecionado = null;
        this.demonstrativoAlterarClienteEndereco = null;
        this.demonstrativoAlterarClientePrefixos = [];
        this.demonstrativoAlterarClientePrefixoSelecionado = null;
        this.demonstrativoAlterarClientePrefixosPorNota = {};
        this.demonstrativoAlterarClienteFiltroPrefixo = '';
        this.demonstrativoAlterarClienteStatus = '';
        this.demonstrativoAlterarClientePasso = 1;
    }

    private inicializarPrefixosAlterarClientePorNota(): void {
        const atual = {...this.demonstrativoAlterarClientePrefixosPorNota};
        this.demonstrativoAlterarClienteNotas.forEach((nota) => {
            const chave = this.chaveNotaAlterarCliente(nota);
            if (chave && !(chave in atual)) {
                atual[chave] = null;
            }
        });
        this.demonstrativoAlterarClientePrefixosPorNota = atual;
    }

    private notasSelecionadasNumericas(): number[] {
        return this.itensSelecionados()
            .map((item) => this.toNumber(this.getCell(item, 'codigo')))
            .filter((codigo) => codigo > 0);
    }

    private formatarEnderecoAlteracao(endereco: Record<string, unknown> | null): string {
        if (!endereco) {
            return '';
        }

        const rua = this.valorBusca(endereco, 'ENDERECO');
        const numero = this.valorBusca(endereco, 'NUMEND');
        const complemento = this.valorBusca(endereco, 'COMPLEMENTO');
        const bairro = this.valorBusca(endereco, 'BAIRRO');
        const cidade = this.valorBusca(endereco, 'NOMECID');
        const uf = this.valorBusca(endereco, 'UF');
        const cep = this.valorBusca(endereco, 'CEP');

        return [
            [rua, numero].filter(Boolean).join(', '),
            complemento,
            bairro,
            [cidade, uf].filter(Boolean).join('/'),
            cep ? `CEP ${cep}` : ''
        ].filter(Boolean).join(' - ');
    }

    private nomeArquivoPdfDemonstrativo(): string {
        const parceiro = this.demonstrativoDados()?.parceiro?.nomeParc || this.demonstrativoFiltroCliente || 'CLIENTE';
        const nomeCliente = parceiro
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '')
            .replace(/[^\w]/g, '')
            .toUpperCase();
        const dataHora = new Date()
            .toLocaleString('pt-BR')
            .replace(/\D/g, '')
            .substring(0, 12);

        return 'DEMONSTRATIVO_' + nomeCliente + '_' + dataHora + '.pdf';
    }

    private itensSelecionados(): Array<Record<string, unknown>> {
        return this.demonstrativoItens().filter((item) => item['selecionado'] === true);
    }

    private itensParaImpressao(tipo: 'SELECIONADOS' | 'TODOS'): Array<Record<string, unknown>> {
        return tipo === 'SELECIONADOS' ? this.itensSelecionados() : this.demonstrativoItens();
    }

    private imprimirAreaDemonstrativo(tipo: 'SELECIONADOS' | 'TODOS', callback?: () => void): void {
        const itensAtuais = this.demonstrativoItens();

        if (tipo === 'SELECIONADOS') {
            this.demonstrativoItens.set(itensAtuais.map((item) => ({
                ...item,
                noPrint: item['selecionado'] !== true
            })));
        }

        setTimeout(() => {
            window.print();

            if (tipo === 'SELECIONADOS') {
                setTimeout(() => {
                    this.demonstrativoItens.set(itensAtuais.map((item) => ({...item, noPrint: false})));
                    callback?.();
                }, 250);
                return;
            }

            setTimeout(() => callback?.(), 250);
        }, 60);
    }

    private abrirFilaOrcamentos(itens: Array<Record<string, unknown>>): void {
        const notas = itens
            .map((item) => this.getCell(item, 'codigo'))
            .filter((codigo) => codigo);

        if (!notas.length) {
            this.abrirModalAlerta('Nenhuma venda valida para imprimir orcamento.', 'OK');
            return;
        }

        const storage = this.getSessionStorage();
        this.salvarEstadoRetornoImpressao();
        storage?.removeItem(this.navegacaoVendaImpressaoKey);
        if (notas.length === 1) {
            storage?.setItem('param_venda_impressao_nunota', notas[0]);
            storage?.removeItem('param_venda_impressao_fila');
        } else {
            storage?.setItem('param_venda_impressao_fila', JSON.stringify(notas));
            storage?.removeItem('param_venda_impressao_nunota');
        }
        storage?.setItem('param_venda_impressao_auto_print', 'S');
        storage?.setItem('param_venda_impressao_retorno', 'demonstrativo-vendas');
        this.activeViewChange.emit('gpl-venda-impressao');
    }

    private salvarNavegacaoVendaImpressao(storage: Storage | null): void {
        if (!storage) {
            return;
        }

        const vistos = new Set<string>();
        const notas = this.demonstrativoItens()
            .map((item) => this.getCell(item, 'codigo').trim())
            .filter((nunota) => {
                if (!nunota || vistos.has(nunota)) {
                    return false;
                }

                vistos.add(nunota);
                return true;
            })
            .map((nunota) => ({NUNOTA: nunota}));

        if (notas.length) {
            storage.setItem(
                this.navegacaoVendaImpressaoKey,
                JSON.stringify(notas)
            );
            return;
        }

        storage.removeItem(this.navegacaoVendaImpressaoKey);
    }

    limparBuscaDemonstrativo(): void {
        if (this.demonstrativoBuscaClienteTimer) {
            clearTimeout(this.demonstrativoBuscaClienteTimer);
            this.demonstrativoBuscaClienteTimer = null;
        }

        this.demonstrativoFiltroCliente = '';
        this.demonstrativoCodparc = '';
        this.demonstrativoCodparcs = [];
        this.demonstrativoPrefixoBuscaSelecionado = '';
        this.demonstrativoClientes.set([]);
        this.demonstrativoDropdownClientesAberto = false;

        this.demonstrativoDados.set(null);
        this.demonstrativoItens.set([]);
        this.demonstrativoItensOriginais = [];
        this.demonstrativoContas = [];

        this.demonstrativoCodigosDisponiveis = [];
        this.demonstrativoPrefixosDisponiveis = [];
        this.demonstrativoEmpresasDisponiveis = [];
        this.demonstrativoStatusDisponiveis = [];

        this.demonstrativoCodigosSelecionados = [];
        this.demonstrativoPrefixosSelecionados = [];
        this.demonstrativoEmpresasSelecionadas = [];
        this.demonstrativoStatusSelecionados = [];

        this.demonstrativoSelecionarTodos = false;
        this.demonstrativoBuscaSemDados = false;
        this.demonstrativoAbrirMenu = false;
        this.demonstrativoAbrirPrefixos = false;
        this.demonstrativoAbrirEmpresas = false;
        this.demonstrativoAbrirCodigos = false;

        this.limparFiltroEnderecoDemonstrativo();

        this.demonstrativoStatus.set(
            this.demonstrativoTipoBusca === 'VENDEDOR'
                ? 'Informe um vendedor para buscar o demonstrativo.'
                : this.demonstrativoTipoBusca === 'PREFIXO'
                    ? 'Informe um prefixo para buscar o demonstrativo.'
                    : 'Informe um cliente para buscar o demonstrativo.'
        );
    }

    private salvarEstadoRetornoImpressao(): void {
        const storage = this.getSessionStorage();
        if (!storage) {
            return;
        }

        const estado = {
            demonstrativoStatus: this.demonstrativoStatus(),
            demonstrativoRawResponse: this.demonstrativoRawResponse(),
            demonstrativoDados: this.demonstrativoDados(),
            demonstrativoItens: this.demonstrativoItens(),
            demonstrativoItensOriginais: this.demonstrativoItensOriginais,
            demonstrativoContas: this.demonstrativoContas,
            demonstrativoCodigosDisponiveis: this.demonstrativoCodigosDisponiveis,
            demonstrativoPrefixosDisponiveis: this.demonstrativoPrefixosDisponiveis,
            demonstrativoEmpresasDisponiveis: this.demonstrativoEmpresasDisponiveis,
            demonstrativoStatusDisponiveis: this.demonstrativoStatusDisponiveis,
            demonstrativoCodigosSelecionados: this.demonstrativoCodigosSelecionados,
            demonstrativoPrefixosSelecionados: this.demonstrativoPrefixosSelecionados,
            demonstrativoEmpresasSelecionadas: this.demonstrativoEmpresasSelecionadas,
            demonstrativoStatusSelecionados: this.demonstrativoStatusSelecionados,
            demonstrativoFiltroCliente: this.demonstrativoFiltroCliente,
            demonstrativoCodparc: this.demonstrativoCodparc,
            demonstrativoCodparcs: this.demonstrativoCodparcs,
            demonstrativoTipoBusca: this.demonstrativoTipoBusca,
            demonstrativoPrefixoBuscaSelecionado: this.demonstrativoPrefixoBuscaSelecionado,
            demonstrativoDataInicial: this.demonstrativoDataInicial,
            demonstrativoDataFinal: this.demonstrativoDataFinal,
            demonstrativoTipoMoeda: this.demonstrativoTipoMoeda,
            demonstrativoSelecionarTodos: this.demonstrativoSelecionarTodos,
            demonstrativoZoomAtual: this.demonstrativoZoomAtual,
            demonstrativoWhatsappNumero: this.demonstrativoWhatsappNumero,
            demonstrativoValorPixQrCode: this.demonstrativoValorPixQrCode,
            demonstrativoImprimirCotacao: this.demonstrativoImprimirCotacao,
            ordemOrdAsc: this.ordemOrdAsc,
            ordemEmpAsc: this.ordemEmpAsc,
            ordemPrefixoAsc: this.ordemPrefixoAsc,
            ordemEmissaoAsc: this.ordemEmissaoAsc,
            ordemStatusAsc: this.ordemStatusAsc
        };

        try {
            storage.setItem(this.estadoRetornoImpressaoKey, JSON.stringify(estado));
        } catch (error) {
            console.warn('Nao foi possivel salvar o estado do demonstrativo:', error);
        }
    }

    private restaurarEstadoRetornoImpressao(): void {
        const storage = this.getSessionStorage();
        const raw = storage?.getItem(this.estadoRetornoImpressaoKey);

        if (!raw) {
            return;
        }

        try {
            const estado = JSON.parse(raw);

            this.demonstrativoStatus.set(estado.demonstrativoStatus || 'Informe um cliente para buscar o demonstrativo.');
            this.demonstrativoRawResponse.set(estado.demonstrativoRawResponse || '');
            this.demonstrativoDados.set(estado.demonstrativoDados || null);
            this.demonstrativoItens.set(Array.isArray(estado.demonstrativoItens) ? estado.demonstrativoItens : []);
            this.demonstrativoItensOriginais = Array.isArray(estado.demonstrativoItensOriginais) ? estado.demonstrativoItensOriginais : [];
            this.demonstrativoContas = Array.isArray(estado.demonstrativoContas) ? estado.demonstrativoContas : [];
            this.demonstrativoCodigosDisponiveis = Array.isArray(estado.demonstrativoCodigosDisponiveis) ? estado.demonstrativoCodigosDisponiveis : [];
            this.demonstrativoPrefixosDisponiveis = Array.isArray(estado.demonstrativoPrefixosDisponiveis) ? estado.demonstrativoPrefixosDisponiveis : [];
            this.demonstrativoEmpresasDisponiveis = Array.isArray(estado.demonstrativoEmpresasDisponiveis) ? estado.demonstrativoEmpresasDisponiveis : [];
            this.demonstrativoStatusDisponiveis = Array.isArray(estado.demonstrativoStatusDisponiveis) ? estado.demonstrativoStatusDisponiveis : [];
            this.demonstrativoCodigosSelecionados = Array.isArray(estado.demonstrativoCodigosSelecionados) ? estado.demonstrativoCodigosSelecionados : [];
            this.demonstrativoPrefixosSelecionados = Array.isArray(estado.demonstrativoPrefixosSelecionados) ? estado.demonstrativoPrefixosSelecionados : [];
            this.demonstrativoEmpresasSelecionadas = Array.isArray(estado.demonstrativoEmpresasSelecionadas) ? estado.demonstrativoEmpresasSelecionadas : [];
            this.demonstrativoStatusSelecionados = Array.isArray(estado.demonstrativoStatusSelecionados) ? estado.demonstrativoStatusSelecionados : [];
            this.demonstrativoFiltroCliente = estado.demonstrativoFiltroCliente || '';
            this.demonstrativoCodparc =
                estado.demonstrativoCodparc || '';

            this.demonstrativoCodparcs =
                Array.isArray(estado.demonstrativoCodparcs)
                    ? estado.demonstrativoCodparcs.map(
                        (codparc: unknown) => String(codparc)
                    )
                    : this.demonstrativoCodparc
                        ? [this.demonstrativoCodparc]
                        : [];

            this.demonstrativoTipoBusca =
                estado.demonstrativoTipoBusca === 'VENDEDOR'
                    ? 'VENDEDOR'
                    : estado.demonstrativoTipoBusca === 'PREFIXO'
                        ? 'PREFIXO'
                        : 'CLIENTE';
            this.demonstrativoPrefixoBuscaSelecionado = estado.demonstrativoPrefixoBuscaSelecionado || '';
            this.demonstrativoDataInicial = estado.demonstrativoDataInicial || this.demonstrativoDataInicial;
            this.demonstrativoDataFinal = estado.demonstrativoDataFinal || this.demonstrativoDataFinal;
            this.demonstrativoTipoMoeda = estado.demonstrativoTipoMoeda === 'DOLAR' ? 'DOLAR' : 'REAL';
            this.demonstrativoSelecionarTodos = !!estado.demonstrativoSelecionarTodos;
            this.demonstrativoZoomAtual = Number(estado.demonstrativoZoomAtual || this.demonstrativoZoomAtual);
            this.demonstrativoWhatsappNumero = estado.demonstrativoWhatsappNumero || '';
            this.demonstrativoValorPixQrCode = estado.demonstrativoValorPixQrCode || this.demonstrativoTotalFaturado();
            this.demonstrativoImprimirCotacao = estado.demonstrativoImprimirCotacao !== false;
            this.ordemOrdAsc = estado.ordemOrdAsc !== false;
            this.ordemEmpAsc = estado.ordemEmpAsc !== false;
            this.ordemPrefixoAsc = estado.ordemPrefixoAsc !== false;
            this.ordemEmissaoAsc = estado.ordemEmissaoAsc !== false;
            this.ordemStatusAsc = estado.ordemStatusAsc !== false;
        } catch (error) {
            console.warn('Nao foi possivel restaurar o estado do demonstrativo:', error);
            storage?.removeItem(this.estadoRetornoImpressaoKey);
        }
    }

    private getSessionStorage(): Storage | null {
        try {
            return window.top?.sessionStorage || window.sessionStorage;
        } catch {
            return null;
        }
    }

    private validarStatusLegado(itens: Array<Record<string, unknown>>, mensagem: string): void {
        if (itens.some((item) => !!item['statusLegado'])) {
            this.abrirModalAlerta(mensagem, 'OK');
            throw new Error(mensagem);
        }
    }

    private unwrapResponse<T>(value: SankhyaEnvelope<T> | (T & Record<string, unknown>) | null | undefined): T | null {
        if (!value) {
            return null;
        }

        if ('responseBody' in value && value.responseBody) {
            return value.responseBody as T;
        }

        return value as T;
    }

    private erroMensagem(error: unknown, fallback: string): string {
        if (typeof error === 'object' && error && 'error' in error) {
            const body = (error as { error?: { message?: string; statusMessage?: string; erro?: string } }).error;
            return body?.erro || body?.statusMessage || body?.message || fallback;
        }
        return fallback;
    }

    private aplicarDadosMultiplosDemonstrativo(
        respostas: Array<SankhyaEnvelope<DemonstrativoDados>>
    ): void {
        this.demonstrativoRawResponse.set(
            JSON.stringify(respostas, null, 2)
        );

        const respostasValidas = respostas.filter(
            (resposta) =>
                resposta &&
                resposta.status === '1' &&
                resposta.responseBody
        );

        this.demonstrativoCodparcsComVendas = respostasValidas
            .map((resposta) => {
                const itens = this.extrairItensDemonstrativo(
                    resposta.responseBody || null
                );

                if (!itens.length) {
                    return '';
                }

                return String(
                    this.getCell(itens[0], 'codParc') ||
                    this.getCell(itens[0], 'CODPARC') ||
                    ''
                );
            })
            .filter(
                (codparc, indice, lista) =>
                    !!codparc && lista.indexOf(codparc) === indice
            );

        this.demonstrativoModalFiltroEndereco = false;

        if (!respostasValidas.length) {
            const primeiraComErro = respostas.find(
                (resposta) =>
                    resposta &&
                    resposta.status !== '1'
            );

            this.demonstrativoDados.set(null);
            this.demonstrativoItens.set([]);
            this.demonstrativoItensOriginais = [];
            this.demonstrativoBuscaSemDados = true;

            this.demonstrativoStatus.set(
                primeiraComErro?.statusMessage ||
                'Nenhuma das consultas retornou sucesso.'
            );

            this.demonstrativoLoading.set(false);
            return;
        }

        const primeiroBody =
            respostasValidas[0].responseBody as
                DemonstrativoDados &
                Record<string, any>;

        const itensAgrupados: Array<Record<string, unknown>> = [];
        const contasAgrupadas: Array<Record<string, unknown>> = [];

        const notasAdicionadas = new Set<string>();

        for (const resposta of respostasValidas) {
            const body =
                resposta.responseBody as
                    DemonstrativoDados &
                    Record<string, any>;

            const itens = this.extrairItensDemonstrativo(body);

            for (const item of itens) {
                const codigo =
                    this.getCell(item, 'codigo') ||
                    this.getCell(item, 'NUNOTA') ||
                    this.getCell(item, 'nunota');

                const chave =
                    this.chaveNunotaDemonstrativo(codigo);

                /*
                 * Evita repetir a mesma nota caso ela apareça
                 * em mais de uma resposta.
                 */
                if (chave && notasAdicionadas.has(chave)) {
                    continue;
                }

                if (chave) {
                    notasAdicionadas.add(chave);
                }

                itensAgrupados.push(item);
            }

            if (Array.isArray(body?.contas)) {
                contasAgrupadas.push(...body.contas);
            }
        }

        itensAgrupados.sort((itemA, itemB) => {
            const dataA = this.dataVendaOrdenacaoDemonstrativo(itemA);
            const dataB = this.dataVendaOrdenacaoDemonstrativo(itemB);

            if (dataA !== dataB) {
                return dataA - dataB;
            }

            const codigoA = this.toNumber(
                this.getCell(itemA, 'codigo') ||
                this.getCell(itemA, 'NUNOTA') ||
                this.getCell(itemA, 'nunota')
            );
            const codigoB = this.toNumber(
                this.getCell(itemB, 'codigo') ||
                this.getCell(itemB, 'NUNOTA') ||
                this.getCell(itemB, 'nunota')
            );

            return codigoA - codigoB;
        });

        const bodyCombinado: DemonstrativoDados &
            Record<string, any> = {
            ...primeiroBody,
            itens: itensAgrupados,
            contas: contasAgrupadas,
            totNotas: itensAgrupados.length,
            sucesso: true
        };

        const respostaCombinada:
            SankhyaEnvelope<DemonstrativoDados> = {
            ...respostasValidas[0],
            status: '1',
            statusMessage: '',
            responseBody: bodyCombinado
        };

        this.aplicarDadosDemonstrativo(
            respostaCombinada
        );
    }

    private dataVendaOrdenacaoDemonstrativo(
        item: Record<string, unknown>
    ): number {
        const valor = (
            this.getCell(item, 'emissao') ||
            this.getCell(item, 'DTNEG') ||
            this.getCell(item, 'dtNeg') ||
            this.getCell(item, 'data')
        ).trim();

        const dataBr = valor.match(
            /^(\d{2})\/(\d{2})\/(\d{4})$/
        );

        if (dataBr) {
            return Date.UTC(
                Number(dataBr[3]),
                Number(dataBr[2]) - 1,
                Number(dataBr[1])
            );
        }

        const dataIso = valor.match(
            /^(\d{4})-(\d{2})-(\d{2})/
        );

        if (dataIso) {
            return Date.UTC(
                Number(dataIso[1]),
                Number(dataIso[2]) - 1,
                Number(dataIso[3])
            );
        }

        return Number.MAX_SAFE_INTEGER;
    }

    private async aplicarDadosDemonstrativo(value: SankhyaEnvelope<DemonstrativoDados>): Promise<void> {
        if (!value) {
            this.demonstrativoRawResponse.set('Resposta vazia do gateway.');
            this.demonstrativoDados.set(null);
            this.demonstrativoItens.set([]);
            this.demonstrativoStatus.set('Resposta vazia do gateway. Tente novamente.');
            this.demonstrativoLoading.set(false);
            return;
        }

        this.demonstrativoRawResponse.set(JSON.stringify(value, null, 2));

        if (value.status !== '1') {
            this.demonstrativoDados.set(null);
            this.demonstrativoItens.set([]);
            this.demonstrativoStatus.set(value.statusMessage || 'Service do demonstrativo nao retornou sucesso.');
            this.demonstrativoLoading.set(false);
            return;
        }

        const dados = value.responseBody || null;
        const itensResposta = this.extrairItensDemonstrativo(dados);
        const itensBase = itensResposta.map((item) => ({
            ...this.normalizarValoresNotaDemonstrativo(item),
            selecionado: false
        }));
        const itens = await this.carregarStatusPedidosVendaDemonstrativo(itensBase);
        this.demonstrativoBuscaSemDados = itens.length === 0;
        this.demonstrativoItensOriginais = itens.map((item) => ({...item}));
        this.demonstrativoContas = dados?.contas || [];
        this.demonstrativoDados.set(dados);
        this.demonstrativoItens.set(itens);
        this.demonstrativoSelecionarTodos = false;
        this.montarFiltrosDemonstrativo();
        this.alternarMoeda(this.demonstrativoTipoMoeda);
        this.demonstrativoStatus.set(itens.length ? `${itens.length} item(ns) carregado(s).` : 'Service respondeu sem itens para o periodo.');
        this.demonstrativoLoading.set(false);
    }

    private extrairItensDemonstrativo(dados: DemonstrativoDados | null): Array<Record<string, unknown>> {
        const origem = dados as (DemonstrativoDados & Record<string, any>) | null;
        const container = origem?.['dados'] || origem?.['demonstrativo'] || origem;
        const itens = container?.itens
            || container?.vendas
            || container?.lista
            || container?.notas
            || container?.registros
            || container?.resultado
            || [];
        return Array.isArray(itens) ? itens : [];
    }

    /**
     * O total correto do demonstrativo e o VLRNOTA da TGFCAB. O campo
     * O campo "faturado" legado pode divergir do total da nota, por isso ele
     * nao deve ser usado quando a resposta disponibiliza nota/VLRNOTA.
     */
    private normalizarValoresNotaDemonstrativo(
        item: Record<string, unknown>
    ): Record<string, unknown> {

        const valorNotaInformado =
            item['VLRNOTA'] ??
            item['vlrNota'] ??
            item['nota'] ??
            item['faturado'] ??
            0;

        const valorNota = this.toNumber(
            String(valorNotaInformado)
        );

        const devolucaoInformada =
            item['devolucao'] ??
            item['dev'] ??
            0;

        const devolucao = this.toNumber(
            String(devolucaoInformada)
        );

        const valorFinal = valorNota - devolucao;

        const status =
            item['gplStatus'] ??
            item['GPL_STATUS'] ??
            item['gpl_status'] ??
            item['status'] ??
            'ABERTO';

        return {
            ...item,

            status: String(status || 'ABERTO').toUpperCase(),

            // Total da tabela
            faturado: this.formatarValorDemonstrativo(valorNota),

            // Devolução
            devolucao: this.formatarValorDemonstrativo(devolucao),
            dev: this.formatarValorDemonstrativo(devolucao),

            // Vlr Final
            valorFinal: this.formatarValorDemonstrativo(valorFinal),

            // Valores numéricos usados na conversão de moeda
            _faturadoReal: valorNota,
            _devolucaoReal: devolucao,
            _devReal: devolucao,
            _valorFinalReal: valorFinal
        };
    }

    /** Usa a mesma fonte da tela Pedidos de Venda: PedidoVendaGlobalSP.doListarPedidos. */
    private async carregarStatusPedidosVendaDemonstrativo(
        itens: Array<Record<string, unknown>>
    ): Promise<Array<Record<string, unknown>>> {
        const empresas = Array.from(new Set(
            itens
                .map((item) => this.toNumber(this.getCell(item, 'emp')))
                .filter((empresa) => empresa > 0)
        ));

        if (!empresas.length) {
            return itens;
        }

        const dataInicial = this.dataIsoParaBr(this.demonstrativoDataInicial);
        const dataFinal = this.dataIsoParaBr(this.demonstrativoDataFinal);
        const statusPorNota = new Map<string, string>();

        await Promise.all(empresas.map(async (empresa) => {
            try {
                const resposta: any = await firstValueFrom(
                    this.sankhyaGateway.listarPedidosVenda(
                        empresa,
                        dataInicial,
                        dataFinal,
                        true,
                        '',
                        null
                    )
                );
                const body = resposta?.responseBody || resposta;
                const pedidos = Array.isArray(body?.lista) ? body.lista : [];

                pedidos.forEach((pedido: any) => {
                    const nunota = this.chaveNunotaDemonstrativo(
                        pedido?.nunota ?? pedido?.NUNOTA ?? pedido?.codigo
                    );
                    const status = pedido?.gplStatus ?? pedido?.GPL_STATUS ?? pedido?.gpl_status;

                    if (nunota && status) {
                        statusPorNota.set(nunota, this.statusPedidoVendaDemonstrativo(status));
                    }
                });
            } catch (error) {
                console.warn(`Nao foi possivel buscar os status da empresa ${empresa}.`, error);
            }
        }));

        return itens.map((item) => {
            const nunota = this.chaveNunotaDemonstrativo(this.getCell(item, 'codigo'));
            const status = statusPorNota.get(nunota);
            return status ? {...item, status} : item;
        });
    }

    private chaveNunotaDemonstrativo(valor: unknown): string {
        return String(valor ?? '').trim().replace(/^0+(?=\d)/, '');
    }

    private dataIsoParaBr(valor: string): string {
        const partes = String(valor || '').split('-');
        return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : valor;
    }

    private statusPedidoVendaDemonstrativo(valor: unknown): string {
        const status = String(valor || 'ABERTO').trim().toUpperCase();
        const labels: Record<string, string> = {
            'SEPARACAO': 'SEPARAÇÃO',
            'SEPARACAO TOTAL': 'SEPARAÇÃO TOTAL',
            'CONFERENCIA': 'CONFERÊNCIA',
            'PENDENCIA VENDEDOR': 'PENDÊNCIA VENDEDOR',
            'LOGISTICA': 'LOGÍSTICA'
        };
        return labels[status] || status;
    }

    /**
     * O Vlr Final deve ser identico ao Total Geral da impressao da venda.
     * Para isso, usa o mesmo documento detalhado e a mesma composicao de itens,
     * CORE, IPI, ST, frete, outras despesas e desconto.
     */
    private async carregarTotaisImpressaoDemonstrativo(
        itens: Array<Record<string, unknown>>
    ): Promise<Array<Record<string, unknown>>> {
        return Promise.all(itens.map(async (item) => {
            const nunota = this.toNumber(this.getCell(item, 'codigo'));

            if (!nunota) {
                return item;
            }

            try {
                const resposta: any = await firstValueFrom(
                    this.sankhyaGateway.consultarOrcamentoImpressao({NUNOTA: nunota})
                );
                const body = resposta?.responseBody || resposta;
                const documento = body?.orcamento;

                if (!body?.sucesso || !documento) {
                    return item;
                }

                const totalReal = this.calcularTotalGeralImpressao(documento, false);
                const totalDolar = this.calcularTotalGeralImpressao(documento, true);

                return {
                    ...item,
                    valorFinal: this.formatarValorDemonstrativo(totalReal),
                    _valorFinalReal: totalReal,
                    _valorFinalDolar: totalDolar
                };
            } catch (error) {
                console.warn(`Nao foi possivel calcular o Total Geral da nota ${nunota}.`, error);
                return item;
            }
        }));
    }

    private calcularTotalGeralImpressao(documento: any, emDolar: boolean): number {
        const itens = Array.isArray(documento?.items) ? documento.items : [];
        const cotacao = this.cotacaoDocumentoImpressao(documento, itens);

        const totalItens = itens.reduce((total: number, item: any) => {
            const quantidade = this.toNumber(String(item?.QTDNEG ?? 0));
            const unitario = this.toNumber(String(
                emDolar ? item?.VLRUNITMOEDA ?? 0 : item?.VLRUNIT ?? 0
            ));
            let totalItem = unitario * quantidade;
            const possuiCore = String(item?.CORE ?? '').trim().toUpperCase();
            const adicionarCore = String(item?.AD_CORE ?? '').trim().toUpperCase() === 'S';

            if (adicionarCore && possuiCore && possuiCore !== 'N') {
                const core = this.toNumber(String(item?.VLRCORE ?? 0));
                totalItem += core * (emDolar ? 1 : cotacao) * quantidade;
            }

            if (!emDolar) {
                totalItem += this.toNumber(String(item?.VLRIPI ?? 0));
                totalItem += this.toNumber(String(item?.VLRSUBST ?? 0));
            }

            return total + totalItem;
        }, 0);

        const converterCabecalho = (valor: unknown): number => {
            const numero = this.toNumber(String(valor ?? 0));
            return emDolar && cotacao > 0 ? numero / cotacao : numero;
        };

        return totalItens
            + converterCabecalho(documento?.VLRFRETE)
            - converterCabecalho(documento?.VLRDESCTOT);
    }

    private cotacaoDocumentoImpressao(documento: any, itens: any[]): number {
        const cotacaoCabecalho = [
            documento?.VLRMOEDA,
            documento?.DOLAR,
            documento?.COTACAO,
            documento?.COTACAO_DOLAR,
            documento?.VLRCOTACAO
        ]
            .map((valor) => this.toNumber(String(valor ?? 0)))
            .find((valor) => valor > 0);

        if (cotacaoCabecalho) {
            return cotacaoCabecalho;
        }

        const itemBase = itens.find((item) =>
            this.toNumber(String(item?.VLRUNIT ?? 0)) > 0 &&
            this.toNumber(String(item?.VLRUNITMOEDA ?? 0)) > 0
        );

        if (!itemBase) {
            return 0;
        }

        return this.toNumber(String(itemBase.VLRUNIT)) /
            this.toNumber(String(itemBase.VLRUNITMOEDA));
    }

    private limparDadosTrocaTipoBuscaDemonstrativo(): void {
        this.demonstrativoRawResponse.set('');
        this.demonstrativoDados.set(null);
        this.demonstrativoItens.set([]);
        this.demonstrativoBuscaSemDados = false;
        this.demonstrativoItensOriginais = [];
        this.demonstrativoContas = [];
        this.demonstrativoCodigosDisponiveis = [];
        this.demonstrativoPrefixosDisponiveis = [];
        this.demonstrativoEmpresasDisponiveis = [];
        this.demonstrativoStatusDisponiveis = [];
        this.demonstrativoCodigosSelecionados = [];
        this.demonstrativoPrefixosSelecionados = [];
        this.demonstrativoEmpresasSelecionadas = [];
        this.demonstrativoStatusSelecionados = [];
        this.demonstrativoCotacoes = [];
        this.demonstrativoCotacaoSelecionada = null;
        this.demonstrativoFiltroCotacao = '';
        this.demonstrativoSelecionarTodos = false;
        this.demonstrativoAbrirMenu = false;
        this.demonstrativoAbrirPrefixos = false;
        this.demonstrativoAbrirEmpresas = false;
        this.demonstrativoAbrirCodigos = false;
        this.demonstrativoModalCotacoes = false;
        this.demonstrativoModalPrefixos = false;
        this.demonstrativoModalFinalizar = false;
        this.demonstrativoModalAjusteNotas = false;
        this.demonstrativoModalAjusteNotaIndividual = false;
        this.demonstrativoModalTipoNegociacaoResumo = false;
        this.demonstrativoModalTipoNegociacao = false;
        this.demonstrativoModalAlterarCliente = false;
        this.demonstrativoModalImpressao = false;
        this.demonstrativoValorPixQrCode = '0,00';
        this.demonstrativoWhatsappNumero = '';
        this.mostrarRetornoDemonstrativo = false;
        this.fecharMenusDemonstrativo();
        this.fecharModalAlerta();
        this.demonstrativoModalConfirmacao = false;
        this.demonstrativoLoading.set(false);
    }

    private aplicarFiltrosDemonstrativo(): void {
        const itens = this.demonstrativoItensOriginais
            .filter((item) => {
                const codigoOk = !this.demonstrativoCodigosSelecionados.length ||
                    this.demonstrativoCodigosSelecionados.includes(this.getCell(item, 'codigo'));

                const prefixoOk = !this.demonstrativoPrefixosSelecionados.length ||
                    this.demonstrativoPrefixosSelecionados.includes(this.getCell(item, 'prefixo'));

                const empresaOk = !this.demonstrativoEmpresasSelecionadas.length ||
                    this.demonstrativoEmpresasSelecionadas.includes(this.getCell(item, 'emp'));

                const codparcItem = String(
                    this.getCell(item, 'codParc') ||
                    this.getCell(item, 'CODPARC') ||
                    ''
                );

                const enderecoOk =
                    !this.demonstrativoEnderecosFiltroAplicados.length ||
                    this.demonstrativoEnderecosFiltroAplicados.includes(
                        codparcItem
                    );

                const statusOk = !this.demonstrativoStatusSelecionados.length ||
                    this.demonstrativoStatusSelecionados.includes(this.getCell(item, 'status'));

                return codigoOk && prefixoOk && empresaOk && enderecoOk && statusOk;
            })
            .map((item) => this.converterMoedaItem(item));

        this.demonstrativoItens.set(itens);
        this.demonstrativoSelecionarTodos = false;
        this.demonstrativoValorPixQrCode = this.demonstrativoTotalFaturado();
        this.atualizarQrCodePix(this.toNumber(this.demonstrativoValorPixQrCode), false);
    }

    private converterMoedaItem(item: Record<string, unknown>): Record<string, unknown> {
        const convertido: Record<string, unknown> = {...item, selecionado: false};
        const dolar = this.toNumber(this.getCell(item, 'dolar'));

        const camposMoeda = ['adiant', 'faturado', 'devolucao', 'dev', 'valorFinal'];
        camposMoeda.forEach((campo) => {
            const chaveReal = `_${campo}Real`;
            const valorReal = this.toNumber(this.getCell(item, chaveReal) || this.getCell(item, campo));
            convertido[chaveReal] = valorReal;
            const valorDolarCalculado = this.toNumber(this.getCell(item, `_${campo}Dolar`));
            const valorConvertido = this.demonstrativoTipoMoeda === 'DOLAR'
                ? (valorDolarCalculado || (dolar > 0 ? valorReal / dolar : valorReal))
                : valorReal;
            convertido[campo] = this.formatarValorDemonstrativo(valorConvertido);
        });

        if (!convertido['devolucao'] && convertido['dev']) {
            convertido['devolucao'] = convertido['dev'];
        }
        if (!convertido['valorFinal']) {
            convertido['valorFinal'] = convertido['faturado'];
        }

        return convertido;
    }

    private formatarValorDemonstrativo(value: number): string {
        return value.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    private montarFiltrosDemonstrativo(): void {
        this.demonstrativoCodigosDisponiveis = this.valoresUnicos('codigo');
        this.demonstrativoPrefixosDisponiveis = this.valoresUnicos('prefixo');
        this.demonstrativoEmpresasDisponiveis = this.valoresUnicos('emp');
        this.demonstrativoStatusDisponiveis = this.valoresUnicos('status');
    }

    private valoresUnicos(campo: string): string[] {
        return Array.from(new Set(
            this.demonstrativoItensOriginais
                .map((item) => this.getCell(item, campo))
                .filter((value) => value)
        )).sort();
    }

    private toggleFiltro(valor: string, selecionados: string[]): string[] {
        if (valor === 'TODOS') {
            return [];
        }
        return selecionados.includes(valor)
            ? selecionados.filter((item) => item !== valor)
            : [...selecionados, valor];
    }

    private toggleOrdenacao(campo: 'ord' | 'emp' | 'prefixo' | 'emissao' | 'status'): boolean {
        if (campo === 'ord') {
            this.ordemOrdAsc = !this.ordemOrdAsc;
            return this.ordemOrdAsc;
        }
        if (campo === 'emp') {
            this.ordemEmpAsc = !this.ordemEmpAsc;
            return this.ordemEmpAsc;
        }
        if (campo === 'prefixo') {
            this.ordemPrefixoAsc = !this.ordemPrefixoAsc;
            return this.ordemPrefixoAsc;
        }
        if (campo === 'emissao') {
            this.ordemEmissaoAsc = !this.ordemEmissaoAsc;
            return this.ordemEmissaoAsc;
        }
        this.ordemStatusAsc = !this.ordemStatusAsc;
        return this.ordemStatusAsc;
    }

    private normalizarDataOrdenacao(value: string): string {
        return value.includes('/') ? value.split('/').reverse().join('') : value;
    }

    private buscarLimiteDescontoVendedorAtual(): void {
        const usarClienteSelecionado = this.demonstrativoTipoBusca === 'CLIENTE' && !!this.demonstrativoCodparc;
        const payload = usarClienteSelecionado
            ? {
                CODPARC: this.demonstrativoCodparc,
                DTINICIAL: this.demonstrativoDataInicial,
                DTFINAL: this.demonstrativoDataFinal
            }
            : {};

        this.sankhyaGateway.chamarServiceGpl(
            usarClienteSelecionado ? 'ParceiroGlobalSP.doBuscarDados' : 'ParceiroGlobalSP.doBuscarLimiteDescontoVendedor',
            payload
        ).subscribe({
            next: (value) => {
                const body = this.unwrapResponse<any>(value as any);
                if (body?.sucesso) {
                    this.demonstrativoLimiteDescontoVendedor = this.formatarMoeda(
                        this.toNumber(String(body.limiteDesconto || body.usuario?.limiteDesconto || '0'))
                    );
                }
            },
            error: () => undefined
        });
    }

    private salvarAjustes(itens: Array<Record<string, unknown>>, callbackSucesso: () => void): void {
        this.demonstrativoLoading.set(true);

        if (this.demonstrativoAjuste.tipo === 'DES') {
            this.sankhyaGateway.chamarServiceGpl('CabecalhoDaNotaGlobalSP.doValidarLimiteDesconto', {
                ajusteTipo: this.demonstrativoAjuste.tipo,
                limiteUsuario: this.demonstrativoLimiteDescontoVendedor || 0,
                itens
            }).subscribe({
                next: (value) => {
                    const body = this.unwrapResponse<any>(value as any);
                    if (!body?.sucesso) {
                        this.demonstrativoLoading.set(false);
                        this.abrirModalAlerta(body?.mensagem || body?.erro || 'Erro ao validar limite de desconto.', 'OK');
                        return;
                    }

                    if (body.excedeLimite) {
                        this.demonstrativoLoading.set(false);
                        this.abrirModalLiberacaoLimite(body, itens, callbackSucesso);
                        return;
                    }

                    this.executarSalvarAjustes(itens, callbackSucesso);
                },
                error: (error) => {
                    this.demonstrativoLoading.set(false);
                    this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao validar limite de desconto.'), 'OK');
                }
            });
            return;
        }

        this.executarSalvarAjustes(itens, callbackSucesso);
    }

    private executarSalvarAjustes(itens: Array<Record<string, unknown>>, callbackSucesso: () => void): void {
        this.demonstrativoLoading.set(true);
        this.sankhyaGateway.salvarAjustesNativosDemonstrativo({
            ajusteTipo: this.demonstrativoAjuste.tipo,
            itens
        }).subscribe({
            next: (value) => {
                const body = this.unwrapResponse<any>(value as any);
                if (body?.sucesso) {
                    this.abrirModalAlerta('Ajuste salvo com sucesso!', 'OK');
                    callbackSucesso();
                    this.buscarDadosDemonstrativo();
                    return;
                }
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(body?.mensagem || body?.erro || 'Erro ao salvar ajuste.', 'OK');
            },
            error: (error) => {
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao salvar ajuste.'), 'OK');
            }
        });
    }

    abrirModalLiberacaoLimite(validacao: Record<string, any>, itens: Array<Record<string, unknown>>, callbackSucesso: () => void): void {
        this.demonstrativoModalConfirmacao = false;
        this.demonstrativoModalAjusteNotas = false;
        this.demonstrativoModalAjusteNotaIndividual = false;
        this.demonstrativoLiberacaoLimite = validacao || {};
        this.demonstrativoItensPendentesLiberacao = itens || [];
        this.demonstrativoCallbackLiberacaoSucesso = callbackSucesso;
        this.demonstrativoModalLiberacaoLimite = true;
    }

    cancelarLiberacaoLimite(): void {
        this.demonstrativoModalLiberacaoLimite = false;
        this.demonstrativoLiberacaoLimite = {};
        this.demonstrativoItensPendentesLiberacao = [];
        this.demonstrativoCallbackLiberacaoSucesso = null;
    }

    salvarSolicitacaoLiberacaoLimite(): void {
        this.demonstrativoLoading.set(true);
        this.sankhyaGateway.chamarServiceGpl('CabecalhoDaNotaGlobalSP.doSolicitarLiberacaoDesconto', {
            ajusteTipo: this.demonstrativoAjuste.tipo,
            limiteUsuario: this.demonstrativoLimiteDescontoVendedor || 0,
            itens: this.demonstrativoItensPendentesLiberacao || []
        }).subscribe({
            next: (value) => {
                const body = this.unwrapResponse<any>(value as any);
                if (body?.sucesso) {
                    const mensagem = body.mensagemSolicitacao || 'Solicitacao de liberacao registrada.';
                    this.cancelarLiberacaoLimite();
                    this.abrirModalAlerta(mensagem, 'OK');
                    this.demonstrativoLoading.set(false);
                    return;
                }

                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(body?.mensagem || body?.erro || 'Erro ao salvar solicitacao de liberacao.', 'OK');
            },
            error: (error) => {
                this.demonstrativoLoading.set(false);
                this.abrirModalAlerta(this.erroMensagem(error, 'Erro ao salvar solicitacao de liberacao.'), 'OK');
            }
        });
    }

    liberarLimiteDesconto(): void {
        this.abrirModalAlerta('Fluxo de liberacao sera implementado na proxima etapa.', 'OK');
    }

    private montarPayloadAjuste(item: Record<string, any>): Record<string, unknown> {
        const ajustePorItem = !!item['sequencia'];
        return {
            codigo: item['codigo'],
            sequencia: item['sequencia'],
            codProd: item['codProd'],
            codVol: item['codVol'],
            qtd: item['qtd'],
            vlrUnit: this.toNumber(String(item['vlrUnit'] || '')),
            origem: item['_ajusteOrigem'] || 'PERCENTUAL',
            percentual: this.toNumber(String(item['percentual'] || '')),
            valor: ajustePorItem ? this.toNumber(String(item['valor'] || '')) : 0,
            novoValor: ajustePorItem ? this.toNumber(String(item['novoValor'] || '')) : 0
        };
    }

    private itemNotaPossuiAjuste(
        item: Record<string, any>
    ): boolean {

        return item['_alterado'] ===
            true;
    }

    private existeAlteracaoAjusteNotaIndividual(): boolean {

        return this.demonstrativoItensNotaAjuste
            .some(
                (
                    item
                ) =>
                    item['_alterado'] ===
                    true
            );
    }

    private atualizarNotaAjustePelosItens(): void {
        if (
            !this.demonstrativoNotaAjuste ||
            !this.demonstrativoItensNotaAjuste.length
        ) {
            return;
        }

        /*
         * Total bruto de todos os itens.
         */
        const totalOriginal =
            this.demonstrativoItensNotaAjuste.reduce(
                (
                    total,
                    item
                ) =>
                    total +
                    this.toNumber(
                        String(
                            item['vlrTotal'] || '0'
                        )
                    ),
                0
            );

        /*
         * Soma do desconto/acréscimo dos itens.
         *
         * Nunca usamos desconto de cabeçalho.
         */
        const valorAjuste =
            this.demonstrativoItensNotaAjuste.reduce(
                (
                    total,
                    item
                ) =>
                    total +
                    this.toNumber(
                        String(
                            item['valor'] || '0'
                        )
                    ),
                0
            );

        /*
         * Total líquido final dos itens.
         */
        const totalNovo =
            this.demonstrativoItensNotaAjuste.reduce(
                (
                    total,
                    item
                ) =>
                    total +
                    this.toNumber(
                        String(
                            item['novoValor'] || '0'
                        )
                    ),
                0
            );

        /*
         * Percentual consolidado:
         *
         * soma dos descontos dos itens
         * ----------------------------
         * soma do bruto dos itens
         */
        const percentual =
            totalOriginal > 0
                ? (
                valorAjuste /
                totalOriginal
            ) * 100
                : 0;

        this.demonstrativoNotaAjuste['faturado'] =
            this.formatarMoeda(
                totalOriginal
            );

        this.demonstrativoNotaAjuste['valor'] =
            this.formatarMoeda(
                valorAjuste
            );

        this.demonstrativoNotaAjuste['percentual'] =
            this.formatarMoeda(
                percentual
            );

        this.demonstrativoNotaAjuste['novoValor'] =
            this.formatarMoeda(
                totalNovo
            );

        this.atualizarTotalFaturadoNota(
            this.demonstrativoNotaAjuste,
            totalNovo
        );

        this.demonstrativoNotaAjuste['_valorOriginal'] =
            totalOriginal;

        this.demonstrativoNotaAjuste['_valorAnterior'] =
            this.formatarMoeda(
                valorAjuste
            );

        this.demonstrativoNotaAjuste['_percentualAnterior'] =
            this.formatarMoeda(
                percentual
            );

        this.demonstrativoNotaAjuste['_novoValorAnterior'] =
            this.formatarMoeda(
                totalNovo
            );
    }

    private recalcularTotaisAjuste(): void {
        const totalNovo = this.demonstrativoItensAjuste.reduce((total, item) => total + this.toNumber(String(item['novoValor'] || '')), 0);
        const totalIpi = this.demonstrativoItensAjuste.reduce((total, item) => total + this.toNumber(String(item['ipi'] || '')), 0);
        const totalSt = this.demonstrativoItensAjuste.reduce((total, item) => total + this.toNumber(String(item['st'] || '')), 0);
        const totalNota = this.demonstrativoItensAjuste.reduce((total, item) => total + this.toNumber(String(item['totalFaturado'] || '')), 0);
        this.demonstrativoAjusteTotalNovoValor = this.formatarMoeda(totalNovo);
        this.demonstrativoAjusteTotalIpi = this.formatarMoeda(totalIpi);
        this.demonstrativoAjusteTotalSt = this.formatarMoeda(totalSt);
        this.demonstrativoAjusteTotalNota = this.formatarMoeda(totalNota);
        this.demonstrativoAjusteTotalFaturadoDesejado = this.demonstrativoAjusteTotalNota;
    }

    private valorMoedaAjuste(valorReal: number, cotacao: number): number {
        if (this.demonstrativoTipoMoeda !== 'DOLAR') {
            return valorReal;
        }
        return cotacao > 0 ? valorReal / cotacao : 0;
    }

    private atualizarTotalFaturadoNota(nota: Record<string, any>, totalItensRecalculado: number): void {
        const cotacao = Number(nota['_cotacao'] || 0);
        const totalNotaAtual = this.valorMoedaAjuste(
            Number(nota['_valorNotaReal'] || 0),
            cotacao
        );
        const totalItensInicial = Number(nota['_totalItensInicial'] ?? totalItensRecalculado);
        const novoTotalNota = totalNotaAtual + (totalItensRecalculado - totalItensInicial);

        nota['totalFaturado'] = this.formatarMoeda(novoTotalNota);
        nota['totalFaturadoDesejado'] = nota['totalFaturado'];
    }

    private recalcularCamposGeraisAjuste(): void {
        const totalOriginal = this.totalOriginalAjuste(this.demonstrativoItensAjuste);
        const totalNovo = this.demonstrativoItensAjuste.reduce((total, item) => {
            return total + this.toNumber(String(item['novoValor'] || ''));
        }, 0);
        const valorAjuste = this.demonstrativoAjuste.tipo === 'DES'
            ? Math.max(totalOriginal - totalNovo, 0)
            : Math.max(totalNovo - totalOriginal, 0);
        this.demonstrativoAjuste.valor = this.formatarMoeda(valorAjuste);
        this.demonstrativoAjuste.percentual = totalOriginal > 0
            ? this.formatarMoeda((valorAjuste / totalOriginal) * 100)
            : '0,00';
    }

    private recalcularTotaisAjusteNotaIndividual(): void {
        const cotacao = Number(this.demonstrativoNotaAjuste?.['_cotacao'] || 0);
        const totalNotaAtual = this.valorMoedaAjuste(
            Number(this.demonstrativoNotaAjuste?.['_valorNotaReal'] || 0),
            cotacao
        );
        const totalItensInicial = this.demonstrativoItensNotaAjuste.reduce(
            (total, item) => total + this.toNumber(String(item['_novoValorInicial'] || item['vlrTotal'] || '')),
            0
        );
        const totalItensNovo = this.demonstrativoItensNotaAjuste.reduce(
            (total, item) => total + this.toNumber(String(item['novoValor'] || '')),
            0
        );
        const totalNotaNovo = totalNotaAtual + (totalItensNovo - totalItensInicial);

        this.demonstrativoTotalNotaOriginal = this.formatarMoeda(totalNotaAtual);
        this.demonstrativoTotalNotaNovoValor = this.formatarMoeda(totalNotaNovo);
    }

    private aplicarAjustePorTotal(itens: Array<Record<string, any>>, totalNovoInformado: number): void {
        if (!itens.length) {
            return;
        }

        const totalOriginal = this.totalOriginalAjuste(itens);
        const totalNovo = this.round2(totalNovoInformado);

        if (totalOriginal <= 0) {
            this.demonstrativoAjuste.valor = '0,00';
            this.demonstrativoAjuste.percentual = '0,00';
            return;
        }

        if (this.demonstrativoAjuste.tipo === 'DES' && (totalNovo < 0 || totalNovo > totalOriginal)) {
            this.abrirModalAlerta('Valor final invalido para desconto.', 'OK');
            return;
        }

        if (this.demonstrativoAjuste.tipo === 'ACR' && totalNovo < totalOriginal) {
            this.abrirModalAlerta('Valor final invalido para acrescimo.', 'OK');
            return;
        }

        const valorTotalAjuste = this.demonstrativoAjuste.tipo === 'DES'
            ? this.round2(totalOriginal - totalNovo)
            : this.round2(totalNovo - totalOriginal);
        const valoresDistribuidos = this.distribuirValorIgual(valorTotalAjuste, itens.length);

        itens.forEach((item, index) => {
            const original = this.valorOriginalItem(item);
            const valorAjuste = valoresDistribuidos[index];
            const novoValor = this.demonstrativoAjuste.tipo === 'DES'
                ? this.round2(original - valorAjuste)
                : this.round2(original + valorAjuste);

            if (novoValor < 0) {
                this.abrirModalAlerta('O desconto dividido igualmente excede o valor de uma das vendas selecionadas.', 'OK');
                return;
            }

            item['valor'] = this.formatarMoeda(valorAjuste);
            item['percentual'] = original > 0 ? this.formatarMoeda((valorAjuste / original) * 100) : '0,00';
            item['novoValor'] = this.formatarMoeda(novoValor);
        });

        this.demonstrativoAjuste.valor = this.formatarMoeda(valorTotalAjuste);
        this.demonstrativoAjuste.percentual = this.formatarMoeda((valorTotalAjuste / totalOriginal) * 100);
        this.recalcularTotaisAjuste();
    }

    private distribuirValorIgual(valor: number, quantidade: number): number[] {
        const totalCentavos = Math.round(this.round2(valor) * 100);
        const base = Math.floor(totalCentavos / quantidade);
        let resto = totalCentavos - (base * quantidade);
        return Array.from({length: quantidade}, () => {
            const centavos = base + (resto > 0 ? 1 : 0);
            resto -= resto > 0 ? 1 : 0;
            return this.round2(centavos / 100);
        });
    }

    private totalOriginalAjuste(itens: Array<Record<string, any>>): number {
        return itens.reduce((total, item) => total + this.valorOriginalItem(item), 0);
    }

    private aplicarNovoValorCalculadoItem(item: Record<string, any>, novoValorInformado: number): void {
        const original = this.valorOriginalItem(item);
        const novoValor = this.round2(novoValorInformado);

        if (this.demonstrativoAjuste.tipo === 'DES' && (novoValor < 0 || novoValor > original)) {
            this.abrirModalAlerta('Valor final invalido para desconto.', 'OK');
            item['novoValor'] = this.formatarMoeda(original);
            item['valor'] = '0,00';
            item['percentual'] = '0,00';
            return;
        }

        if (this.demonstrativoAjuste.tipo === 'ACR' && novoValor < original) {
            this.abrirModalAlerta('Valor final invalido para acrescimo.', 'OK');
            item['novoValor'] = this.formatarMoeda(original);
            item['valor'] = '0,00';
            item['percentual'] = '0,00';
            return;
        }

        const valorAjuste = this.demonstrativoAjuste.tipo === 'DES'
            ? this.round2(original - novoValor)
            : this.round2(novoValor - original);

        item['valor'] = this.formatarMoeda(valorAjuste);
        item['percentual'] = original > 0 ? this.formatarMoeda((valorAjuste / original) * 100) : '0,00';
        item['novoValor'] = this.formatarMoeda(novoValor);
    }

    private aplicarPercentualNoItem(item: Record<string, any>, percentual: number): void {
        const original = this.valorOriginalItem(item);
        const valor = original * (percentual / 100);
        const novoValor = this.demonstrativoAjuste.tipo === 'DES' ? original - valor : original + valor;
        this.aplicarNovoValorCalculadoItem(item, novoValor);
    }

    private valorOriginalItem(item: Record<string, any>): number {
        return Number(item['_valorOriginal'] || this.toNumber(String(item['faturado'] || item['vlrTotal'] || '0')));
    }

    alterarValorPix(): void {

        const valorPix = this.toNumber(this.demonstrativoValorPixQrCode);
        const valorTotal = this.toNumber(this.demonstrativoTotalFaturado());

        if (valorPix > valorTotal) {

            this.abrirModalAlerta(
                `O valor do QR-Code Pix (${valorPix.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}) não pode ser maior que o valor faturado (${valorTotal.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}).`,
                'OK');

            this.demonstrativoValorPixQrCode =
                valorTotal.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

            return;
        }

        if (valorPix <= 0) {
            this.abrirModalAlerta('Informe um valor maior que zero para gerar o QR-Code Pix.', 'OK');
            return;
        }

        this.atualizarQrCodePix(valorPix, true);
    }

    private atualizarQrCodePix(valorPix: number, exibirErro: boolean): void {
        if (valorPix <= 0) {
            this.demonstrativoContas = [];
            return;
        }

        const requestSeq = ++this.qrCodePixRequestSeq;
        this.sankhyaGateway.gerarQrCodeImpressao({
            valor: valorPix.toFixed(2)
        }).subscribe({
            next: (value) => {
                if (requestSeq !== this.qrCodePixRequestSeq) {
                    return;
                }

                const body = this.unwrapResponse<any>(value as any);
                if (body?.sucesso && Array.isArray(body.contas)) {
                    this.demonstrativoContas = body.contas;
                    this.demonstrativoValorPixQrCode = this.formatarMoeda(valorPix);
                    return;
                }

                if (exibirErro) {
                    this.abrirModalAlerta('Nao foi possivel gerar o QR-Code Pix com o valor informado.', 'OK');
                }
            },
            error: () => {
                if (requestSeq === this.qrCodePixRequestSeq && exibirErro) {
                    this.abrirModalAlerta('Erro ao gerar QR-Code Pix.', 'OK');
                }
            }
        });
    }

    private round2(valor: number): number {
        return Math.round((Number(valor) || 0) * 100) / 100;
    }

    private isNotaFinalizada(item: Record<string, unknown>): boolean {
        return this.getCell(item, 'status').toUpperCase() === 'AUTORIZADO';
    }

    private formatarMoeda(valor: number): string {
        return (Number(valor) || 0).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    private montarMensagemFalhas(response: any, fallback: string): string {
        if (!response) {
            return fallback;
        }

        if (!response.resultado || !response.resultado.length) {
            return response.mensagem || response.erro || fallback;
        }

        const falhas = response.resultado.filter((item: any) => !item.sucesso);
        if (!falhas.length) {
            return response.mensagem || response.erro || fallback;
        }

        return falhas
            .map((item: any) => `Nota ${item.nunota}: ${item.erro || 'falha na operacao'}`)
            .join('\n');
    }

    private respostaPossuiFalhas(response: any): boolean {
        return Array.isArray(response?.resultado) &&
            response.resultado.some((item: any) => item?.sucesso === false);
    }

    private toInputDate(date: Date): string {
        return date.toISOString().slice(0, 10);
    }

    private formatarDataInputCurta(value: string): string {
        if (!value) {
            return '--/--/--';
        }
        const [ano, mes, dia] = value.split('-');
        if (!ano || !mes || !dia) {
            return value;
        }
        return `${dia}/${mes}/${ano.slice(-2)}`;
    }

    private toNumber(value: string): number {
        if (!value) {
            return 0;
        }

        const texto = String(value).trim();
        if (!texto) {
            return 0;
        }

        const normalizado = texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto;

        return parseFloat(normalizado.replace(/[^\d.-]/g, '')) || 0;
    }

    private formatarDocumento(value: string, tipoDocumento: string): string {
        const numeros = value.replace(/\D/g, '');

        if (tipoDocumento.toUpperCase() === 'F') {
            return numeros
                .slice(0, 11)
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d)/, '$1.$2')
                .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        }

        return numeros
            .slice(0, 14)
            .replace(/(\d{2})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1/$2')
            .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }

    private extrairTiposNegociacaoNativos(
        value: any
    ): Array<Record<string, any>> {
        const body =
            value?.responseBody ||
            value;

        const jsonBruto =
            body?.json?.['$'] ??
            body?.json?.$ ??
            '';

        if (!jsonBruto) {
            return [];
        }

        try {
            const resultado =
                JSON.parse(
                    String(jsonBruto)
                );

            const dados =
                Array.isArray(resultado?.data)
                    ? resultado.data
                    : [];

            return dados
                .filter(
                    (item: Record<string, any>) =>
                        Number(
                            item['CODTIPVENDA'] || 0
                        ) > 0 &&
                        String(
                            item['DESCRTIPVENDA'] || ''
                        ).trim() !== ''
                );

        } catch (error) {
            console.error(
                'Erro ao interpretar retorno nativo de TipoNegociacao:',
                error
            );

            return [];
        }
    }

    usuarioLogado(): string {
        const tipo = localStorage.getItem('authStorageType');

        const name =
            tipo === 'session'
                ? sessionStorage.getItem('userName') || ''
                : localStorage.getItem('userName') ||
                sessionStorage.getItem('userName') ||
                '';

        if (!name) {
            return '-';
        }

        return name.split(' ')[0];
    }
}
